(function(){
    'use strict';

    /**
     * Provides the base Widget class Widgets
     *
     * @module App.Insights.Dashboard.widgets
     */
    angular.module('app.insights.dashboard.widgets', ['chart.js', 'datatables', 'app.insights.dashboard.widgets.chartsettings', 'app.insights.dashboard.widgets.magentoModule', 'app.insights.dashboard.widgets.settings', 'app.insights.dashboard.widgets.salesSummary', 'app.insights.dashboard.widgets']);
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('websiteResponsetime', websiteResponsetime);

    function websiteResponsetime(widget_module_URI, chartSettings) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.templateUrl = widget_module_URI + 'website/responsetime/website_responsetime_line_chart.html';
        tmpl.transclude = true,
            tmpl.link = function (scope) {
                scope.$watch("data", function (newVal, oldVal) {

                    if (!newVal.length) {
                        return;
                    }

                    scope.mobileData = [];
                    scope.values = [
                        []
                    ];
                    scope.labels = [];
                    scope.noData = false;
                    scope.series = ["ms"];
                    scope.chartOptions = {
                        scales: chartSettings.scales({ show: true, label: 'Millisecond' }, { show: true, label: 'Date' }),
                        tooltips: chartSettings.tooltips({
                            unit: "single",
                            unitText: "ms"
                        })
                    }

                    if (scope.data.length > 3) {
                        Papa.parse(scope.data, {
                            delimter: ",",
                            skipEmptyLines: true,
                            header: true,
                            worker: true,
                            complete: function (items) {
                                var values = [[]];
                                var labels = [];
                                var mobileData = [];

                                items.data.forEach(function (value, index) {
                                    var date = moment(value[""]).format("DD-MM-YYYY");
                                    var value = fixedValue(value["response_time"]);

                                    var obj = {};
                                    obj.label = date;
                                    obj.value = value;

                                    labels.push(date);
                                    values[0].push(value);
                                    mobileData.push(obj);
                                });

                                scope.values = values;
                                scope.labels = labels;
                                scope.mobileData = mobileData;

                                scope.$emit("parsing_done");
                                scope.$apply();
                            }
                        });
                    } else {
                        scope.noData = true;
                        scope.$emit("parsing_done");
                    }
                });
            }
        return tmpl;
    }

    /**
     * Get value with 2 decimal
     * 
     * @param {String} value
     * @return {String}
     */
    function fixedValue(value) {
        var tmp = value.split(".");

        if(tmp.length > 1) {
            return tmp[0];
        }

        return value;
    }
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('websiteEnvInfo', websiteEnvInfo);

    function websiteEnvInfo(widget_module_URI, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.transclude = true;
        tmpl.templateUrl = widget_module_URI + 'website/environment_info/website_environment_info_table.html';
        tmpl.link = function(scope) {
            scope.$watch('data', function (newVal, oldVal) {
                if(newVal.length === 0) {
                    return;
                }

                scope.$emit("parsing_done");
            });
        },
        tmpl.controller = ['$scope', function($scope, websiteFactory, magentoService) {
            $scope.dtoptions = {
                dom: '',
                language: {
                    url: dataTableLoc
                }
            }
        }];
        return tmpl;
    }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoSales', magentoSales);

    /**
    * Magento Sales Summary Directive
    *
    * @class magentoSales
    * @constructor
    */
    function magentoSales(widget_module_URI, chartSettings) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.transclude = true;
        tmpl.templateUrl = widget_module_URI + 'magento/sales/magento_sales_chart.html';
        tmpl.link = function (scope) {
            scope.$watch('data', function (newVal, oldVal) {

                if (!newVal.length) {
                    return;
                }

                scope.values = [[]];
                scope.labels = [];
                scope.noData = false;
                scope.mobileData = [];
                scope.series = ["Sold"];
                scope.chartOptions = {
                    scales: chartSettings.scales({ show: true, label: "Euro" }, { show: true, label: 'Datum' }),
                    tooltips: chartSettings.tooltips({
                        mode: "single",
                        unit: "sales"
                    })
                }

                if (scope.data.length > 3) {
                    Papa.parse(scope.data, {
                        delimiter: ",",
                        skipEmptyLines: true,
                        header: true,
                        worker: true,
                        complete: function (items) {
                            var values = [[]];
                            var labels = [];
                            var mobileData = [];

                            items.data.forEach(function (value, index) {
                                var date = moment(value[""]).format("DD-MM-YYYY");
                                var value = fixedValue(value["revenue"]);

                                var obj = {};
                                obj.label = date;
                                obj.value = value;

                                labels.push(date);
                                values[0].push(value);
                                mobileData.push(obj);
                            });

                            scope.values = values;
                            scope.labels = labels;
                            scope.mobileData = mobileData;

                            scope.$emit("parsing_done");
                            scope.$apply();
                        }
                    });
                } else {
                    scope.noData = true;
                    scope.$emit("parsing_done");
                }
            });
        };
        return tmpl;
    }

    /**
     * Get value with 2 decimal
     * 
     * @param {String} value
     * @return {String}
     */
    function fixedValue(value) {
        var tmp = value.split(".");

        if (tmp.length > 1) {
            value = tmp[0] + "." + tmp[1].slice(0, 2);
        } else {
            return tmp[0];
        }
        return value;
    }
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoOrders', magentoOrders);

    function magentoOrders(widget_module_URI, chartSettings) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.templateUrl = widget_module_URI + 'magento/orders/magento_orders_chart.html';
        tmpl.transclude = true;
        tmpl.link = function (scope) {
            scope.$watch('data', function (newVal, oldVal) {

                if (!newVal.length) {
                    return;
                }

                scope.values = [[], [], []];
                scope.labels = [];
                scope.series = ["Complete", "Pending", "Proccessing"];
                scope.mobileData = [];
                scope.noData = false;
                scope.chartColors = ["#46BFBD", "#FDB45C", "#949FB1"];
                scope.chartOptions = {
                    legend: chartSettings.legends(),
                    scales: chartSettings.scales({ show: true, label: 'Bestellingen' }, { show: true, label: 'Datum' }),
                    tooltips: chartSettings.tooltips({
                        tooltipMode: "label",
                        unit: "groupOrders",
                        unitText: "Orders"
                    })
                }

                if (newVal.length > 3) {
                    Papa.parse(scope.data, {
                        delimiter: ",",
                        skipEmptyLines: true,
                        worker: true,
                        header: true,
                        complete: function (items) {
                            var tmpArray = [[], [], []];
                            var labels = [];
                            var tmpMobile = [];

                            items.data.forEach(function (value, index, object) {
                                var dateTime = moment(value[""]).format("DD-MM-YYYY");
                                var mobileData = {};
                                var arr = [value['value_complete'], value['value_pending'], value['value_processing']];
                                mobileData.series = [];
                                mobileData.values = [];
                                mobileData.series.push("Complete", "Pending", "Proccessing");
                                mobileData.date = dateTime;

                                for (var i = 0; i < 3; i++) {
                                    tmpArray[i].push(arr[i]);
                                    mobileData.values.push(arr[i]);
                                }

                                labels.push(dateTime);
                                tmpMobile.push(mobileData);
                            });

                            scope.values = tmpArray;
                            scope.labels = labels;
                            scope.mobileData = tmpMobile;

                            scope.$emit("parsing_done");
                            scope.$apply();
                        }
                    });
                } else {
                    scope.noData = true;
                    scope.$emit("parsing_done");
                }
            });
        };
        return tmpl;
    }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoModuleVersions', magentoModuleVersion);

    function magentoModuleVersion(widget_module_URI, magentoModule, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.templateUrl = widget_module_URI + 'magento/module_versions/magento_module_versions_table.html';
        tmpl.transclude = true;
        tmpl.link = function(scope) {
            scope.$watch('data', function (newVal, oldVal) {
                if(!newVal.length) {
                    return;
                }

                scope.magentoModule = magentoModule;
                var lenModule = magentoModule.amountModules();

                if(lenModule.modules === 0) {
                    magentoModule.setData(newVal);
                    scope.data = newVal;

                    scope.$emit("parsing_done");
                } else {
                    scope.data = magentoModule.getData();
                    scope.$emit("parsing_done");
                }
            });

        }
        tmpl.controller = ['$scope', function($scope) {
            $scope.dtoptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                responsive  : true,
                language: {
                    url: dataTableLoc
                }
            };

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }
        }];
        return tmpl;
    }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoModuleOutdated', magentoModuleOutdated);

    function magentoModuleOutdated(widget_module_URI, magentoModule, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.transclude = true;
        tmpl.templateUrl = widget_module_URI + 'magento/module_outdated/magento_module_outdated_table.html';
        tmpl.link = function(scope) {
            scope.$watch('data', function (newVal, oldVal) {
                if(!newVal.length) {
                    return;
                }

                scope.magentoModule = magentoModule;
                scope.lenModule = magentoModule.amountModules();
                scope.outDated = magentoModule.getOutdatedModule();

                if(scope.lenModule.modules === 0) {
                    magentoModule.setData(newVal);

                    scope.$emit("parsing_done");
                } else {
                    scope.$emit("parsing_done");
                }
            });
        }
        tmpl.controller = ['$scope', function($scope) {
            $scope.dtoptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                responsive  : true,
                language: {
                    url: dataTableLoc
                }
            };

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }
        }];
        return tmpl;
    }
})();

(function () {
  'use strict';

  angular.module('app.insights.dashboard.widgets')
    .directive('magentoModuleManual', magentoModuleManual)
    .controller('moduleManualController', moduleManualController);

  function magentoModuleManual(widget_module_URI, magentoModule, dataTableLoc) {
    var tmpl = {};
    tmpl.scope = {
      data: '='
    };
    tmpl.transclude = true;
    tmpl.templateUrl = widget_module_URI + 'magento/module_manual/magento_module_manual_table.html';
    tmpl.link = function (scope) {
      scope.$watch('data', function (newVal, oldVal) {
        if (!newVal.length) {
          return;
        }

        scope.list = magentoModule.getModuleList();
        scope.$emit("parsing_done");
      });

      scope.$watch(function () {
        return magentoModule.magentoEdition
      }, function (edtion) {
        scope.magentoE = "Magento " + edtion;
      });
    }
    tmpl.controller = ['$scope', '$mdDialog', function ($scope, $mdDialog) {
      $scope.dtoptions = {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        lengthMenu: [5, 10, 20, 30, 50, 100],
        pageLength: 5,
        responsive: true,
        language: {
            url: dataTableLoc
        }
      };

      $scope.OpenDialog = function (data, category) {
        $mdDialog.show({
          controller: "moduleManualController as vm",
          templateUrl: widget_module_URI + 'magento/module_manual/modal/view_modules.html',
          parent: angular.element(document.body),
          fullscreen: true,
          locals: {
            item: data,
            category: category
          }
        });
      }
    }];
    return tmpl;
  }

  function moduleManualController(item, category, $mdDialog, magentoService) {
    var vm = this;

    vm.data = item;
    vm.name = category;
    vm.body = "";
    vm.documentationUrlIsset = function (url) {
      if (url === '') {
        return false;
      }

      return true;
    }

    function init() {
      vm.data.forEach(function (val, index) {
        var item = vm.data[index];
        item.loading = true;
        item.html = '';
        item.link = '';

        if (vm.documentationUrlIsset(val["documentation_url"])) {
          magentoService.getConfluencePage(val["documentation_url"])
            .then(function (data) {
              item.loading = false;
              item.html = data.body.view.value;
              item.link = data["_links"]["tinyui"];
            });
        } else {
          item.loading = false;
        }
      });

    }

    init();

    vm.closeDialoog = function () {
      $mdDialog.hide();
    }

    vm.renderHtml = function (html_code) {
      return linkifyHtml(html_code, {
        target: {
          url: "_blank"
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoModuleCount', magentoModuleCount);

    function magentoModuleCount(widget_module_URI, magentoModule) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.transclude = true;
        tmpl.templateUrl = widget_module_URI + 'magento/module_count/magento_module_count_text.html';
        tmpl.link = function(scope) {
            scope.$watch('data', function (newVal, oldVal) {
                if(!newVal.length) {
                    return;
                }

                scope.magentoModule = magentoModule;
                scope.lenModule = magentoModule.amountModules();

                if(scope.lenModule.modules === 0) {
                    magentoModule.setData(newVal);
                    scope.data = newVal;

                    
                    scope.$emit("parsing_done");
                } else {
                    scope.$emit("parsing_done");
                }                
            });  
        }
        return tmpl;
    }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('magentoVersions', magentoVersions);

    function magentoVersions(widget_module_URI, magentoModule) {
        var tmpl = {};
        tmpl.scope = {
            data: '='
        };
        tmpl.link = function($scope) {
            $scope.$watch('data', function(newVal, oldVal) {
                if(!newVal.length) {
                    return;
                }

                $scope.current = newVal[0]['current'];
                $scope.latest = newVal[0]['latest'];

                function outdated() {
                    var current = parseInt(newVal[0]['current'].replace(/([.])+/g, ''));
                    var latest = parseInt(newVal[0]['latest'].replace(/([.])+/g, ''));

                    if(latest > current) {
                        $scope.outdated = true;
                    } else {
                        $scope.outdated = false;
                    }
                }
                outdated();

                $scope.pack = "";

                if(newVal[0]["edition"] === 1) {
                    $scope.pack = "Community";
                } else if(newVal[0]["edition"] === 2) {
                    $scope.pack = "Enterprise";
                } else if(newVal[0]["edition"] === 3) {
                    $scope.pack = "Professional";
                }

                magentoModule.magentoEdition = $scope.pack;
                
                $scope.$emit("parsing_done");
            });
        }
        tmpl.transclude = true;
        tmpl.templateUrl = widget_module_URI + 'magento/magento_versions/magento_magento_versions_text.html';
        return tmpl;
    }
})();

(function(){
    "use strict";

    angular.module('app.insights.dashboard.widgets')
        .directive("magentoCacheFlush", magentoCacheFlush);

    function magentoCacheFlush(widget_module_URI) {
        var directive = {
            restrict: 'EA',
            controllerAs: 'vm',
            controller: magentoCacheFlushController,
            bindToController: true,
            templateUrl: widget_module_URI + 'magento/magento_cacheflush/magento_cacheflush.html',
        }

        magentoCacheFlushController.$inject = ['$scope', 'websitesFactory', 'magentoService', '$mdDialog', 'widgetService'];

        function magentoCacheFlushController($scope, websitesFactory, magentoService, $mdDialog, widgetService) {
            var vm = this;
            var websiteId = 0;
            vm.adminUrl = '';
            vm.url = '';
            $scope.$watch(function () {
                return websitesFactory.selected;
            }, function (website) {
               if(website) {
                   vm.url = website.url;
                   websiteId = website.id;
                   getAdminUrl();
               }
            });

            function getAdminUrl() {
                var options = {
                    website: websiteId,
                    store: 1,
                    range_start: "2017-10-25T00:00:00"
                }

                options.options = {};
                options.options.interval = 300;

                widgetService.getWidgetData("magento_magento_infos", options)
                    .then(function (res) {
                       var obj = res.items[0];
                       vm.adminUrl = obj.admin_frontname;
                       vm.url += "/" + vm.adminUrl;
                    });
            }

            vm.flushCache = function () {
                magentoService.cacheFlush(websiteId)
                    .then(function () {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#content')))
                                .clickOutsideToClose(true)
                                .title('Magento Cache Flush')
                                .textContent('De cache is geflusht')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Oke!')
                        );
                    });
            }
        }

        return directive;
    }
})();

(function(){
    'use strict';

    /**
     * Module of all settings options
     * @module App.Insights.dashboard.widgets.settings
     */
    angular.module('app.insights.dashboard.widgets.settings', ['app.insights.dashboard.widgets.settings.daterangeSettings', 'app.insights.dashboard.widgets.settings.storeSettings']);
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.settings')
        .directive('saveSettings', saveSettings)
    
    /**
     * 
     * @class saveSettings
     */
    function saveSettings(widget_API_URI) {
        var tmpl = {};
        tmpl.transclude = true;
        tmpl.templateUrl = widget_API_URI + 'settings/savesettings/savesettings.html';
        tmpl.link = function (scope) {

        };
        tmpl.controller = ['$scope', function ($scope) {
            var amountDirective = 0;
            var savedOptions = 0;
            var saveOptions = new Object();
            $scope.disableBtn = false;

            /**
             * @event disable_btn_option
             */
            $scope.$on("disable_btn_option", function (ev, value) {
                $scope.disableBtn = value;
            });

            /**
             * @event register_directive
             */
            $scope.$on("register_directive", function (ev, value) {
                amountDirective++;
            });

            /**
             * @event sendsettings
             */
            $scope.$on('sendsettings', function (ev, value) {
                var keys = Object.keys(value)

                for (var i = 0; i < keys.length; i++) {
                    Object.defineProperty(saveOptions, keys[i], {
                        configurable: true,
                        value: value[keys[i]]
                    });
                }

                savedOptions++;

                //Checks if all value of settings are send
                if (savedOptions === amountDirective) {
                    Object.defineProperty(saveOptions, 'id', {
                        configurable: true,
                        value: $scope.setup.id
                    });

                    updateSettings();
                }
            });



            $scope.saveSettings = function () {
                savedOptions = 0;
                $scope.$broadcast('savesettings');
            }

            function updateSettings() {
                var obj = {
                    id: $scope.setup.id,
                    tab: $scope.setup.tab,
                    website: $scope.setup.website,
                    data_code: $scope.setup.data_code,
                    options: saveOptions
                };

                $scope.$emit("update_settings", obj);
                $scope.$parent.flipWidget();
            }
        }];
        return tmpl;
    }
})();

(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.settings')
        .directive('settingsDefaultHeader', settingsDefaultHeader);

    function settingsDefaultHeader(widget_API_URI) {
        var tmpl = {};
        tmpl.scope = {
            name: '@'
        }
        tmpl.transclude = true;
        tmpl.templateUrl = widget_API_URI + 'settings/defaultheader/defaultheader.html';
        tmpl.controller = ['$scope', function ($scope) {

            $scope.flipWidget = function () {
                $scope.$parent.flipWidget();
            }
        }];
        return tmpl;
    }
})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets.settings.storeSettings', []);
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.settings.storeSettings')
        .directive('storeSettingsFilter', storeSettingsFilter)

    function storeSettingsFilter(widget_API_URI, websitesFactory) {
        var tmpl = {};
        tmpl.scope = {
            setup: '='
        };
        tmpl.link = function ($scope) {
            $scope.$watch('setup', function (newVal) {
                if (newVal) {
                    var stores = websitesFactory.getStores();
                    $scope.selected = newVal.options.store;
                    stores.filter(function (value) {
                        if (newVal.options.store === parseInt(value['store_id'])) {
                            $scope.$emit('storeview_selected', value);
                            return;
                        }
                    });

                }
            });
        };
        tmpl.templateUrl = widget_API_URI + 'storeSettingsFilter/storesettings.html';
        tmpl.controller = ['$scope', function ($scope) {
            $scope.stores = websitesFactory.getStores();

            $scope.$emit("register_directive");

            $scope.$watch('selected', function (newVal, oldVal) {
                if (newVal) {
                    $scope.stores.filter(function (value) {
                        if (newVal === value['store_id']) {
                            $scope.$emit('storeview_selected', value);
                            return;
                        }
                    });                    
                }
            });

            $scope.$on('savesettings', function (ev, value) {
                var storeId = Number($scope.selected);

                $scope.$emit("sendsettings", {
                    store: storeId
                });
            });
        }];
        return tmpl;
    }
})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets.salesSummary', [])
})();
(function(){
    'use strict';
    
    angular.module('app.insights.dashboard.widgets.salesSummary')
    .service('salesSummaryService', salesSummaryService)

    function salesSummaryService($q, $http, portal_path) {
        var salesSummaryService =  {};

        salesSummaryService.getSalesSummary = function(id) {
            var results = $q.defer();

            $http({
                method: "GET",
                url: portal_path + "websites/"+id+"/sales/summary"
            })
            .then(function(req){
                results.resolve(req.data.data[0]);
            });

            return results.promise;
        }

        return salesSummaryService;
    }
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.salesSummary')
        .directive('salesSummary', salesSummary)

    function salesSummary(widget_API_URI) {
        var sales = {};
        sales.templateUrl = widget_API_URI + 'salesSummary/salesSummary.html';
        sales.controller = ['$scope', 'salesSummaryService', 'websitesFactory', function ($scope, salesSummaryService, websitesFactory) {
            $scope.summary = {
                loaded: false,
                data: {}
            }

            $scope.$watch(function () {
                return websitesFactory.selected;
            }, function (newVal) {
                if (newVal) {
                    $scope.summary = {
                        loaded: false,
                        data: {}
                    }

                    getSummary(newVal.id);
                }
            });

            function getSummary(id) {
                salesSummaryService.getSalesSummary(id)
                    .then(function (data) {
                        $scope.summary.data = data;
                        mapData();
                    });
            }

            /**
             * To fix all float numbers;
             * @method mapData
             * @return {void}
             */
            function mapData() {
                $scope.summary.data["last_30_days"] = $scope.summary.data["last_30_days"].toFixed(2);
                $scope.summary.data["last_month"] = $scope.summary.data["last_month"].toFixed(2);
                $scope.summary.data["last_year"] = $scope.summary.data["last_year"].toFixed(2);
                $scope.summary.data["total_revenue"] = $scope.summary.data["total_revenue"].toFixed(2);
                
                $scope.summary.loaded = true;
            }
        }];
        return sales;
    }
})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets.magentoModule', []);
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.magentoModule')
        .factory('magentoModule', magentoModule);

    function magentoModule() {
        var module = {};
        var count = 0;
        var items = [];
        var itemsOutdated = [];
        var securityRisk = [];
        module.moduleList = {};
        module.magentoEdition = "Community";
        
        module.amountModules = function () {
            var modules = items.length;
            var modulesOutdated = itemsOutdated.length;
            var securityRiskModule = securityRisk.length;

            return {
                modules: modules,
                modulesOutdated: modulesOutdated,
                securityRisk: securityRiskModule
            }
        }

        module.getData = function () {
            return items;
        }

        module.getOutdatedModule = function () {
            return itemsOutdated;
        }

        module.getSecurityRisk = function () {
            return securityRisk;
        }

        module.setData = function (data) {
            items = data.map(function (value) {
                var installed = value.installed;
                var latest = value.latest;
                value.versionOutdated = false;

                if (checkVersion(installed, latest)) {
                    value.versionOutdated = true;

                    itemsOutdated.push(value);
                }

                if (value.security_risk) {
                    securityRisk.push(value);
                }

                module._setModuleList(value);

                return value
            });
            items = data;
        }

        /**
         * Set list of module items for the manuals
         */
        module._setModuleList = function (data) {
            var name = data.name.split("/");
            var categoryFound = false;

            if (name.length <= 1) {
                return;
            }

            Object.keys(this.moduleList).forEach(function (val, index) {
                data.label = name[1];

                if (name[0] === val) {
                    categoryFound = true;
                    module.moduleList[val].items.push(data);
                }
            });

            if (!categoryFound) {
                Object.defineProperty(this.moduleList, name[0], {
                    value: {
                        category: name[0], 
                        items: [data]
                    },
                    writable: true,
                    enumerable: true,
                    configurable: true
                })
            }
        }

        module.getModuleList = function() {
            return this.moduleList;
        }

        module.clearData = function () {
            items = [];
            itemsOutdated = [];
            securityRisk = [];
            count = 0;
            this.moduleList = {};
            this.magentoEdition = "Community";
        }

        return module;
    }

    function checkVersion(installed, latest) {
        var installedVersion = parseInt(installed.replace(/([.])+/g, ''));
        var latestVersion = parseInt(latest.replace(/([.])+/g, ''));

        if (latestVersion === 0) {
            return false;
        }

        if (latestVersion > installedVersion) {
            return true;
        }

    }
})();
(function(){
    'use strict';

    /**
     * Date range settings module
     * @module App.Insights.dashboard.widgets.setting.dataRangeSettings
     */
    angular.module('app.insights.dashboard.widgets.settings.daterangeSettings', []);
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.settings.daterangeSettings')
        .directive('widgetRangeSettings', widgetRangesettings);
    
    /**
     * Main class for the daterangeSettings module
     * @class widgetRangesettings
     * @constructor
     */
    function widgetRangesettings(widget_API_URI) {
        var tmpl = {};
        tmpl.scope = {
            setup: '=',
            name: '@'
        };
        tmpl.transclude = true;
        tmpl.link = function (scope, element, attrs) {
            /**
             * Set the default value of the options
             * @event setup
             */
            scope.$watch("setup", function (newVal, oldVal) {
                if (newVal) {
                    scope.dataRangeSelected = newVal.options.date_range;
                    scope.blockId = newVal.id;
                    scope.dashboardId = newVal.dashboard;
                    scope.websiteId = newVal.website;
                    scope.data_code = newVal.data_code;

                    if (newVal.options.date_range === "cu") {
                        scope.hideRange = false;

                        scope.minDate = new Date(moment(newVal.options.range_start).format("YYYY-MM-DD"));
                        scope.maxDate = new Date(moment(newVal.options.range_start).format("YYYY-MM-DD"));
                    }
                }
            });

            /**
             * Save settings of date range settings
             * @event savesettings
             */
            scope.$on('savesettings', function (ev, value) {
                var minDate = "";
                var maxDate = "";

                if (scope.dataRangeSelected === "cu") {
                    minDate = moment(scope.minDate).format("YYYY-MM-DD 00:00:ss");
                    maxDate = moment(scope.maxDate).format("YYYY-MM-DD 23:58:00");
                }

                /**
                 * Send settings to the settingsmodule
                 * @event sendsettings
                 */
                scope.$emit("sendsettings", {
                    range_start: minDate,
                    range_end: maxDate,
                    date_range: scope.dataRangeSelected,
                    interval: 300
                });
            });
        };
        tmpl.templateUrl = widget_API_URI + 'dateRangeSettings/widget-back-settings.html';
        tmpl.controller = ['$scope', '$timeout', function ($scope, $timeout) {
            $scope.todayIs = new Date();
            $scope.hideRange = true;
            $scope.disableSave = false;
            $scope.maxDateVal = false;
            $scope.maxDateNotEmpty = false;
            $scope.submitForm = false;

            $timeout(function () {
                $scope.$emit("register_directive");
            }, 0);

            $scope.updateRange = function (val) {
                if (val === "cu") {
                    $scope.hideRange = false;
                    $scope.disableSave = true;
                    $scope.$emit('disable_btn_option', true);
                    return;
                }

                $scope.$emit('disable_btn_option', false);
                $scope.disableSave = false;
                $scope.hideRange = true;
                return;
            }

            $scope.flipWidget = function () {
                $scope.$parent.flipWidget();
            }

            $scope.$watch("minDate", function (newVal, oldVal) {
                if (!newVal) {
                    return;
                }

                var todayTime = $scope.todayIs.getTime();
                var inputTime = newVal.getTime();
                var end = $scope.maxDate;

                $scope.maxDate = null;
                $timeout(function () {
                    $scope.maxDate = end;
                    canBySubmit();
                });

                if (inputTime <= todayTime) {
                    $scope.maxDateVal = true;
                    canBySubmit();
                    return;
                }

                canBySubmit();
                $scope.maxDateVal = false;
            });

            $scope.$watch("maxDate", function (newVal, oldVal) {
                if (!newVal) {
                    return;
                }
                canBySubmit();
            });

            function canBySubmit() {
                var minDate = $scope.minDate.getTime();
                var maxDate = ($scope.maxDate != null) ? $scope.maxDate.getTime() : 0;

                if ($scope.maxDate && $scope.maxDateVal && (minDate <= maxDate)) {
                    $scope.$emit('disable_btn_option', false);
                    $scope.submitForm = true;
                } else {
                    $scope.$emit('disable_btn_option', true);
                    $scope.submitForm = false;
                }
            }
        }];
        return tmpl;
    }
})();
(function(){
    'use strict';

    /**
     * Module for Angular-Chart.js settings
     * @module App.Insights.Dashbaord.widgets.chartsettings
     */
    angular.module('app.insights.dashboard.widgets.chartsettings', []);
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets.chartsettings')
        .factory('chartSettings', chartSettings);

    function chartSettings() {
        var settings = {};

        settings.legends = function () {
            return {
                display: true,
                position: 'top',
                labels: {
                    boxWidth: 20,
                    fontSize: 10
                }
            }
        };
        settings.scales = function (yOpt, xOpt) {
            return {
                yAxes: [{
                    scaleLabel: {
                        display: yOpt.show || false,
                        labelString: yOpt.label
                    }
                }],
                xAxes: [{
                    scaleLabel: {
                        display: xOpt.show || false,
                        labelString: xOpt.label
                    },
                    stacked: isStacked(xOpt.stacked)
                }]
            }
        }

        var isStacked = function(stacked) {
            if(stacked) {
                return true;
            }

            return false;
        }

        settings.tooltips = function (opt) {
            var currUnit = opt.unit;
            return {
                enabled: true,
                mode: opt.tooltipMode || "single",
                callbacks: {
                    label: function (tooltipItems, data) {
                        var datasetLabel = data.datasets[tooltipItems.datasetIndex].label;
                        var result = tooltipItems.yLabel + " " + (opt.unitText || "");

                        switch(currUnit) {
                            case "groupOrders":
                                result = _getGroupOrderLabel(datasetLabel, tooltipItems.yLabel, opt.unitText);
                            break;
                            case "sales":
                                result = _getSalesLabel(tooltipItems.yLabel); 
                            break;
                            case "ticketsummary":
                                result = _getTicketSummaryLabel(tooltipItems.yLabel, datasetLabel);
                            break;
                            case "hoursSummary":
                                result = _getHoursSummaryLabel(tooltipItems.Label, datasetLabel);
                            break;
                        }
                            return result;
                    }
                }
            }
        }
        return settings;
    }

    //Return Value for tooltips 
    var _getGroupOrderLabel = function(datasetLabel, tooltipItems, opt) {
        if(tooltipItems === 1) {
            var opt = opt.slice(0, -1);
        }
        return datasetLabel + ": " + tooltipItems + " " + opt;
    }

    //Return Value for tooltips 
    var _getSalesLabel = function(tooltipItems) {
        return "€ " + tooltipItems
    }

    //Return Value for tooltips
    var _getTicketSummaryLabel = function(tooltipItems, datasetLabel) {
        return datasetLabel + ": " +tooltipItems;
    }

    var _getHoursSummaryLabel = function(tooltipItems, datasetLabel) {
        return datasetLabel + ": " +tooltipItems + " %";
    }


})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets.chartsettings')
    .config(config);

    function config($translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/insights/dashboard/widgets/api/chartsettings/');
    }
});
(function(){
    'use strict';

    angular.module('app.support.monthsummary.dashboard', []);
})();
(function () {
    'use strict';

    angular.module('app.support.monthsummary.dashboard')
        .config(config)

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.websites.support.monthsummary.dashboard', {
                url: '/:month/:year',
                middleware: ['AuthMiddleware'],
                views: {
                    'dashboard@app.websites.support.monthsummary': {
                        templateUrl: 'app/main/support/monthsummary/dashboard.monthsummary.html',
                        controller: 'MonthsummaryDashboardController as vm'
                    }
                }
            });
            
            $translatePartialLoaderProvider.addPart('app/main/support/monthsummary/dashboard');
    }
})();
(function () {
    'use strict';

    angular.module('app.support.monthsummary.dashboard')
        .controller('MonthsummaryDashboardController', MonthsummaryDashboardController);

    function MonthsummaryDashboardController($scope, $state, MonthsummaryFactory, support_ticket_path, SupportService, websitesFactory, chartSettings, dataTableLoc) {
        var vm = this;

        vm.paths = [support_ticket_path + "monthsummary/dashboard/table.closedtickets.html", support_ticket_path + "monthsummary/dashboard/table.contract.html"];
        vm.tickets = {
            data: '',
            loaded: false,
            found: false
        }

        vm.notContract = support_ticket_path + 'summary/nosupport.html';
        vm.totalbilltime = 0;
        vm.credits = 0;
        vm.supportcontract = false;
        vm.showpie = false;

        vm.spendhours = {
            data: '',
            labels: ["Aantal support uren over", "Uren besteed"],
            items: [0, 100],
            loaded: false,
            found: false
        }

        vm.chartColors = ["#9E9E9E", "#4CAF50"];
        vm.chartOptions = {
            legend: chartSettings.legends(),
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function (selected, data) {
                        var index = selected.index;
                        var label = data.labels[index];
                        var value = data.datasets[0].data[index];
                        return label + ": " + value + "%";
                    }
                }
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }
        }

        vm.contract = {
            data: '',
            loaded: false
        }

        vm.dtoptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            lengthMenu: [5, 10, 20, 30, 50, 100],
            pageLength: 5,
            responsive: true,
            language: {
                url: dataTableLoc
            }
        };

        vm.supportSummary = {
            data: '',
            loaded: false,
            support: false,
        }

        var isLoaded = 0;

        function init() {
            var month = $state.params["month"];
            var year = $state.params["year"];

            MonthsummaryFactory.setDate(month, year);
        }

        $scope.$watch(function () {
            return websitesFactory.selected;
        }, function (newVal, oldVal) {
            if (newVal) {
                init();
                dataAndService(newVal.id);
                vm.clear();

                //websiteFactory.setStoreById(newVal.id);
            }
        });

        function checkContract() {
            if(vm.supportSummary.contract) {
                vm.contract.data = vm.supportSummary.data.support_hours;
                vm.contract.loaded = true;
                vm.contract.found = true
                $scope.$emit("supportContractFound", true);
            } else {
                vm.contract.loaded = true;
                vm.contract.found = false;
                $scope.$emit("supportContractFound", false);
            }
        }

        function dataAndService(id) {
            var start = MonthsummaryFactory.getRangeStart();
            var end = MonthsummaryFactory.getRangeEnd();

            SupportService.getSupportMonths(id)
                .then(function (data) {
                    var month = $state.params.month;

                    var filterData = data.filter(function (item) {
                        var itemdate = item.date.split("-")[1];

                        if (itemdate == month) {
                            return item;
                        }
                    });

                    if (filterData.length > 0) {
                        vm.supportSummary.data = filterData[0];
                        vm.supportSummary.loaded = true;

                        if(parseFloat(filterData[0].support_hours) > 0) {
                            vm.supportSummary.contract = true
                        }
                    } else {
                        vm.supportSummary.loaded = true;
                    }

                    checkContract();
                })

            SupportService.getSupportTickets(id, start, end, "done")
                .then(function (item) {
                    vm.tickets.loaded = true;
                    vm.tickets.data = item;
                    vm.tickets.found = true;
                    isLoaded++;
                    calcu_credits();
                })
                .catch(function (err) {
                    vm.tickets.found = false;
                    vm.tickets.loaded = true;
                });

            var date = MonthsummaryFactory.getDate();
            SupportService.getSupportHours(id, date)
                .then(function (data) {
                    vm.spendhours.loaded = true;
                    vm.spendhours.data = data;
                    vm.spendhours.found = true;
                    vm.credits = parseFloat(data.credit);

                    isLoaded++;
                    calcu_credits();
                })
                .catch(function (err) {
                    vm.spendhours.found = false;
                    vm.spendhours.loaded = true;
                });
        }

        /**
         * Data
         */
        function calcu_credits() {
            //Check if support ticket and hours are loaded
            if (isLoaded < 2) {
                return;
            }

            var support = vm.spendhours.data;
            var totalBilledTime = support.total_billed_time
            vm.totalbilltime = totalBilledTime;
            var totalCredit = parseFloat(support.corrected_hours) + parseFloat(support.support_hours);

            if (totalCredit > 0) {
                var diffrence = totalCredit - totalBilledTime;
                vm.showpie = true;

                var percentage = Math.round((diffrence / totalCredit) * 100);

                if (percentage <= 50 && percentage > 25) {
                    vm.chartColors[1] = "#FFFF00";
                } else if (percentage <= 25 && percentage > 3) {
                    vm.chartColors[1] = "#EF6C00";
                } else if (percentage <= 3) {
                    vm.chartColors[1] = "#FF5252";
                } else if (percentage <= 0 && percentage > 3) {
                    vm.chartColors[0] = "#C62828";
                }

                if (percentage <= 0) {
                    vm.spendhours.items[0] = 0;
                    vm.spendhours.items[1] = 100;
                } else {
                    vm.spendhours.items[0] = percentage;
                    vm.spendhours.items[1] = 100 - percentage;
                }
            }
        }

        vm.clear = function () {
            this._clearTickets();
            this._clearSpendHours();
            this._clearContract();
            this._clearSupportSummary();
        }

        vm._clearTickets = function () {
            this.tickets = {
                data: '',
                loaded: false,
                found: false
            }
        }

        vm._clearSpendHours = function () {
            this.totalbilltime = 0;
            this.credits = 0
            this.spendhours = {
                data: '',
                labels: ["Aantal support uren over", "Uren besteed"],
                items: [0, 100],
                loaded: false,
                found: false
            }
        }

        vm._clearContract = function () {
            this.contract = {
                data: '',
                loaded: false
            }
        }

        vm._clearSupportSummary = function () {
            this.supportSummary = {
                data: '',
                loaded: false
            }
        }

        /**
         * Create Downloadable support summary file
         * @param {Object} data
         */
        vm.getLinks = function (data) {
            var id = websitesFactory.selected.id;
            var date = data.date.split("-");
            var dateSet = {
                month: '',
                year: '',
                toString: ''
            };

            if (date.length > 0) {
                dateSet.month = date[1];
                dateSet.year = date[0];

                dateSet.toString = dateSet.year.toString() + dateSet.month.toString();
            }

            SupportService.getFile(id, dateSet.toString, "summary");

        }
    }
})();

(function() {
    angular.module('app.settings.account', [])
})();

(function () {
    angular.module('app.settings.account')
        .directive('startPage', startPage);

    startPage.$inject = ['settings_path'];

    function startPage(settings_path) {
        var directive = {
            restrict: 'EA',
            scope: {},
            templateUrl: settings_path + 'account/startPage/startPage.html',
            controller: startPageController,
            controllerAs: 'vm',
            bindToController: true
        };

        startPageController.$inject = ['$scope', 'websitesFactory'];

        function startPageController($scope, websitesFactory) {
            var vm = this;
            vm.pages = [
//                { // MER-1510
//                    name: 'Magento',
//                    state: 'app.websites.magento'
//                },
                {
                    name: 'Analytics',
                    state: 'app.websites.dashboard'
                },
                {
                    name: 'Analytics > Conversie',
                    state: 'app.websites.dashboard.ga'
                },
                {
                    name: 'Sales',
                    state: 'app.websites.sales'
                },
//                { // MER-1508
//                    name: 'Kennisbank',
//                    state: 'app.kennisbank'
//                },
//                {
//                    name: 'Kennisbank > Handleiding',
//                    state: 'app.kennisbank.magentomanual'
//                },
                {
                    name: 'Test Suite',
                    state: 'app.websites.testsuite'
                },
                {
                    name: 'PageSpeed',
                    state: 'app.websites.pagespeed'
                },
                {
                    name: 'Facturen',
                    state: 'app.websites.invoice'
                },
                {
                    name: 'Firewall',
                    state: 'app.websites.settings.overview'
                },
                {
                    name: 'Experius Actueel',
                    state: 'app.social'
                },
                {
                    name: 'Contact',
                    state: 'app.contact'
                }
            ];

            vm.startPage = '';

            vm.getStartPage = function () {
                var startPage = localStorage.getItem("startPage");

                if (startPage) {
                    this.startPage = startPage;
                } else {
                    var firstItem = this.pages[0].state;
                    this.startPage = firstItem;
                }
            }

            $scope.$watch('vm.startPage', function (newVal) {
                if (newVal) {
                    localStorage.setItem("startPage", newVal);

                }
            });

            $scope.$watch(function () {
                return websitesFactory.selected;
            }, function (website) {
                if (website) {
                    vm.getStartPage();
                }
            });
        }

        return directive;
    }
})();

(function () {
    angular.module('app.settings.account')
        .directive('ghostMail', ghostMail);

    ghostMail.$inject = ['settings_path'];

    function ghostMail(settings_path) {
        var directive = {
            restrict: 'EA',
            scope: {},
            templateUrl: settings_path + 'account/ghostMail/ghostMail.html',
            controller: ghostMailController,
            controllerAs: 'vm',
            bindToController: true
        };

        ghostMailController.$inject = ['$scope', 'websitesFactory'];

        function ghostMailController($scope, websiteFactory) {
            var vm = this;

            vm.active = false;

            vm.setMail = function (bool) {
                vm.active = bool;
            }

            function init() {

            }

            $scope.$watch(function () {
                return websiteFactory.selected;
            }, function (website) {
                if (website) {
                   init();
                }
            });
        }

        return directive;
    }
})();

(function(){
    "use strict";

    /**
     * @module app.ga
     */
    angular.module("app.ga", []);

})();

(function () {
    "use strict";

    angular.module("app.ga")
        .directive("gaTopsoldProduct", gaTopsoldProduct)

    function gaTopsoldProduct(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "topsoldproduct/ga.topsoldproduct.html";
        tmpl.controller = ["$scope", function ($scope) {
            $scope.data6 = [];
            $scope.loading = true;

            function init() {
                var ids = gaFactory.getViewIds();

                    gaService.getTopsoldProducts(ids)
                        .then(function (data) {
                            $scope.data6 = data;
                            $scope.loading = false;
                        });
            }

            $scope.dtoptions = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                lengthMenu: [5, 10, 20, 30, 50, 100],
                pageLength: 10,
                responsive: true,
                paging: false,
                order: [[1, 'DESC']],
                language: {
                    url: dataTableLoc
                }
            };

            $scope.$watch(function () {
                return gaFactory.ViewChange
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    $scope.loading = true;
                    init();
                }
            });

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }

            $scope.openSupportTicket = function () {
                $scope.$emit("openSupportTicket", "Top 10 meest gekochte producten - Conversie Optimalisatie");
            }

        }];
        return tmpl;
    }
})();

(function () {
    "use strict";

    angular.module("app.ga")
        .directive("gaTopSearchQuery", gaTopSearchQuery);

    function gaTopSearchQuery(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "topsearchquery/ga.topsearchquery.html";

        tmpl.controller = ["$scope", function ($scope) {
            $scope.data4 = [];
            $scope.loading = true;

                function init() {
                    var ids = gaFactory.getViewIds();


                        gaService.getTopSearchQuery(ids)
                            .then(function (data) {
                                $scope.data4 = data;
                                $scope.loading = false;
                            });
                }

            $scope.dtoptions = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                lengthMenu: [5, 10, 20, 30, 50, 100],
                pageLength: 10,
                responsive: true,
                order: [[1, 'DESC']],
                paging: false,
                language: {
                    url: dataTableLoc
                }
            };

            $scope.$watch(function () {
                return gaFactory.ViewChange
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    $scope.loading = true;
                    init();
                }
            });

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }

            $scope.openSupportTicket = function () {
                $scope.$emit("openSupportTicket", "Top 10 zoekopdrachten - Conversie Optimalisatie");
            }
        }];

        return tmpl;
    }
})();

(function () {
    "use strict";

    angular.module("app.ga")
        .directive("gaLeavePage", gaLeavePage)

    function gaLeavePage(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "leave_page/ga.leave_page.html";
        tmpl.controller = ["$scope", function ($scope) {
            $scope.data2 = [];
            $scope.loading = true;

            function init() {
                var ids = gaFactory.getViewIds();
                var ViewSelector = gaFactory.getViewSelector();

                ViewSelector.on('change', function(ids) {
                    gaService.getLeavePage(ids)
                        .then(function (data) {
                            $scope.data2 = data;
                            $scope.loading = false;
                        });
                });

                gaService.getLeavePage(ids)
                    .then(function (data) {
                        $scope.data2 = data;
                        $scope.loading = false;
                    });

            }

            $scope.dtoptions = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                lengthMenu: [5, 10, 20, 30, 50, 100],
                pageLength: 5,
                responsive: true,
                order: [1, 'desc'],
                language: {
                    url: dataTableLoc
                }
            };

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }

            $scope.$watch(function () {
                return gaFactory.ViewChange
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    $scope.loading = true;
                    init();
                }
            });

            $scope.openSupportTicket = function () {
                $scope.$emit("openSupportTicket", "Verlatingspagina's - Conversie Optimalisatie");
            }
        }];

        return tmpl;
    }
})();

(function () {
    "use strict";

    angular.module("app.ga")
        .directive("gaConversionDevice", gaConversionDevice)

    function gaConversionDevice(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
            tmpl.scope = {};
            tmpl.templateUrl = ga_widget_path + "conversion_device/ga.conversion_device.html";
            tmpl.controller = ["$scope", function ($scope) {
                $scope.data3 = [];
                $scope.loading = true;

                function init() {
                    var ids = gaFactory.getViewIds();

                        gaService.getConversionDevice(ids)
                            .then(function (data) {
                                $scope.data3 = data;
                                $scope.loading = false;
                            });
                }

                $scope.dtoptions = {
                    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    pagingType: 'simple',
                    lengthMenu: [5, 10, 20, 30, 50, 100],
                    pageLength: 5,
                    responsive: true,
                    language: {
                        url: dataTableLoc
                    }
                };

                $scope.$watch(function () {
                    return gaFactory.ViewChange
                }, function () {
                    if(gaFactory.ViewSelectorIsSet) {
                        $scope.loading = true;
                        init();
                    }
                });

                $scope.dtInstanceCallback = function (dtInstance) {
                    dtInstance.DataTable.on('length', function () {
                        $scope.$emit('msMasonry:relayout');
                    });
                }

                $scope.openSupportTicket = function () {
                    $scope.$emit("openSupportTicket", "Conversiepercentage per device - Conversie Optimalisatie");
                }
            }];
        return tmpl;
    }
})();

(function () {
    "use strict";
    angular.module("app.ga")
        .directive("gaConversionBrowser", gaConversionBrowser)

    function gaConversionBrowser(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "conversion_browser/ga.conversion_browser.html";

        tmpl.controller = ["$scope", "$state", function ($scope) {
            $scope.data = [];
            $scope.loading = true;

            function init() {
                var ids = gaFactory.getViewIds();

                    gaService.getConversionBrowser(ids)
                        .then(function (data) {
                           $scope.data = data;
                           $scope.loading = false;
                        });
            }

            $scope.dtoptions = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                lengthMenu: [5, 10, 20, 30, 50, 100],
                pageLength: 5,
                responsive: true,
                language: {
                    url: dataTableLoc
                }
            };

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }

            $scope.$watch(function () {
                return gaFactory.ViewChange
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    $scope.loading = true;
                    init();
                }
            });

            $scope.openSupportTicket = function () {
                $scope.$emit("openSupportTicket", "Conversiepercentage per browser - Conversie Optimalisatie");
            }
        }]
        return tmpl;
    }
})();

(function () {
    "use strict";

    angular.module("app.ga")
        .directive("gaBouncePage", gaBouncePage);

    function gaBouncePage(ga_widget_path, gaService, gaFactory, dataTableLoc) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "bounce_page/ga.bounce_page.html";
        tmpl.controller = ["$scope", function ($scope) {
            $scope.data5 = [];
            $scope.loading = true;

            function init() {
                var ids = gaFactory.getViewIds();

                gaService.getBouncePage(ids)
                        .then(function (data) {
                            $scope.data5 = data;
                            $scope.loading = false;
                        });
            }

            $scope.dtoptions = {
                dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                lengthMenu: [5, 10, 20, 30, 50, 100],
                pageLength: 10,
                responsive: true,
                language: {
                    url: dataTableLoc
                }
            };

            $scope.dtInstanceCallback = function (dtInstance) {
                dtInstance.DataTable.on('length', function () {
                    $scope.$emit('msMasonry:relayout');
                });
            }

            $scope.$watch(function () {
                return gaFactory.ViewChange
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    $scope.loading = true;
                    init();
                }
            });

            $scope.openSupportTicket = function () {
                $scope.$emit("openSupportTicket", "Best bekeken pagina's met een hoog bouncepercentage - Conversie Optimalisatie");
            }

        }];
        return tmpl;
    }
})();

(function () {
    "use strict";
    angular.module("app.ga")
        .directive("ga404Page", ga404Page)

    function ga404Page(ga_widget_path, gaService, gaFactory, websitesFactory) {
        var tmpl = {};
        tmpl.scope = {};
        tmpl.templateUrl = ga_widget_path + "404_page/ga.404_page.html";

        //tmpl.controller = ["$scope", function ($scope) {
        tmpl.link = function(scope) {
            scope.count = 0;
            scope.moduleisActive = false;
            scope.loading = true;

            function init() {
                var ids = gaFactory.getViewIds();

                gaService.get404NotFound(ids)
                        .then(function (count) {
                            scope.count = count;
                            scope.loading = false;
                        })
            }

            scope.$watch(function () {
                return gaFactory.ViewChange;
            }, function () {
                if(gaFactory.ViewSelectorIsSet) {
                    scope.loading = true;
                    init();
                }
            });

            scope.$watch(function () {
                return websitesFactory.selected
            }, function (website) {
                if (website && websitesFactory.getSelectedWebsite()) {
                    gaService.get404Module(websitesFactory.getSelectedWebsite()["id"])
                        .then(function (bool) {
                            if(bool) {
                                scope.moduleisActive = true;
                            } else {
                                scope.moduleisActive = false;
                            }
                        });
                }
            });

            scope.openSupportTicket = function () {
                scope.$emit("openSupportTicket", "404 module activeren - Conversie Optimalisatie");
            }
        }

        return tmpl;
    }
})();

(function(){
    'use strict';

    angular.module('app.support.summary', []);
})();
(function () {
    'use strict';

    angular.module('app.support.summary')
        .controller('SupportSummaryController', SupportSummaryController)
        .controller('createTicketController', createTicketController);

    function SupportSummaryController($scope, websitesFactory, SupportService, SupportFactory, support_ticket_path, $mdDialog, portal_path, dataTableLoc, $state) {
        var vm = this;
        vm.hideme = true;
        vm.id = 0;
        vm.supportcontract = SupportFactory.getContract();
        vm.supportHours = SupportFactory.getSupportHours();
        vm.supportTickets = SupportFactory.getSupportTickets();
        vm.supportcontractisLoaded = false;
        vm.supportOpenticketModel = {
            loaded: false,
            found: false,
            tickets: []
        }
        vm.supportticketsModel = {
            loaded: false,
            found: false
        }

        vm.supportoverviewModel = {
            loaded: false,
            found: false
        }

        vm.openhours = {
            loaded: false,
            found: false,
            total: 0,
        }

        vm.manager = {
            loaded: false,
            found: false,
            name: '',
            img: ''
        }

        vm.nosupportTemplate = support_ticket_path + "nosupport.html"
        vm.paths = [support_ticket_path + "summary/table.summary.html", support_ticket_path + "summary/text.hours.html", support_ticket_path + "summary/table.opentickets.html", support_ticket_path + "summary/manager.html"];

        function init() {

        }

        init();

        vm.createTicket = function () {
            $mdDialog.show({
                controller: "createTicketController as vm",
                templateUrl: support_ticket_path + 'summary/modal/createticket.html',
                parent: angular.element(document.body),
                fullscreen: false,
                bindToController: true,
                locals: {
                    title: "",
                    websiteId: vm.id
                }
            })
        }

        vm.getLink = function(data) {
            var id = websitesFactory.selected.id;
            var month = data.year.toString() + data.month.toString();
            return portal_path + 'websites/'+id+'/support/months/'+ month+'/download/summary';
        }

        vm.getLinks = function(data) {
            var id = websitesFactory.selected.id;
            var month = data.year.toString() + data.month.toString();
            SupportService.getFile(id, month, "summary");

        }

        $scope.overview = [];

        $scope.dtoptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            lengthMenu: [5, 10, 20, 50, 100],
            pageLength: 5,
            responsive: true,
            language: {
                url: dataTableLoc
            },
            order: false
        };

        $scope.dtoptions2 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            lengthMenu: [5, 10, 20, 50, 100],
            pageLength: 5,
            responsive: true,
            language: {
                url: dataTableLoc
            },
            order: false
        };

        $scope.dtInstanceCallback = function (dtInstance) {
            dtInstance.DataTable.on('length', function () {
                $scope.$broadcast('msMasonry:relayout');
            });
        }

        $scope.$watch(function () {
            return SupportFactory.getSupportMonths();
        }, function (newVal, oldVal) {
            if (newVal.length > 0) {
                var count = 0;
                var currLength = newVal.length;
                var id = websitesFactory.selected.id;

                $scope.overview = newVal.filter(function (value, index) {
                    var date = moment(value.date);
                    var end = date.endOf("month").format("YYYY-MM-DD");

                    //Start of support tickets in merlin See for more info https://jira.experius.nl/browse/PORTAL-248
                    if (parseInt(date.format("YY")) < 16 && parseInt(date.format("MM")) < 11) {
                        currLength--;
                        return;
                    }

                    value.dateName = date.format("MMMM YYYY");
                    value.credit = parseFloat(value.credit);
                    value.support_hours = parseFloat(value.support_hours);
                    value.corrected_hours = parseFloat(value.corrected_hours);
                    value.totalHours = value.support_hours + value.corrected_hours;
                    value.spendHours = parseFloat(value.total_billed_time);
                    value.month = value.date.split("-")[1];
                    value.year = value.date.split("-")[0];

                    vm.supportticketsModel.loaded = true;
                    vm.supportticketsModel.found = true;
                    $scope.$broadcast("createChart");

                    return value;
                });

                vm.supportoverviewModel.loaded = true;
                vm.supportoverviewModel.found = true;

                getOpenTickets(id);
            }
        });

        /**
         * @method getOpenTickets
         * @param {int} id
         * @return {void}
         */
        function getOpenTickets(id) {
            var currMonth = moment().month(moment().month());
            var end = currMonth.add(1, "days").format("YYYY-MM-DD");
            var start = currMonth.format("YYYY-MM-01");

            SupportService.getSupportTickets(id, start, end, "open")
                .then(function (data) {
                    vm.supportOpenticketModel.tickets = data;
                    vm.supportOpenticketModel.loaded = true;
                    vm.supportOpenticketModel.found = true;

                    setOpenHours();
                })
                .catch(function () {
                    vm.supportOpenticketModel.loaded = true;
                    vm.supportOpenticketModel.found = false;
                    vm.openhours.loaded = true;
                });
        }

        /**
         * Calculate total open hours
         * @method setOpenHours
         * @return {void}
         */
        function setOpenHours() {
            var total = 0;

            vm.supportOpenticketModel.tickets.forEach(function (value) {
                if (parseFloat(value["estimate_time"]) > 0) {
                    total += parseFloat(value["estimate_time"]);
                } else {
                    total += parseFloat(value["billed_time"]);
                }
            });

            vm.openhours.loaded = true;
            vm.openhours.found = true;
            vm.openhours.total = total;
        }

        $scope.$watch(function () {
            return websitesFactory.selected;
        }, function (newVal, oldVal) {
            if (newVal) {
                SupportFactory.clear();
                vm.clear();

                var id = newVal.id;
                vm.id = newVal.id;
                SupportService.getSupportMonths(id)
                    .then(function (data) {
                        SupportFactory.setSupportMonths(data);
                    });

                if(websitesFactory.selected.manager) {
                    vm.manager.loaded = true;
                    vm.manager.found = true;

                    vm.manager.name = websitesFactory.selected.manager.first_name + ' ' + websitesFactory.selected.manager.last_name;
                    vm.manager.img = websitesFactory.selected.manager.avatar;
                } else {
                    vm.manager.loaded = true;
                    vm.manager.found = false;
                }
            }
        });

        $scope.close = function () {
            $scope.hideme = true;
        }

        vm.clear = function () {
            this._clearSupportModel();
            this._clearSupportOverviewModel();
            this._clearSupportOpenTicketModel();
            this._clearManager();
        }

        vm._clearSupportModel = function () {
            this.supportticketsModel = {
                loaded: false,
                found: false
            }
        }

        vm._clearSupportOverviewModel = function () {
            this.supportoverviewModel = {
                loaded: false,
                found: false
            }
        }

        vm._clearSupportOpenTicketModel = function () {
            this.supportOpenticketModel = {
                loaded: false,
                found: false,
                tickets: []
            }

            this.openhours = {
                loaded: false,
                found: false,
                total: 0
            }
        }

        vm._clearManager = function () {
            this.manager = {
                loaded: false,
                found: false,
                name: '',
                img: ''
            }
        }
    }

    function createTicketController($mdDialog, SupportService, websiteId, title, $scope) {
        var vm = this;
        vm.subject = "";
        vm.description = "";
        vm.error = false;
        vm.success = false;
        vm.sendok = true;
        vm.sending = false;

        function init() {
            vm.subject = title;
        }

        init();

        vm.closeDialoog = function () {
            $mdDialog.hide();
            vm.error = false;
            vm.success = false;
            vm.sendok = true;
            vm.sending = false;
        }

        vm.sendMail = function () {
            SupportService.createTicket(websiteId, vm.subject, vm.description)
                .then(function () {
                    vm.success = true;
                    vm.sending = true;
                })
                .catch(function (err) {
                    vm.error = true;
                    vm.sending = true;
                })
        }

        $scope.$watch('vm.subject', function (newVal) {
            if (newVal) {
                if (newVal.length > 3) {
                    vm.sendok = false;
                } else {
                    vm.sendok = true;
                }
            }
        });
    }
})();

(function(){
    'use strict';

    angular.module('app.support.summary')
    .config(config);

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.websites.support.summary', {
                url    : '/summary',
                middleware: ['AuthMiddleware'],
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/support/summary/support.summary.html',
                        controller : 'SupportSummaryController as vm'
                    }
                },
                resolve: {
                }
        });

        $translatePartialLoaderProvider.addPart('app/main/support/summary');
    }
})();
(function () {
    'use strict';

    angular.module('app.support.summary')
        .directive('chartSummary', ChartSummary)

    function ChartSummary(support_ticket_path, SupportFactory, SupportService, chartSettings) {
        var summary = {};
        summary.templateUrl = support_ticket_path + "summary/chart.summary.html";

        summary.controller = ['$scope', 'websitesFactory',function ($scope, websitesFactory) {
            $scope.labels = [];

            $scope.series = [
                 "Uren besteed", "Support uren"
            ];

            $scope.colors = ["#FDB45C", "#949FB1"];

            $scope.values = [[], []];

            $scope.chartOptions = {
                legend: chartSettings.legends(),
                scales: chartSettings.scales({ show: true, label: "Uren" }, { show: true, label: 'Datum', stacked: true }),
                tooltips: chartSettings.tooltips({
                    mode: "single",
                    unit: "ticketsummary"
                })
            }

            $scope.$on("createChart", function (v, i) {
                var items = getData(SupportFactory);

                $scope.values = items["data"];
                $scope.labels = items["labels"];

            });
        }];

        return summary;
    }

    /**
     * Get data and label based on currMonth
     * @method getData
     * @param {Object} SupportFactory
     * @return {Object}
     */
    function getData(SupportFactory) {
        var currMonth = getCurrentMonth();
        var labels = [];
        var summarydata = [
            [], []
        ]

        for (var i = 0; i < 12; i++) {
            var currdate = moment().month(currMonth).subtract(i, "months");
            var label = moment().month(currMonth).subtract(i, "months").format("MMM YYYY");
            var data = SupportFactory.findHoursByMonth(currdate.format("YYYY-MM"));


            //Start of support tickets in merlin See for more info https://jira.experius.nl/browse/PORTAL-248
            if(parseInt(currdate.format("YYMM")) < 1611) {
                break;
            }

            if (data.length > 0) {
                summarydata[1].push(data[0].totalHours);
                summarydata[0].push(data[0].spendHours);
                labels.push(label);
            }
        }

        return {
            data: summarydata,
            labels: labels
        };
    }

    /**
     * Get current month
     * @return {String}
     */
    function getCurrentMonth() {
        var currMonth = new Date().getMonth();

        return currMonth;
    }

})();

(function(){
    'use strict';

    angular.module('app.support.monthsummary', ['app.support.monthsummary.dashboard']);
})();
(function () {
    'use strict';

    angular.module('app.support.monthsummary')
        .controller('MonthsummaryController', monthsummaryController)

    function monthsummaryController($scope, $state, MonthsummaryFactory, support_ticket_path, SupportService, websitesFactory) {
        var vm = this;
        vm.disableForward = false;
        vm.disableBackward = false;
        vm.chartContract = {
            loaded: false,
            found: false
        }
        function init() {
            checkDate(MonthsummaryFactory.getDateName())
        }

        init();

        $scope.$watch(function () {
            return MonthsummaryFactory.selectedDate.month;
        }, function (newVal) {
            if (newVal) {
                vm.dateName = newVal;
                checkDate(MonthsummaryFactory.getDateName(), MonthsummaryFactory.getDateYear())
            }
        });

        $scope.$watch(function () {
            return MonthsummaryFactory.selectedDate.year;
        }, function (newVal) {
            if (newVal) {
                vm.dateYear = newVal;
                checkDate(MonthsummaryFactory.getDateName(), MonthsummaryFactory.getDateYear())
            }
        });

        $scope.$on("supportContractFound", function (e, data) {
            vm.chartContract = {
                loaded: true,
                found: data
            }
        });

        vm.forward = function () {
            if (vm.disableForward) {
                return;
            }

            var date = MonthsummaryFactory.getAddDate();
            var month = moment().month(date.month()).format("MM");
            var year = date.year();

            $state.go('app.websites.support.monthsummary.dashboard', {
                month: month.toString(),
                year: year.toString()
            });
        }

        vm.backward = function () {
            if (vm.disableBackward) {
                return;
            }

            var date = MonthsummaryFactory.getSubtractDate();
            var month = moment().month(date.month()).format("MM");
            var year = date.year();

            $state.go('app.websites.support.monthsummary.dashboard', {
                month: month.toString(),
                year: year.toString()
            });
        }

        /**
         * Compares date for disabling forward button
         * @param {string} dateName
         * @param {number} year
         */
        function checkDate(dateName, yearItem) {
            var currentMonth = moment().month(moment().month()).format("YYMM");
            var date = moment().month(dateName).format("MM");
            var year = moment().year(parseInt(yearItem)).format("YY");
            var compareY = parseInt(year);
            var compareM = parseInt(date);
            var compare = year + "" + date;

            if (parseInt(compare) >= parseInt(currentMonth)) {
                vm.disableForward = true;
            } else {
                vm.disableForward = false;
            }

            //Start of support tickets in merlin See for more info https://jira.experius.nl/browse/PORTAL-248
            if (parseInt(compare) <= 1611) {
                vm.disableBackward = true;
            } else {
                vm.disableBackward = false;
            }

        }
    }
})();

(function () {
    'use strict';

    angular.module('app.support.monthsummary')
        .factory('MonthsummaryFactory', MonthsummaryFactory)

    function MonthsummaryFactory() {
        var ms = {};
        ms.selectedDate = {
            month: "",
            year: "",
            date: "",
            ISO: "",
            start: "",
            end: ""
        }

        /**
         * Set date for current state
         * @param {String} month,
         * @param {String} year
         */
        ms.setDate = function (month, year) {
            ms.selectedDate.ISO = moment(year + month + "01");
            
            ms.selectedDate.month = moment().month(ms.selectedDate.ISO.month()).format("MMMM");
            ms.selectedDate.year = ms.selectedDate.ISO.year();
            ms.selectedDate.date = year.toString() + moment().month(ms.selectedDate.month).format("MM");
            ms.setDateRange(ms.selectedDate.ISO);
        }

        /**
         * Return date minus 1 month
         * @return {Object}
         */
        ms.getSubtractDate = function () {
            return moment(ms.selectedDate.ISO).subtract(1, "month");
        }

        /**
         * Return date plus 1 month
         * @return {Object}
         */
        ms.getAddDate = function () {
            return moment(ms.selectedDate.ISO).add(1, "month");
        }

        ms.getDateName = function () {
            return ms.selectedDate.month;
        }

        ms.getDateYear = function () {
            return ms.selectedDate.year;
        }

        ms.getRangeStart = function () {
            return ms.selectedDate.start;
        }

        ms.getRangeEnd = function () {
            return ms.selectedDate.end;
        }

        ms.getDate = function () {
            return ms.selectedDate.date;
        }

        /**
         * Set end & start range
         */
        ms.setDateRange = function (date) {
            var start = date.format("YYYY-MM-DD");
            var end = moment(date).endOf("month").format("YYYY-MM-DD");

            ms.selectedDate.start = start;
            ms.selectedDate.end = end;
        }

        ms.clear = function () {
            this._clearSelectedDate();
        }

        ms._clearSelectedDate = function () {
            this.selectedDate = {
                month: "",
                year: "",
                date: "201611",
                ISO: "",
                start: "",
                end: ""
            }
        }

        return ms;
    }
})();
(function () {
    'use strict';

    angular.module('app.support.monthsummary')
        .config(config)

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var curr = new Date();
        var currentMonth = curr.getMonth();
        var currentYear = curr.getFullYear();

        $stateProvider
            .state('app.websites.support.monthsummary', {
                url: '/monthsummary',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/support/monthsummary/support.monthsummary.html',
                        controller: 'MonthsummaryController as vm'
                    }
                },
                resolve: {
                }
            });
            $translatePartialLoaderProvider.addPart('app/main/support/monthsummary');
    }
})();
(function(){
    'use strict';

    angular.module('app.support.monthsummary')
    .directive('chartSpendhours', chartSpendhours);

    function chartSpendhours(support_ticket_path) {
        var cph = {};
        cph.templateUrl = support_ticket_path+'monthsummary/chart.spendhours.html';

        return cph;
    } 
})();
(function(){
    'use strict';

    angular.module('app.support', ['app.support.summary', 'app.support.monthsummary'])
})();
(function () {
    angular.module('app.support')
        .directive('createTicket', createTicket);

    function  createTicket(support_ticket_path) {
        var api = {};
        api.templateUrl = support_ticket_path + 'directive/createticket.html';
        return api;
    }
})();

(function(){
    'use strict';

    angular.module('app.settings.overview', []);
})();

(function() {
    'use strict';

    angular.module('app.settings.overview')
        .controller('SettingsOverviewController', SettingsOverviewController)

    function SettingsOverviewController($scope, $mdToast, SettingsService, SettingsFactory, settings_path, $q, websitesFactory) {
        var vm = this;
        vm.hideme = true;
        vm.adminProtectionLoaded = false;
        vm.adminProtection = false;
        vm.paths = [
            settings_path + "overview/table.ipaddresses.html",
            settings_path + "overview/table.account.html"
        ];
        vm.form = {
            ip: ''
        };

        vm.ipAddresses = SettingsFactory.getAddresses();

        function init() {
            SettingsService.getAddresses()
                .then(function (data) {
                    SettingsFactory.setAddresses(data);
                });
        }

        init();

        function adminProtection() {
            var id = websitesFactory.selected["id"];
            SettingsService.getAdminProtection(id)
                .then(function (adminProtection) {
                    vm.adminProtectionLoaded = true;
                    vm.adminProtection = adminProtection;
                });
        }

        vm.setAdminProtection = function() {
            var id = websitesFactory.selected["id"];
            SettingsService.setAdminProtection(id, vm.adminProtection);
        }

        $scope.$watch(function() {
            return SettingsFactory.getAddresses();
        }, function(newVal, oldVal) {
            if (newVal) {
                $scope.ipAddresses = newVal;
            }
        });

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                adminProtection();
            }
        });

        /**
         * Delete address from company.
         * @param id
         */
        vm.deleteAddress = function (id) {
            SettingsService.deleteAddress(id)
                .then(function() {
                    init();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('IP-adres is verwijderd')
                            .hideDelay(2000)
                    );
                })
                .catch(function() {
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent('Fout bij verwijderen!')
                        .hideDelay(2000)
                    );
                });
        }

        /**
         * Add address to company.
         */
        vm.submitAddress = function (current) {
            current = current || false;
            var address = (current ? 'current' : vm.form.ip);
            var description = vm.form.description;

            if (! SettingsService.validateAddress(address)) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Foutief IP-adres!')
                        .hideDelay(5000)
                );
            }


            SettingsService.getIp()
                .then(function(publicIp) {
                    if (current) {
                        address = publicIp;

                        vm.form.ip = address;
                        return $q.reject("skip");
                    }

                    if(description === "") {
                        description = null;
                    }

                    return SettingsService.addAddress(address, description);
                })
                .then(function() {
                    vm.form.ip = '';
                    vm.form.description = '';

                    init();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('IP-adres is toegevoegd!')
                            .hideDelay(2000)
                    );
                })
                .catch(function(status, err) {
                    var message = 'Fout bij toegevoegen!';

                    if(status === "skip") {
                        return;
                    }

                    if (status === 400) {
                        message = 'Lokale IP-adres zijn niet toegestaan!';
                    } else if (status === 409) {
                        message = 'IP-adres bestaat al!';
                    } else if (status === 403) {
                        message = 'U heeft het limiet bereikt! Neem contact op met de klantenservice.';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .hideDelay(2000)
                    );
                });
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.settings.overview')
    .config(config);

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.websites.settings.overview', {
                url    : '/overview',
                middleware: ['AuthMiddleware'],
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/overview/settings.overview.html',
                        controller : 'SettingsOverviewController as vm'
                    }
                },
                resolve: {
                }
        });

         $translatePartialLoaderProvider.addPart('app/main/settings/overview');
    }
})();

(function() {
    angular.module('app.settings.account')
        .controller('accountSettingsController', accountSettingsController)

    function accountSettingsController() {

    }
})();

(function() {
    angular.module('app.settings.account')
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.settings.account', {
                url: '/account',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/account/settings.account.html',
                        controller: 'accountSettingsController as vm'
                    }
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/settings/account');
    }
})();

(function(){
  angular.module('app.kennisbank.nomanual', []);
})();
(function(){
  angular.module('app.kennisbank.nomanual')
  .directive('noManual', noManual)

  function noManual(kennisbank_path) {
    var api = {};
    api.scope = {
      title: '@',
      message: '@'
    }
    api.templateUrl = kennisbank_path + "nomanual/kennisbank.nomanual.html";

    return api;
  }
})();
(function(){
  "use strict";

  angular.module("app.kennisbank.magentomanual", []);
})();
(function () {
    "use strict";

    angular.module("app.kennisbank.magentomanual")
        .controller("MagentomanualSingleController", MagentomanualSingleController)

    function MagentomanualSingleController($scope, $state, magentoService, websitesFactory, widgetService) {
        var vm = this;
        vm.page = {
            loaded: false,
            found: false,
            title: '',
            content: ''
        }
        var pageid = $state.params.pageid;

        function init() {
            var isReadme = parseInt(pageid);

            if (!isNaN(isReadme)) {
                getConfluencePage(pageid);
            } else {
                var splitter = pageid.split("-");
                var name = splitter[1] + "/" + splitter[2];
                getReadme(name);
            }
        }

        init();

        function getReadme(name) {
            var datacode = "magento_module_infos";
            var website = websitesFactory.selected;

            if (website) {
                var website_id = website.id;
                var options = {
                    range_start: moment().format(),
                    store: 1,
                    website: website_id,
                    options: {
                        interval: 300
                    }
                }

                widgetService.getWidgetData(datacode, options)
                    .then(function (data) {
                        if (data.items.length > 0) {
                            var filter = data.items[0].filter(function (val) {
                                if (val.name == name) {
                                    return val;
                                }
                            });

                            if (filter.length > 0) {
                                if (filter[0].readme.length > 0) {
                                    vm.page.title = name;
                                    vm.page.content = filter[0].readme;

                                    vm.page.loaded = true;
                                    vm.page.found = true;
                                    $scope.$emit("readme", {});
                                } else {
                                    vm.page.loaded = true;
                                    vm.page.found = false;
                                    $scope.$emit("noRead");
                                }
                            } else {
                                vm.page.loaded = true;
                                vm.page.found = false;
                                $scope.$emit("noRead");
                            }
                        }
                    });
            }
        }

        function getConfluencePage(pageid) {
            magentoService.getConfluencePage(pageid)
                .then(function (data) {
                    if (data && data.status !== 'error') {
                        vm.page.title = data.title.rendered;
                        vm.page.content = data.content.rendered;

                        vm.page.loaded = true;
                        vm.page.found = true;
                    } else {
                        vm.page.loaded = true;
                        vm.page.found = false;
                        $scope.$emit("noRead");
                    }
                })
                .catch(function () {
                    vm.page.loaded = true;
                    vm.page.found = false;
                    $scope.$emit("noRead");
                });
        }

        function dataReset() {
            vm.page = {
                loaded: false,
                found: false,
                title: '',
                content: ''
            }
        }

        vm.renderHtml = function (html) {
            return html;
        }

        $scope.$watch(function () {
            return websitesFactory.selected;
        }, function (newVal, oldVal) {
            if (newVal) {
                init();
                dataReset();
            }
        });
    }
})();

(function(){
  "use strict";

  angular.module("app.kennisbank.magentomanual")
  .service("MagentomanualService", MagentomanualService)

  function MagentomanualService() {
    
  }
})();
(function(){
  "use strict";

    angular.module("app.kennisbank.magentomanual")
  .factory("MagentomanualFactory", MagentomanualFactory)

  function MagentomanualFactory() {
    var api = {};
    api.moduleList = [];

    api.setModuleList = function(list) {
      this.moduleList = list;
    }

    api.getModuleList = function() {
      this.moduleList;
    }
  }
})();
(function () {
    "use strict";

    angular.module("app.kennisbank.magentomanual")
        .controller("MagentomanualController", MagentomanualController)

    function MagentomanualController($scope, websitesFactory, widgetService, magentoService, kennisbankFactory) {
        var vm = this;

        $scope.loaded = false;
        $scope.modules = [];

        $scope.magento = {
            loaded: false,
            found: false,
            link: ""
        };

        vm.magentoModules = {
            loaded: false,
            found: false,
            showReadErr: false,
            showNoRead: false,
            modules: []
        };

        function init() {
            //Check if modules are loaded
            var magentoModules = kennisbankFactory.getMagentoModuleList();
            var magentoLink = kennisbankFactory.getMagentoLink();

            $scope.magento = magentoLink;

            if(!$scope.magento.found && !$scope.magento.loaded) {
                magentoManual();
            }

            if (magentoModules.length > 0) {
                createMagentoManual(magentoModules);
            } else {
                loadModules()
            }
        }

        function getMagentoType(magento) {
            if (magento === "magento") {
                return "magento1-";
            } else {
                return "magento2-";
            }
        }

        function getType(name) {
            if (name === 1) {
                return "community";
            } else {
                return "enterprise";
            }
        }

        function getMagentoManual(edition) {
            magentoService.getMagentoManual(edition)
                .then(function (req) {
                    var obj = req.data[0];

                    if(obj.manual_file) {
                        $scope.magento.found = true;
                        $scope.magento.loaded = true;
                        $scope.magento.link = obj.manual_link;
                        kennisbankFactory.setMagentoLink({
                            found: true,
                            loaded: true,
                            link: obj.manual_link
                        });
                    }
                })
                .catch(function (err) {
                    $scope.magento.found = false;
                    $scope.magento.loaded = true;
                    kennisbankFactory.setMagentoLink({
                        found: false,
                        loaded: true,
                        link: ""
                    });
                });
        }

        function magentoManual() {
            var website = websitesFactory.selected;
            var options = {
                website: website.id,
                options: {
                    interval: 300,
                    range_start: "2017-05-12T00:00:00",
                    store: 1
                }
            }

            widgetService.getWidgetData("magento_magento_infos", options)
                .then(function (data) {

                    var magento = getMagentoType(website["type_code"]);

                    if (data["items"].length > 0) {
                        var type = getType(data["items"][0]["edition"]);
                        var link = magento + type + "-manual";
                        getMagentoManual(link);
                    } else {
                        //vm.magentoManual.loaded = true;
                    }
                });
        }

        function dataReset() {
            vm.magentoModules = {
                loaded: false,
                found: false,
                showReadErr: false,
                showNoRead: false,
                modules: []
            }

            $scope.loaded = false;

            kennisbankFactory.setMagentoModuleList([]);
            kennisbankFactory.setMagentoLink({
                loaded: false,
                found: false,
                link: ""
            });

        }

        function loadModules() {
            var datacode = "magento_module_infos";
            var website = websitesFactory.selected;

            if (website) {
                var website_id = website.id;
                var options = {
                    range_start: moment().format(),
                    store: 1,
                    website: website_id,
                    options: {
                        interval: 300
                    }
                }

                widgetService.getWidgetData(datacode, options)
                    .then(function (data) {
                        var magento = getMagentoType(website["type_code"]);
                        if (data.items.length > 0) {
                            kennisbankFactory.setMagentoModuleList(data.items);
                            createMagentoManual(data.items);
                            var type = getType(data["items"]["edition"]);
                            var link = magento + type + "-manual";
                            getMagentoManual(link);
                        }
                    });
            }
        }

        //Set all modules in a list is document id isset
        function createMagentoManual(items) {
            var arr = [];
            items.forEach(function (val) {

                val.docIsset = false;
                val.readIsset = false
                val.namesplit = val.name.replace("/", "-");

                //Check if document or readme isset
                if (val.documentation_id != "") {
                    val.docIsset = true;
                    arr.push(val);

                    return;
                }

                //Check if readme isset
                if (val.readme.length > 0) {
                    val.readIsset = true;
                    vm.magentoModules.readIsset = true;
                    arr.push(val);
                } else {
                    vm.magentoModules.readIsset = false;
                }
            });


            if (arr.length > 0) {
                vm.magentoModules.found = true;
            } else {
                vm.magentoModules.found = false;
            }

            vm.magentoModules.loaded = true;
            $scope.modules = arr;
            $scope.loaded = true;
        }

        $scope.$watch(function () {
            return websitesFactory.selected;
        }, function (newVal, oldVal) {
            if (newVal) {
                dataReset();
                init();
            }
        });

        $scope.$on("readme", function (data) {
            vm.magentoModules.showReadErr = true;
        });

        $scope.$on("noRead", function (data) {
            vm.magentoModules.showNoRead = true;
        });
    }

})();

(function () {
    "use strict";

    angular.module("app.kennisbank.magentomanual")
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.kennisbank.magentomanual', {
                url: '/handleiding',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/kennisbank/magentomanual/magentomanual.html',
                        controller: 'MagentomanualController as vm'
                    },
                    'manualcontent@app.kennisbank.magentomanual': {
                        templateUrl: 'app/main/kennisbank/magentomanual/index.html',
                        controller: function() {

                        }
                    }
                }
            });

        $stateProvider
            .state('app.kennisbank.magentomanual.single', {
                url: '/:pageid',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/kennisbank/magentomanual/magentomanual.html',
                        controller: 'MagentomanualController as vm'
                    },
                    'manualcontent@app.kennisbank.magentomanual.single': {
                        templateUrl: 'app/main/kennisbank/magentomanual/single.html',
                        controller: 'MagentomanualSingleController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('handleiding', {
            title: 'Kennisbank',
            icon: 'icon-book-multiple',
            state: 'app.kennisbank.magentomanual',
            class: '500',
            weight: 40
        });

        $translatePartialLoaderProvider.addPart('app/main/kennisbank/magentomanual');
    }
})();

(function () {
    'use strict';

    /**
     * Provides the base Widget class dashboard
     *
     * @module App.Insights.Dashboard
     */
    angular
        .module('app.insights.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.insights_dashboard', {
                icon: 'icon-chart-areaspline',
                url: '/insights/dashboard/',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/insights/dashboard/dashboard.html'
                    }
                }
            });

        // msNavigationServiceProvider.saveItem('insights', {
        //     title: 'Dashboard',
        //     icon: 'icon-chart-areaspline',
        //     state: 'app.insights_dashboard'
        // });

        $translatePartialLoaderProvider.addPart('app/main/insights/dashboard');
    }
})();

(function(){
    'use strict';

    angular
        .module('app.insights.dashboard')
        .service('dashboardService', dashboardService);

        function dashboardService(portal_path, $http, $q) {
            var api = {};

            api.data;

            /*
            *   Get All Dashbaords from current user
            *
            *   return {void}
            */
            api.getDashboards = function() {
                var results = $q.defer();

                $http({
                    url: portal_path+'dashboards'
                }).then(function(data){
                    api.data = data.data.data;
                    results.resolve(data.data.data);
                }).catch(function(err){
                    results.reject();
                });

                return results.promise
            }

            /*
            *   findDashboardById
            */
            api.findDashboardById = function(id) {
                var results = $q.defer();

                if(typeof api.data != 'undefined') {
                    return api.data.filter(function(item){
                        if(item.website === id) {
                            return item;
                        }
                    });
                }
            }

            return api;
        }
})();

(function () {
    'use strict';

    angular
        .module('app.insights.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(websiteService, dashboardService, $scope, websiteStore, magentoModule) {
        var vm = this;
        vm.selectedWebsite;
        vm.websites;
        vm.dashboards;
        vm.noByte = false;

        function init() {
            dashboardService.getDashboards().then(function (data) {
                vm.dashboards = data;

                $scope.$emit("WIL", {
                    from: "dashboard",
                    dep: ["website"]
                });

                $scope.$on("dashboardDepLoad", function (e, value) {
                    vm.selectedWebsite = websiteStore.selected;
                });
            })
        }

        init();
        $scope.$watch(function () {
            return websiteStore.selected;
        }, function (newVal, oldVal) {
            if (newVal) {
                //Checks if it is a valid magento enviroment
                if (!websiteStore.getLiveEnv() || websiteStore.getTypeCode() != "magento") {
                    websiteStore.setStoreById(newVal.id);
                    $scope.$broadcast("noByte");
                    return
                }

                vm.noByte = false;
                if (typeof dashboardService.data === "undefined") {
                    dashboardService.getDashboards().then(function (data) {
                        vm.dashboards = data;

                        var newDashBoard = dashboardService.findDashboardById(newVal.id);
                        magentoModule.clearData();
                        websiteStore.setStoreById(newVal.id);
                        $scope.$broadcast('newBoard', { websiteId: newDashBoard[0].website, dashboardId: newDashBoard[0].id });
                    });
                } else {
                    var newDashBoard = dashboardService.findDashboardById(newVal.id);
                    magentoModule.clearData();
                    websiteStore.setStoreById(newVal.id);
                    $scope.$broadcast('newBoard', { websiteId: newDashBoard[0].website, dashboardId: newDashBoard[0].id });
                }
            }
        });
    }
})();

(function(){
    "use strict";

    angular.module("app.ga")
        .directive("noGaAccess", noGaAccess);

    noGaAccess.$inject = ['ga_path',  'gaService'];
    /**
     * Module no Google Anyaltics Access
     *
     * @module noGaAccess
     * @param ga_path
     * @param gaService
     * @return {{restrict: string, scope: {}, templateUrl: string, controller: noGaAccessController, controllerAs: string, bindToController: boolean}}
     */
    function noGaAccess(ga_path, gaService) {
        var directive = {
            restrict: 'EA',
            scope: {},
            templateUrl: ga_path + 'gaAccess/ga.gaAccess.html',
            controller: noGaAccessController,
            controllerAs: 'vm',
            bindToController: true
        };

        noGaAccessController.$inject = ['$scope', 'websitesFactory', 'gaService', 'gaFactory', '$mdDialog'];

        /**
         * Provide the controller for the module
         *
         * @method noGaAccessController
         * @param $scope
         * @param websitesFactory
         * @param gaService
         * @param gaFactory
         * @param $mdDialog
         */
        function noGaAccessController($scope, websitesFactory, gaService, gaFactory, $mdDialog) {
            var vm = this;

            function init() {
                getKey();
            }

            /**
             * Get the Google Analytics api key
             *
             * @method getKey
             */
            function getKey() {
                gaService.getKey()
                    .then(function (key) {
                        isActive();
                    });
            }

            /**
             * Check if Google Analytics isActive
             *
             * @method isActive
             */
            function isActive() {
                var isActive = gaFactory.getActive();

                if(isActive) {
                    $scope.$emit("gaStatus", true);
                } else {
                    $scope.$emit("gaStatus", false);
                }
            }

            /**
             * Open the modal with Google Analytics instructions
             *
             * @method openModal
             */
            vm.openModal = function() {
                $mdDialog.show({
                    locals: {title: "GA.NOACCESS.TITLE"},
                    controller: "gaNoActiveControllor as vm",
                    templateUrl: 'app/main/ga/modals/notaccess.html'
                }).finally(function () {
                    reset();
                    init();
                });
            }

            $scope.$watch(function () {
                return websitesFactory.selected
            }, function (website) {
                if (website && websitesFactory.getSelectedWebsite()) {
                    reset();
                    init();
                }
            });

            function reset() {

            }
        }

        return directive;
    }

})();

(function(){
    "use strict";

    /**
     * Provides the base Dasboardv2 module
     *
     * @module app.dashboardv2
     */
    angular.module("app.dashboardv2", []);
})();

(function () {
    'use strict';

    angular.module("app.dashboardv2")
        .directive('sumBar', sumBar);

    sumBar.$inject = ['dashboard_path'];

    /**
     * @module sumBar
     * @param dashboard_path
     * @return {{restrict: string, scope: {}, templateUrl: string, controller: sumBarController, controllerAs: string, bindToController: boolean}}
     */
    function sumBar(dashboard_path) {
        var directive = {
            restrict: 'EA',
            scope: {},
            templateUrl: dashboard_path + 'sumbar/dashboard.sumbar.html',
            controller: sumBarController,
            controllerAs: 'vm',
            bindToController: true
        };

        sumBarController.$inject = ['$scope', 'websitesFactory', 'dashboardServicev2', 'dashboardFactoryv2'];

        /**
         * Controller for the module sumBar
         *
         * @method sumBarController
         * @param $scope
         * @param websitesFactory
         * @param dashboardServicev2
         * @param dashboardFactoryv2
         */
        function sumBarController($scope, websitesFactory, dashboardServicev2, dashboardFactoryv2) {
            var loaded = false;
            var vm = this;
                vm.active = false;
                vm.users = 0;
                vm.orderValue = 0;
                vm.conversion = 0;
                vm.revenue = 0;

            function init() {

            }

            /**
             * Get notification when Google Analytics has access
             *
             * @event active
             * @param status {boolean}
             */
            $scope.$on("active", function (ev, status) {
                vm.active = status;

                if(status) {
                    loadGaElements()
                }
            });

            /**
             * Load Google Analytics elements
             *
             * @method loadGaElements
             */
            function loadGaElements() {
                dashboardServicev2.gapiReady()
                    .then(function () {
                        loadEcommerceData();

                    });
            }

            /**
             * Load the ecommerce data from Google Anayltics
             *
             * @method loadEcommerceData
             */
            function loadEcommerceData() {
                var id = dashboardFactoryv2.getViewId();
                dashboardServicev2.getRevenue(id)
                    .then(function (revenue) {
                        vm.revenue = revenue;
                    });
                dashboardServicev2.getConversion(id)
                    .then(function (conversion) {
                       vm.conversion = conversion;
                    });
                dashboardServicev2.getOrderValue(id)
                    .then(function (orderValue) {
                        vm.orderValue = orderValue;
                    });
                dashboardServicev2.getVisitors(id, {
                    statDate: '30daysAgo',
                    endDate: 'today',
                    container: 'sumUsers'
                })
                    .then(function (users) {
                        vm.users = users
                    })
            }

            $scope.$watch(function () {
                return websitesFactory.selected
            }, function (website) {
                if (website && websitesFactory.getSelectedWebsite()) {
                    reset();
                    init();
                }
            });

            function reset() {

            }
        }

        return directive;
    }
})();

(function(){
    "use strict";

    angular.module("app.dashboardv2")
        .directive("dashboardSales", dashboardSales2);

    dashboardSales2.$inject = ['dashboard_path'];
    /**
     * Provide the website info and test status data
     *
     * @module dashboardSales2
     * @param dashboard_path
     * @return {{restrict: string, scope: {}, templateUrl: string, controller: dashboardSalesController, controllerAs: string, bindToController: boolean}}
     */
    function dashboardSales2(dashboard_path) {
        var directive = {
            restrict: 'EA',
            scope: {},
            templateUrl : dashboard_path + 'sales/dashboard.sales.html',
            controller: dashboardSalesController,
            controllerAs: 'vm',
            bindToController: true
        };

        dashboardSalesController.$inject = ['$scope', 'websitesFactory', 'dashboardServicev2', 'dashboardFactoryv2'];

        /**
         * Controller for the module
         *
         * @method dashbaordSalesController
         * @param $scope
         * @param websitesFactory
         * @param dashboardServicev2
         * @param dashboardFactoryv2
         */
        function dashboardSalesController($scope, websitesFactory, dashboardServicev2, dashboardFactoryv2) {
            var vm = this;
            vm.websiteInfo = {
                loading: false,
                online_status: false,
                last_loadtime_date: 0,
                last_loadtime: 0
            }

            vm.suiteInfo = {
                last_suite_run: false
            }

            vm.testInfo = [];

            function init() {
                var websiteid = websitesFactory.getSelectedWebsite()["id"];

                if(websiteid) {
                    getGeneralInfo(websiteid);
                }
            }

            /**
             * Get the general info for the dashboard
             *
             * @method getGeneralInfo
             * @param websiteid
             */
            function getGeneralInfo(websiteid) {
                dashboardServicev2.getGeneralInfo(websiteid)
                    .then(function () {
                        vm.websiteInfo = dashboardFactoryv2.getWebsiteInfo();
                        vm.suiteInfo = dashboardFactoryv2.getSuiteInfo();
                        vm.testInfo = dashboardFactoryv2.getTestInfo();
                    });
            }


            /**
             * Get online label
             *
             * @method isOnline
             * @param bool
             * @return {string}
             */
            vm.isOnline = function (bool) {
                if(bool) {
                    return "online";
                } else {
                    return "offline";
                }
            }

            /**
             * Get passing label
             *
             * @method isPassing
             * @param bool
             * @return {string}
             */
            vm.isPassing = function (bool) {
                if(bool) {
                    return "Goed";
                } else {
                    return "Fout";
                }
            }

            $scope.$watch(function () {
                return websitesFactory.selected
            }, function (website) {
                if (website && websitesFactory.getSelectedWebsite()) {
                    reset();
                    init();
                }
            });

            function reset() {

            }
        }

        return directive;
    }
})();

 (function(){
   "use strict";

   angular.module("app.dashboardv2")
       .directive("dashboardGeneral", dashboardGeneral);

   dashboardGeneral.$inject = ['dashboard_path'];
    /**
     * Directive for the general info for the dashboard
     *
     * @module dasboardGeneral
     * @param dashboard_path
     * @returns {{restrict: string, scope: {}, templateUrl: string, controller: dasboardGeneralController, controllerAs: string, bindToController: boolean}}
     */
   function dashboardGeneral(dashboard_path) {
    var directive = {
        restrict: 'EA',
        scope: {},
        templateUrl: dashboard_path + 'general/dashboard.general.html',
        controller: dasboardGeneralController,
        controllerAs: 'vm',
        bindToController: true
    };

    dasboardGeneralController.$inject = ['$scope', 'websitesFactory', 'dashboardServicev2', 'dashboardFactoryv2'];

        /**
         * Controller for the dashboardGeneral module
         *
         * @class dashboardController
         * @param $scope
         * @param websitesFactory
         * @param dashboardServicev2
         * @param dashboardFactoryv2
         */
    function dasboardGeneralController($scope, websitesFactory, dashboardServicev2, dashboardFactoryv2) {
        var vm = this;
        vm.active = false;
        vm.today = {
            loading: true,
            today_orders: 0,
            today_revenue: 0
        };

        vm.visitor = {
            loading: true,
            count: 0
        }

        vm.history = {
            loading: true,
            orders_30_days: 0,
            orders_last_month: 0,
            orders_last_year_difference: 0,
            revenue_30_days: 0,
            revenue_last_month: 0,
            revenue_last_year_difference: 0
        }
        function init() {
            var id = websitesFactory.getSelectedWebsite()["id"];
            if(id) {
                getSales(id);
            }
        }

            /**
             * Get Sales info
             *
             * @method getSales
             * @param websiteid
             * @return {void}
             */
        function getSales(websiteid) {
            dashboardServicev2.getSales(websiteid)
                .then(function () {
                    vm.today = dashboardFactoryv2.getTodayData();
                    vm.history = dashboardFactoryv2.getHistoryData();
                });
        }

            /**
             * Load Google Analytics API
             *
             * @method loadGaElements
             * @return {void}
             */
        function loadGaElements() {
            dashboardServicev2.gapiReady()
                .then(function () {
                   _loadVisitors();
                });
        }

            /**
             * Loads the visitors stats
             *
             * @method _loadVisitors
             * @private
             * @return {Promise}
             */
        function _loadVisitors() {
            var id = dashboardFactoryv2.getViewId();
            dashboardServicev2.getVisitors(id, {
                startDate: 'today',
                endDate: 'today',
                container: 'generalusers'
            })
                .then(function (count) {
                    vm.visitor.loading = false;
                    vm.visitor.count = count;
                });
        }

            /**
             * Create a numeral
             *
             * @method createNumeral
             * @param val
             * @param format
             */
        vm.createNumeral = function(val, format) {
            return numeral(val).format(format);
        }

            /**
             * Get overall percentage
             *
             * @method overallpercentage
             * @param percentage
             * @return {*}
             */
        vm.overallpercentage = function (percentage) {
            var newPercentage = _getAllPercentage(percentage);

            switch(newPercentage) {
                case 'positive':
                        return "+ " + percentage;
                    break;
                case 'nothing':
                        return percentage;
                    break;
                case 'negative':
                        return "- " + Math.sqrt(percentage*percentage);
                    break;

            }
        }

            /**
             * Get classname by percentage
             *
             * @method overallpercentageClass
             * @param percentage
             * @return {string}
             */
        vm.overallpercentageClass = function (percentage) {
            return _getAllPercentage(percentage);
        }

            /**
             * Get All Percentage
             *
             * @method _getAllPercentage
             * @param percentage
             * @return {string}
             * @private
             */
        function _getAllPercentage(percentage) {
            var percentage = Math.sign(percentage);

            if(percentage > 0) {
                return "positive";
            } else if (percentage === 0 ) {
                return "nothing";
            } else if( percentage === -1) {
                return "negative";
            }

        }

            /**
             * @event Website Switch
             */
        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                reset();
                init();
            }
        });

            /**
             * Get notification when Google Analytics has access
             *
             * @event active
             * @param status {boolean}
             */
        $scope.$on("active", function (ev, status) {
            vm.active = status;

            if(status) {
                loadGaElements()
            }
        });

        function reset() {

        }
    }

        return directive;
   }
})();

(function () {
    'use strict';

    angular.module('app.dashboardv2')
        .directive('dashboardCms', dashboardCms);

    dashboardCms.$inject = ['dashboard_path'];

    function dashboardCms(dashboard_path) {
        var directive = {
            restrict: 'EA',
            scope: {
                data: '=',
                uistate: '@'
            },
            templateUrl: dashboard_path + 'cms/dashboard.cms.html',
            controller: dashboardCmsController,
            controllerAs: 'vm',
            bindToController: true
        };

        dashboardCmsController.$inject = ['$scope', 'websitesFactory', '$state'];

        function dashboardCmsController($scope, websiteFactory, $state) {
            var vm = this;
                vm.title = '';
                vm.table = [];
                vm.loaded = false;
                vm.id = 0;

            $scope.$watch(function () {
                return vm.data
            }, function (data) {
                if(data) {
                    vm.table = [];
                    setData(data);
                }
            });

            $scope.$watch(function () {
                return websiteFactory.selected;
            }, function (website) {
               if (website) {
                   vm.id = website.id;
               }
            });

            vm.gotoState = function (parent, child) {
                $state.go(vm.uistate, {id: vm.id, group: parent, single: child});
            }

            /**
             *  setData
             *  Create the tr rows for the table
             *  @param data {Object}
             */
            function setData(data) {
                vm.title = data.title;
                var parent = data.slug;
                var maxItems = data.children.length - 1;

                // Get childs
                data.children.forEach(function (item, idx) {
                    var parentChild = item.slug;

                    //First child items
                    var firstItem = {
                        type: 'header',
                        title: item.title,
                        slug: item.slug,
                        parent: parent,
                        status: item.status,
                        class: 'none'
                    }

                    vm.table.push(firstItem);

                    //Sub child items
                    if(item.children.length > 0) {
                        item.children.forEach(function (val) {

                            var childItem = {
                                type: 'item',
                                title: val.title,
                                slug: val.slug,
                                parent: parentChild,
                                status: val.status,
                                class: 'none'
                            }

                            vm.table.push(childItem);
                        });
                    };

                    if (maxItems !== idx) {
                        var clearBoth = {
                            type: 'clear',
                            title: '',
                            slug: '',
                            parent: '',
                            class: 'clearboth'
                        }

                        vm.table.push(clearBoth);
                    }

                    vm.loaded = true;
                });
            }
        }

        return directive;
    }

})();

(function () {
    "use strict";

    angular.module('app.custompage.custom', []);
})();

(function () {
    "use strict";

    angular.module('app.custompage.custom')
        .controller("customController", CustomController)

    function CustomController($state, cmsService, $sce) {
        var vm = this;
            vm.html = "";
            vm.title = "";

        function init() {
            var slug = $state.params.slug;

            if(slug.length > 0) {
                getContent(slug);
            }
        }

        function getContent(slug) {
            cmsService.getSinglePage(slug)
                .then(function(data) {
                    var content = data.content;

                    if(content.length > 0) {
                        vm.title = data.title;
                        vm.html = content;
                    } else {
                        vm.title = "404";
                        vm.html = "Er is helaas geen content beschikbaar";
                    }
                });
        }

        vm.getHTML = function(content) {
            return $sce.trustAsHtml(content);
        }

        init();
    }
})();

(function () {
    "use strict";

    angular.module('app.custompage.custom')
        .config(config)

    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.custompage.custom', {
                url: '/:slug',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/custompage/custom/custom.html',
                        controller: 'customController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('CustomPage', {
            title: '',
            icon: 'icon-resize-bottom-right',
            state: 'app.custompage.custom',
            class: '500',
            weight: 60
        });
    }
})();

(function () {
    angular.module('app.cms.widgets', []);
})();

(function () {
    angular.module('app.cms.widgets')
        .directive('cmsWidget', cmsWidget);

    function cmsWidget() {
        var directive = {
            restrict: 'EA',
            scope: {
                load: '='
            },
            controller: cmsWidgetController,
            templateUrl: 'app/main/cms/widgets/cms.widgets.html',
            controllerAs: 'vm',
            bindToController: true
        };

        cmsWidgetController.$inject = ['$scope', 'dashboardServicev2', 'websitesFactory', 'cmsService'];

        function cmsWidgetController($scope, dashboardServicev2, websiteFactory, cmsService) {
            var vm = this;
                vm.id = 0;
                vm.hideloading = false;
                vm.cmsData = {
                    list: [],
                    loaded: false
                }
                vm.uistate = "";
                vm.cmsItem = [];
                vm.adBlockTable = {
                    loaded: false,
                    data: []
                };

            function init() {
                switch (vm.load.name) {
                    case 'Adblock':
                        getAdBlock();
                        break;
                    case 'cmsConversion':
                            vm.uistate = "app.websites.dashboard.increasevisitor.group.single";
                            getCmsPages(0);
                        break;
                    default:
                        vm.hideloading = true;
                }
            }

            function getCmsPages(index) {
                dashboardServicev2.getCmsParentPage()
                    .then(function (cmsData) {
                        vm.cmsData.list = cmsData;
                        vm.cmsItem = cmsData[index];
                        vm.cmsData.loaded = true;
                        vm.hideloading = true;
                    });
            }

            function getAdBlock() {
                void 0;
                cmsService.getAdBlock(vm.id)
                    .then(function (table) {
                        vm.adBlockTable.loaded = true;
                        vm.adBlockTable.data = table;

                    })
                    .catch(function () {
                        vm.adBlockTable.loaded = false;
                    });
            }

            $scope.$watch(function () {
                return vm.load.isset;
            }, function (load) {
                if (load) {
                    init();
                }
            });

            $scope.$watch(function () {
                return websiteFactory.selected;
            }, function (website) {
                if (website) {
                    vm.id = website.id;
                    init();
                }
            });
        }

        return directive;
    }
})();

(function () {
    'use strict';

    angular.module('app.cms.single', [])
})();

(function () {
    'use strict';

    angular.module('app.cms.single')
        .controller('cmsSingleController', cmsSingleController)

    function cmsSingleController($state, cmsService) {
        var vm = this;
        vm.loaded = false;
        vm.title = '';
        vm.content = '';
        vm._data = {};
        vm.widget = {
            isset: false,
            name: '',
            description: ''
        }

        function init() {
            var slug = $state.params.single;
            cmsService.getSinglePage(slug)
                .then(function (data) {
                    void 0;
                    vm._data = data;
                    vm.title = data.title;
                    vm.content = data.content;
                    vm.loaded = true;
                    if(data.widget) {
                        vm.widget.isset = true;
                        vm.widget.name = data.widget.name;
                        vm.widget.description = data.widget.description;
                    }
                });
        }

        vm.renderHtml = function (html) {
            return html;
        }

        init();
    }
})();

(function () {
    'use strict';

    angular.module('app.cms.single')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('app.websites.cms.group.single', {
                url: '/:single',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/single/cms.single.html',
                        controller: 'cmsSingleController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increasevisitor.group.single', {
                url: '/:single',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/single/cms.single.html',
                        controller: 'cmsSingleController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.ga.group.single', {
                url: '/:single',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/single/cms.single.html',
                        controller: 'cmsSingleController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increaseorders.group.single', {
                url: '/:single',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/single/cms.single.html',
                        controller: 'cmsSingleController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.cms.group', [])
})();

(function () {
    'use strict';

    angular.module('app.cms.group')
        .controller('cmsGroupController', cmsGroupController)

    function cmsGroupController($state, cmsService) {
        var vm = this;
            vm.loaded = false;
            vm.title = '';
            vm.content = '';
            vm._data = {};

        function init() {
            var slug = $state.params.group;
            cmsService.getSinglePage(slug)
                .then(function (data) {
                    vm._data = data;
                    vm.title = data.title;
                    vm.content = data.content;
                    vm.loaded = true;
                });
        }

        vm.renderHtml = function (html) {
            return html;
        }

        init();
    }
})();

(function () {
    'use strict';

    angular.module('app.cms.group')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('app.websites.cms.group', {
                url: '/:group',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/group/cms.group.html',
                        controller: 'cmsGroupController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increasevisitor.group', {
                url: '/:group',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/group/cms.group.html',
                        controller: 'cmsGroupController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.ga.group', {
                url: '/:group',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/group/cms.group.html',
                        controller: 'cmsGroupController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increaseorders.group', {
                url: '/:group',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/group/cms.group.html',
                        controller: 'cmsGroupController as vm'
                    }
                }
            });
    }
})();

(function () {
    angular.module('app.cms.breadcrumbs', []);
})();

(function () {
    angular.module('app.cms.breadcrumbs')
        .directive('cmsBreadcrumbs', cmsBreadcrumbs)

    function cmsBreadcrumbs() {
        var directive = {
            restrict: 'EA',
            scope: {
                data: '='
            },
            controller: cmsBreadCrumbsController,
            templateUrl: 'app/main/cms/breadcrumbs/cms.breadcrumbs.html',
            controllerAs: 'vm',
            bindToController: true
        }

        cmsBreadCrumbsController.$inject = ['$scope', 'dashboardServicev2', 'websitesFactory', '$state'];

        function cmsBreadCrumbsController($scope, websiteFactory, $state) {
            var vm = this;
                vm.id = 0;
                vm.crumbs = [];
                vm.root = $state.current.name;
                vm.rootState = "";

            function init() {
                if (vm.data) {
                    parseCrumb(vm.data);
                }

                var str = vm.root.split(".");
                vm.rootState = str[0] + '.' + str[1]  + '.' + str[2] + '.' + str[3];
            }

            function parseCrumb(data) {
                var obj = {
                    slug: data.slug,
                    title: data.title
                };



                if(data.parent) {
                    obj.parent = data.parent.slug;
                    vm.crumbs.push(obj);
                    parseCrumb(data.parent)
                } else {
                    obj.parent = null;
                    vm.crumbs.push(obj);
                    vm.crumbs.reverse();
                }
            }

            vm.gotoState = function(parent, slug, idx) {
                switch (idx) {
                    case 2:
                        $state.go(vm.rootState + '.group.single', {id: vm.id, group: parent, single: slug});
                        break;
                    case 1:
                        $state.go(vm.rootState + '.group', {id: vm.id, group: parent});
                        break;
                    case 0:
                        $state.go(vm.rootState, {id: vm.id})
                }

            }

            $scope.$watch(function () {
                return vm.data
            }, function (data) {
                if(Object.keys(data).length > 0) {
                    vm.crumbs = [];
                    init();
                }
            });

            $scope.$watch(function () {
                return websiteFactory.selected;
            }, function (website) {
                if (website) {
                    vm.id = website.id;
                }
            });
        }

        return directive;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'chart.js'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService, websitesFactory)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
            $scope.testsuite = websitesFactory.getTestsuiteStatus();
            
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        $scope.$watch(function () {
            return websitesFactory.websiteTestSuite
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                init()
            }
        });
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';
    angular.module('app.user-reset-password-step-3', [])
    .config(config)

    /**
     * @module app.user-reset-password-step-3
     */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
        .state('app.user_reset-password-step-3', {
            url: "/reset-password/step-3?stk&um",
            views: {
                'main@': {
                    templateUrl: 'app/user/login/login.html',
                    controller : 'LoginController as vm'
                },                
                'content@app.user_reset-password-step-3': {
                    templateUrl: 'app/user/reset-password-step-3/reset-password-step-3.html',
                    controller: 'ResetPasswordStep3Controller as vm'
                }
            }
        });

         $translatePartialLoaderProvider.addPart('app/user/reset-password-step-3'); 
    }
})();
(function(){
    'use strict';

    angular.module('app.user-reset-password-step-3')
    .service('ResetPasswordStep3Service', ResetPasswordStep3Service);

    function ResetPasswordStep3Service($http, $q, portal_path) {
        var api = {};

        /*
        *   Send new password with token and email to verify on the server
        *
        *   @return (void)
        */
        api.authPassword = function(email, token, password) {
            var response = $q.defer();

            $http({
                method: 'PUT',
                url: portal_path + 'auth/password',
                data: {
                    email: email,
                    token: token,
                    password: password
                }
            }).then(function( res ) {
                if(res.status === 204) {
                    response.resolve({
                        message: "Password has been changed successfully!"
                    });
                } else {
                    response.reject({
                        err: res.status,
                        message: res.data.error.message
                    });
                }
            })

            return response.promise;
        }

        return api;
    }
})();

(function(){
    'use strict';

    angular.module('app.user-reset-password-step-3')
    .controller('ResetPasswordStep3Controller', ResetPasswordStep3Controller)

    /**
     * @class ResetPasswordStep3Controller
     */
    function ResetPasswordStep3Controller(ResetPasswordStep3Service, $state, $stateParams, $scope) {
        var vm = this;
        vm.newPass = newPass;
        vm.showError = false;
        vm.passIsChanged = false;
        vm.errMessage = '';
        vm.formStep3Disabled = true;
        vm.init = init;
        // vm.form = {};
        // vm.form.password = "";
        // vm.form.password2 = "";

        /**
         *  Initial function for this controller checks if params are set
         * @method init
         */
        function init() {

            if(typeof $stateParams.stk != 'undefined') {
                localStorage.setItem('resetToken', $stateParams.stk);
            }

            if(typeof $stateParams.um != 'undefined') {
                var uri = decodeURIComponent($stateParams.um);
                localStorage.setItem('resetMail', uri);
            }

        }

        /**
         * Checks if token en email is not empty or null
         * @method newPass
         */
        function newPass() {
            var email = localStorage.getItem('resetMail');
            var token = localStorage.getItem('resetToken');

            if(email != null && email != '' && token != null && token != '') {
                ResetPasswordStep3Service.authPassword(email, token, vm.form.password)
                .then(function(data){
                    localStorage.removeItem('resetMail');
                    localStorage.removeItem('resetToken');
                    vm.passIsChanged = true;

                    //$state.go('app.login');
                }).catch(function(err){
                    vm.showError = true;
                    vm.errMessage = err.message;
                });
            }
        }

        /**
         * Password compare
         * @method passwordCheck
         */
        vm.passwordCheck = function() {
            var pass1 = (vm.form.password || '').trim();
            var pass2 = (vm.form.password2 || '').trim();



            if(pass2.length >= 6 && pass1.length >= 6) {

                if(pass1 === pass2) {
                    vm.formStep3Disabled = false;
                } else {
                    vm.formStep3Disabled = true;
                }

            } else {
                vm.formStep3Disabled = true;
            }
            
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.user-reset-password-step-2', ['app.user-reset-password-step-3'])
    .config(config)

    /**
     * @module app.user-reset-password-step-2
     */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
        .state('app.user_reset-password-step-2', {
            url: "/reset-password/step-2",
            views: {
                'main@': {
                    templateUrl: 'app/user/login/login.html',
                    controller : 'LoginController as vm'
                },                
                'content@app.user_reset-password-step-2': {
                    templateUrl: 'app/user/reset-password-step-2/reset-password-step-2.html',
                    controller: 'ResetPasswordStep2Controller as vm'
                }
            }
        });

         $translatePartialLoaderProvider.addPart('app/user/reset-password-step-2'); 
    }

})();
(function(){
    angular.module('app.user-reset-password-step-2')
    .controller('ResetPasswordStep2Controller', ResetPasswordStep2Controller);

    /**
     * @class ResetPasswordStep2Controller
     */
    function ResetPasswordStep2Controller($state) {
        var vm = this;
        vm.verifyCode = verifyCode;
        vm.codeIsVerified = true;
        vm.mailIsset = false;
        vm.usermail = '';
        vm.code = '';

        /**
         * Checks if the verifyCode is not empty 
         * @method verifyCode
         */
        function verifyCode() {
            if(vm.code != '') {
                localStorage.setItem('resetToken', vm.code);
                $state.go('app.user_reset-password-step-3'); 
            }
        }
    }
})();
(function(){
    'use strict';

    angular.module('app.user-reset-password-step-1', ['app.user-reset-password-step-2'])
    .config(config);

    /**
     * Password reset step one
     * 
     * @module app.user-reset-password-step-1
     */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
        .state('app.user_reset-password-step-1', {
            url: "/reset-password/step-1",
            views: {
                'main@': {
                    templateUrl: 'app/user/login/login.html',
                    controller : 'LoginController as vm'
                },
                'content@app.user_reset-password-step-1': {
                    templateUrl: 'app/user/reset-password-step-1/reset-password-step-1.html',
                    controller: 'ResetPasswordController as vm'
                }
            }
        });

         $translatePartialLoaderProvider.addPart('app/user/reset-password-step-1'); 
    }
})();
(function () {
    'use strict';

    angular.module('app.user-reset-password-step-1')
        .service('ResetPasswordService', ResetPasswordService);
    
    /**
     * @class ResetPasswordService
     */
    function ResetPasswordService($http, $q, portal_path) {
        var api = {};

        /**
         * Send a put request to the server with email a data body
         * 
         * @method authPassword
         * @param {String} email
         */
        api.authPassword = function(email) {
            $http({
                method: 'PUT',
                url: portal_path + 'auth/password',
                data: {
                    email: email
                }
            });
        }

        return api;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.user-reset-password-step-1')
        .controller('ResetPasswordController', ResetPasswordController);
    /**
     * @class ResetPasswordController
     */
    function ResetPasswordController($state, msApi, ResetPasswordService) {
        var vm = this;
        vm.sendCode = sendCode;
        vm.isSend = false;

        /**
         * Send a password token to the user
         * @method sendCode
         */
        function sendCode() {
            
            if(vm.isSend) {
                $state.go('app.user_reset-password-step-2');
                return; 
            }

            localStorage.setItem('resetMail', vm.form.email);
            ResetPasswordService.authPassword(vm.form.email);
            vm.isSend = true;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.login', ['app.user-reset-password-step-1'])
        .config(config);

    /** @ngInject */
    /**
     * App login module contains user login and password reset
     * @module app.login
     */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.login', {
                url    : '/login',
                views  : {
                    'main@': {
                        templateUrl: 'app/user/login/login.html',
                        controller : 'LoginController as vm'
                    },
                    'content@app.login': {
                        templateUrl: 'app/user/login/login-form.html'
                    }
                }
            });

            $translatePartialLoaderProvider.addPart('app/user/login'); 
    }
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    /**
     * @class LoginController
     * @constructor
     */
    function LoginController($scope, $location, $window, $rootScope, api, $state) {
        var vm = this;

        // Variables
        vm.login = login;
        vm.loginFail = false;

        /**
         * Remove the splash screen
         * @event viewContentAnimationEnded
         */
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        /**
         * Login user by username and password
         * @method login
         * @return {void}
         */
        function login() {
            var email = vm.form.email;
            var password = vm.form.password;

            api.Login(email, password)
            .then(function (item) {
                if (item.data.status === "success") {
                    localStorage.setItem("userToken", item.data.data[0]);
                    localStorage.setItem("userMail", email);
                    var startPage = localStorage.getItem('startPage');

                    if (startPage) {
                        $state.go(startPage);
                    } else {
                        $window.location.assign('/website/0/dashboard');
                    }
                } else {
                    vm.loginFail = true;
                }
            });
        }
    }
})();

(function(){
    'use strict';

    angular.module('wootric', []);

})();
(function () {
    'use strict';

    angular.module('wootric')
        .factory('wootricFactory', wootricFactory)

    function wootricFactory(wootric) {

        return {
            run: function () {
                if (wootric) {
                    window.wootric("run");
                }
            },
            settings: function() {
                var usermail = localStorage.getItem("userMail");
                window.wootricSettings = {
                    email: usermail,// TODO: The current logged in user's email address.
                    created_at: 1234567890, // TODO: The current logged in user's sign-up date as a 10 digit Unix timestamp.
                    account_token: 'NPS-f98d7ac9' // This is your unique account token.
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('wootric')
        .controller('wootricController', wootricController)

    function wootricController(wootricFactory) {

        function init() {
            wootricFactory.settings();
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = "//disutgh7q0ncc.cloudfront.net/beacon.js";

            script.onreadystatechange = wootricrun;
            script.onload = wootricrun;

            // Fire the loading
            head.appendChild(script);
        }

        function wootricrun() {
            wootricFactory.run();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.insights.dashboard.widgets')
        .service('widgetService', widgetService);
    /**
     * Service for the widgets
     *
     * @class widgetService
     * @constructor
     */
    function widgetService(portal_path, $http, $q, websitesFactory) {
        var api = {};

        /**
         *  Get widgets of dashboard with the widget options;
         *  @method getWidgets
         *  @param {int} id
         */
        api.getWidgets = function (id) {
            var results = $q.defer();
            $http({
                method: 'GET',
                url: portal_path + 'dashboards/' + id + '/widgets'
            })
                .then(function (req) {
                    results.resolve(req.data.data);
                })
                .catch(function (req) {
                    results.reject(req.data.error.message);
                });
            return results.promise;
        }

        /**
         * Get data from widgets by datacode and options
         * @param {String} datacode
         * @param {object} options
         */
        api.getWidgetData = function (dataCode, options) {
            var result = $q.defer();

            $http({
                method: "POST",
                url: portal_path + "data/" + dataCode,
                data: _getWidgetBody(options)
            }).then(function (req) {
                var headerNotfoud = true;
                var header = req.headers("Content-Type").split(";")[0];

                if (header === "application/json") {
                    headerNotfoud = false;
                    result.resolve({
                        items: req.data.data,
                        options: options
                    })
                }

                if (header === "text/plain" || header === "text/csv") {
                    headerNotfoud = false;
                    result.resolve(
                        {
                            items: req.data,
                            options: options
                        });
                }

                if(headerNotfoud) {
                    void 0;
                }
            });

            return result.promise;
        }

        /**
         * Update the option of a widget
         * @method updateWidgetOptions
         * @param {object} options
         */
        api.updateWidgetOptions = function (opt) {
            $http({
                method: "PATCH",
                url: portal_path + "websites/" + opt.website + "/tabs/tab-" + opt.tab + "/blocks/"+opt.id+"/",
                data: {
                    options: {
                        interval: 300,
                        date_range: opt.options.date_range,
                        range_start: opt.options.range_start,
                        range_end: opt.options.range_end,
                        store: opt.options.store
                    }
                }
            });
        }

        return api;
    }

    /**
     * This private method sets the default value of a daterange option
     * 
     * @method _getWidgetBody
     * @param {object} options
     * @return {Object}
     */
    function _getWidgetBody(options) {
        var opt = {};
        opt.website = options.website;
        opt.interval = options.options.interval;
        opt.store = 1

        switch (options.options.date_range) {
            case "1d":
                opt.range_start = moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00");
                break;
            case "1w":
                opt.range_start = moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00");
                break;
            case "1m":
                opt.range_start = moment().subtract(1, "month").format("YYYY-MM-DD 00:00:00");
                break;
            case "1y":
                opt.range_start = moment().subtract(1, "years").format("YYYY-MM-DD 00:00:00");
                break;
            case "lv":
                opt.range_start = moment().subtract(50, "years").format("YYYY-MM-DD 00:00:00");
                break;
            case "cu":
                opt.range_start = options.options.range_start
                opt.range_end = options.options.range_end;
                break;
            default:
                opt.range_start = moment().subtract(7, "days").format("YYYY-MM-DDT00:00:00");
                break;
        }
        return opt;
    }
})();

(function () {
    "use strict";

    angular.module("app.insights.dashboard.widgets")
        .factory("WidgetsFactory", WidgetsFactory)

    function WidgetsFactory() {
        var api = {};
        api.data = [];

        api.setData = function (item) {
            this.data.push(item)
        }

        api.findByIdWithDataCode = function (id, dataCode) {
            return this.data.filter(function (value, index) {
                if (value.options["data_code"] === dataCode && value.options.website === id) {
                    return value;
                }
            });
        }

        api.deleteWidgetByIdAndDataCode = function(id, dataCode) {
            var idx = 0;

            this.data.filter(function(value,index) {
                if(value.options["data_code"] === dataCode && value.options.website === id) {
                    idx = index;
                }
            });

            delete this.data[idx];

        }

        api.clearData = function () {
            this.data = [];
        }

        return api;
    }
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .controller('WidgetsController', WidgetsController);
    /**
     * Controller for the widget builder
     *
     * @class WidgetsController
     * @constructor
     */
    function WidgetsController($scope, widgetService, websitesFactory) {
        var vm = this;
        vm.data;

        $scope.$on('newBoard', function (ev, data) {
            vm.data = [];
            vm.stores = websitesFactory.getStores();
            loadWidgets(data);
        });

        /**
         * loadWidgets by dashboardid
         * 
         * @method loadWidgets
         * @param {object} data
         * @return {void}
         */
        function loadWidgets(data) {
            var widgets = data.widgets;
     
            widgets.forEach(function(item){
                vm.data.splice(item.order, 0, item);
            });
        }
    };
})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets')
    .constant('widget_template_URI', 'app/main/widgets/templates/')
    .constant('widget_specific_URI', 'app/main/widgets/charts/')
    .constant('widget_module_URI', 'app/main/widgets/modules/')
    .constant('widget_API_URI', 'app/main/widgets/api/');
})();
(function(){
    'use strict';

    angular.module('app.insights.dashboard.widgets')
    .config(config);

    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/widgets');
    }
})();
(function () {
    'use strict';

    angular.module('app.insights.dashboard.widgets')
        .directive('widgetBuilder', widgetBuilder);

    var isnewSettings = true;
    var Factory;
    var promise;
    /**
     * Builds the dashboard with widgets
     *
     * @class widgetBuilder
     * @constructor
     */
    function widgetBuilder(widget_module_URI, $http, $compile, $templateCache, widgetService, $parse, WidgetsFactory, $q) {
        var tmpl = {};
        tmpl.scope = {
            settings: '=',
            stores: '=',
            tab: '@'
        };
        tmpl.transclude = true,
            tmpl.link = function (scope, element, attr) {
                Factory = WidgetsFactory;
                promise = $q;

                var moduleURI = getTemplateUrl(scope.settings.widget, widget_module_URI);
                scope.options = [];
                scope.isLoading = true;

                scope.settings.tab = scope.tab;
                loadTemplate(moduleURI, $http, $templateCache, $compile, scope, element);
                loadData(scope.settings, widgetService)
                    .then(function (data) {

                        if (data.isset === undefined) {
                            Factory.setData(data);
                        }

                        scope.options = data.items;
                        scope.setup = data.options;
                    });

                /**
                 * Gets triggerd when parsing_done of the widget is done
                 *
                 * @event parsing_done
                 */
                scope.$on("parsing_done", function (ev, data) {
                    scope.isLoading = false;
                });

                /**
                 * This event get fired when the settings of a widget gets updated
                 * @event update_settings
                 */
                scope.$on("update_settings", function (ev, data) {
                    widgetService.updateWidgetOptions(data);
                    scope.options = [];
                    scope.isLoading = true;

                    Factory.deleteWidgetByIdAndDataCode(data.website, data.data_code);
                    loadData(data, widgetService).then(function (data) {
                        if (data.isset === undefined) {
                            Factory.setData(data);
                        }

                        scope.options = data.items;
                        scope.setup = data.options;
                    });
                });

                /**
                 * Fired when storeview of the webshop changed
                 * @event storeview_selected
                 */
                scope.$on('storeview_selected', function (ev, value) {
                    scope.storeView = value.website + ' - ' + value.name;
                });
            };

        return tmpl;
    }

    /**
    * Determine which type it is and returns template URI
    * @method getTemplateUrl
    * @param {String} templateType
    * @param {String} widgetModuleURI
    * @return {void}
    */
    function getTemplateUrl(templateType, widgetModuleURI) {

        if(templateType) {
            var templateTypeArr = templateType.split("-");
        } else {
            var templateTypeArr = null;
        }

        var templateURI = '';
        var templateList = ["magento-orders", "magento-sales", "magento-module_versions", "magento-module_outdated", "magento-module_manual", "magento-module_count", "website-responsetime", "website-environment_info", "magento-magento_versions"];

        if (templateList.indexOf(templateType) > -1) {
            templateURI = widgetModuleURI + templateTypeArr[0] + '/' + templateTypeArr[1] + '/' + templateTypeArr[1] + '.html';
        } else {
            templateURI = widgetModuleURI + '/basic/text/text.html';
        }

        return templateURI;
    }

    /**
    *  Load template by template url
    * @method loadTemplate
    * @param {String} templateURI
    * @param {Function} $http
    * @param {Object} $templateCache
    * @param {Object} $compile
    * @param {Object} scope
    * @param {Object} element
    *
    * @return {void}
    */
    function loadTemplate(templateURI, $http, $templateCache, $compile, scope, element) {
        $http.get(templateURI, { cache: $templateCache })
            .success(function (templateContent) {
                element.replaceWith($compile(templateContent)(scope))
            });
    }

    /**
    *   Load The data for the widget
    *   @method loadData
    *   @param {String} type
    *   @param {Object} options
    *   @param {int} websiteid
    *   @param {Object} widgetService
    *   @return {Promise|Object}
    */
    function loadData(settings, widgetService) {
        var websiteId = settings.website;
        var len = settings.options
        var items = Factory.findByIdWithDataCode(websiteId, settings.data_code);

        if (items.length > 0) {
            return promise.resolve({
                items: items[0].items,
                options: items[0].options,
                isset: true
            });
        } else {

            var options = _getOptions(settings, widgetService);
            return widgetService.getWidgetData(settings.data_code, options);
        }
    }

    /**
    *   Check if options isset else load default value
    *   @method _getOptions
    *   @param {Object} settings
    *   @param {Object} widgetService
    *
    *   @return {object}
    */
    function _getOptions(settings, widgetService) {

        if (settings['options'].hasOwnProperty('interval')) {
            return settings;
        } else {
            var saveOption = _getDefaultOptionsByType(settings.data_code);
            saveOption.website = settings.website;
            saveOption.id = settings.id;
            saveOption.data_code = settings.data_code;
            saveOption.tab = settings.tab;

            widgetService.updateWidgetOptions(saveOption);

            return saveOption;
        }
    }

    /**
    *   set default options
    *   @method _getDefaultOptionsByType
    *   @param {String} type
    *
    *   @return {object}
    */
    function _getDefaultOptionsByType(type) {
        var opt = {};
        opt.options = {};
        opt.options.interval = 300,
            opt.options.range_end = "";
        opt.options.store = 0;

        //Default settings
        opt.options.range_start = moment().subtract(7, "days").format("YYYY-MM-DDTHH:ss:mm");
        opt.options.date_range = "1w";

        return opt;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.websites', [])
})();
(function(){
    'use strict';

    angular.module('app.websites')
        .service('websiteService', websiteService);

        /**
         * Service for retrieving website info
         *
         * @params {String} portal_path
         * @params {Object} $http
         * @params {Object} websiteStore
         *
         * return {Object}
         */
        function websiteService(portal_path, $http, $q, websitesFactory) {
            var api = {}

            api.getWebsites = function() {
                var result = $q.defer();

                $http({
                    url: portal_path+'websites'
                }).then(function(data){
                    if (data.status === 401) {
                        localStorage.removeItem("userToken");
                        location.href = "login"
                    }
                    data.data.data.map(function(value, index) {
                        value.favico = portal_path + 'websites/'+value.id+'/favicon';

                        return value
                    });

                    result.resolve({
                        items: data.data.data
                    });

                    websitesFactory.setData(data.data.data);
                });

                return result.promise;
            }
            return api;
        }
})();

(function(){
    'use strict';
    angular.module('app.websites')
        .factory('websitesFactory', websitesFactory)

    function websitesFactory($state) {
        var factory = {};
        var data = [];
        var currStore = null;
        var storeItems = [];
        var selectedWebsite = null;
        var websites = [];
        var websiteisSet = false;

        factory.websiteTestSuite = {
            count: 0,
            failed: false
        }

        factory.website = [];
        factory.selected = null;
        factory.liveEnv = false;
        factory.typecode = "";
        factory.stateId = 0;

        factory.getStores = function() {
            return storeItems;
        }

        /**
         * Set selected website
         * @method setStoreById
         * @param {int} id
         * @return {void}
         */
        factory.setStoreById = function(id) {
            data.filter(function(item, index){
               if(item.id === id && item.type_code === "magento" && data[index]['live_env'] != null) {
                   currStore = data[index]['live_env']['structure'];
                   setStoreItems();
               }
            });
        }

        /**
         * Check if support is active
         * @return {boolean}
         */
        factory.isSupportDisable = function () {
            var website = this.getSelectedWebsite();

            if(website.options.hasOwnProperty('portal_disable_support_tab')) {
                return website.options.portal_disable_support_tab;
            } else {
                return false;
            }
        }

        function setStoreItems() {
            //Clear Array;
            storeItems = [];

            //Check length;
            if(Object.keys(currStore['store_groups']).length == 2) {
                setSingleStoreView();
            } else {
                setMultipleStoreView();
            }
        }

        /**
         * Set single store view
         * @return {void}
         */
        function setSingleStoreView() {
            var store_group = currStore['store_groups'];
            var store = currStore['stores'];
            var websites = currStore['websites'];

            Object.keys(store_group).forEach(function(value, index) {
                var obj = {};

                if(value === "0") {
                    return;
                }

                obj.website = websites[value].name;
                obj.store_id = 0;
                obj.name = store[value].name;

                storeItems.push(obj);

            });
        }

        /**
         * Set Storeview Object
         * @method setMultipleStoreView
         * @return {void}
         */
        function setMultipleStoreView() {
            var store_group = currStore['store_groups'];
            var store = currStore['stores'];
            var websites = currStore['websites'];

            Object.keys(store_group).forEach(function(value, index) {
                var obj = {};

                if(value === "0") {
                    obj.website = "All"
                    obj.store_id = 0;
                    obj.name = "Stores";
                    storeItems.push(obj);
                    return;
                }

                //Website
                var webid = store_group[value]['website_id'];
                var webfound = false;

                Object.keys(websites).forEach(function(value, index) {
                    if(websites[value]["id"] === webid) {
                        webfound = true;
                        obj.website = websites[value].name;
                    }
                });

                var storefound = false;

                Object.keys(store).forEach(function(value, index) {
                    if(store[value]["website_id"] === webid) {
                        storefound = true;
                        obj.store_id = store[value].id;
                        obj.name = store[value].name;
                    }
                });

                //if Website & Store is true
                if( webfound && storefound) {
                    storeItems.push(obj);
                }
            });
        }

        factory.setData = function(stores) {
            data = stores;
        }

        factory.setWebsites = function(sites) {
            websites = sites;
            websiteisSet = true;
            factory.website = sites;
        }

        factory.isWebsiteSet = function () {
            return websiteisSet;
        }

        factory.getWebsites = function() {
            return websites;
        }

        factory.setSelectedWebsite = function ( website ) {
            selectedWebsite = website;
            factory.selected = website;
            this.setLiveEnv(website["live_env"]);
            this.setTypeCode(website["type_code"]);
        }

        factory.getSelectedWebsite = function() {
            return selectedWebsite;
        }

        /**
         * Set a boolean if live_env is set
         * @method setLiveEnv
         * @param {Object} livenv
         * @return {void}
         */
        factory.setLiveEnv = function(livenv) {
            if(typeof livenv === "object" && livenv != null) {
                this.liveEnv = true;
            } else {
                this.liveEnv = false;
            }
        }

        /**
         * returns the value of the variable liveEnv
         * @method getLiveEnv
         * @return {Boolean}
         */
        factory.getLiveEnv = function(){
            return this.liveEnv
        }

        /**
         * Set the type code of the selected Website
         * @method setTypeCode
         * @param {String} typecode
         * @return {void}
         */
        factory.setTypeCode = function(typecode) {
            this.typecode = typecode;
        }

        /**
         * @method getTypeCode
         * @return {String}
         */
        factory.getTypeCode = function() {
            return this.typecode;
        }

        factory.setStateId = function(id) {
            this.stateId = id;
            this.setStoreById(id);
        }

        factory.getStateId = function() {
            return this.stateId;
        }

        factory.findWebsiteById = function(id) {
            var website = websites.filter(function(value){
                if(value.id === parseInt(id)) {
                    return value;
                }
            });

            return website;
        }

        factory.getTestsuiteStatus = function() {
            return this.websiteTestSuite;
        }

        factory.setTestsuiteStatus = function(obj) {
            this.websiteTestSuite = obj;
        }

        return factory;
    }
})();

(function(){
    'use strict';

    angular.module('app.websites')
    .directive('websiteBlock', websiteBlock);

    /**
     * Directive for displaying website block;
     * 
     * @param {String} websites_template_path
     * return {object}
     */
    function websiteBlock(websites_template_path, websitesFactory) {
        var websites = {};
        websites.scope = {
            'title': '@',
            'website': '@',
            'support': '@',
            'selectedWebsite': '@'
        };
        websites.templateUrl = websites_template_path;
        websites.controller = ['$scope', 'websitesFactory',function($scope, websitesFactory) {
            var vm = this;

            $scope.$watch(function(){
                return websitesFactory.website;
            }, function(newVal, OldValue) {
                 $scope.websites = newVal;
            });              
        }];
        return websites;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.websites')
        .controller('websitesController', websitesController);

    /**
     * Controller for the websites
     *
     * @class websitesController
     * @constructor
     */
    function websitesController($window, $scope, $rootScope, websiteService, websitesFactory, $state, $stateParams, $location, portal_path, giService) {
        var vm = this;
        $scope.favicon = false;
        /**
         * Get website information based on state id param
         * @method init
         *
         * @param {object} $state
         * @return void
         */
        function init() {
            if ($state.params.id && $state.params.id > 0) {
                var id = $state.params.id;
                websitesFactory.setStateId(id);

            } else {
                websitesFactory.setStateId(0);
            }

            getWebsites();

        }

        init();

        /**
         * Load websites;
         * @method getWebsites
         */
        function getWebsites() {
            //Check if website data is loaded
            if (websitesFactory.getWebsites().length === 0) {
                loadWebsites();
            } else {
                var id = $state.params.id;
                var website = websitesFactory.findWebsiteById(websitesFactory.getStateId())[0];

                if (!website) {

                    if (websitesFactory.getSelectedWebsite()) {
                        website = websitesFactory.getSelectedWebsite();
                    } else {
                        var firstSite = websitesFactory.getWebsites()[0];
                        websitesFactory.setStateId(firstSite.id);
                        website = firstSite;
                    }
                }

                $scope.selectedWebsite = website;
            }
        }

        function getTestResult() {
            var website = websitesFactory.getSelectedWebsite();
            var giEnable = website["options"]["ghostinspector_enable"]
            var suiteId = website["options"]["ghostinspector_suite"];

            if (giEnable) {
                giService.getTests(suiteId)
                    .then(function (data) {
                        var failed = 0;
                        data.forEach(function (i, v) {
                            if (!i["passing"]) {
                                failed++;
                            }
                        });

                        if (failed > 0) {
                            var obj = { count: failed, failed: true };
                            websitesFactory.setTestsuiteStatus(obj);
                        } else {
                            var obj = { count: 0, failed: false };
                            websitesFactory.setTestsuiteStatus(obj);
                        }
                    });
            }
        }

        function loadWebsites() {
            websiteService.getWebsites()
                .then(function (data) {
                    websitesFactory.setWebsites(data.items);
                    var stateId = websitesFactory.getStateId();
                    var website = websitesFactory.findWebsiteById(stateId);


                    if (website.length === 0) {
                        var firstSite = websitesFactory.getWebsites();

                        websitesFactory.setSelectedWebsite(firstSite[0]);
                        websitesFactory.setStateId(firstSite[0].id);
                        $scope.selectedWebsite = websitesFactory.getSelectedWebsite();

                        var route = checkRoute();

                        if (route) {
                            $state.go($state.current.name, {
                                id: firstSite[0].id
                            });
                        } else {
                            var websiteState = $state.get("app.websites");
                            var oldState = $state.$current;

                            $state.go(websiteState.name, {
                                id: firstSite[0].id
                            }, {
                                    location: false,
                                    notify: false
                                });

                            $state.go(oldState.self.name, {}, {
                                notify: false,
                            });

                        }

                    } else {
                        websitesFactory.setSelectedWebsite(website[0]);
                        websitesFactory.setStateId(website[0].id);
                        $scope.selectedWebsite = websitesFactory.getSelectedWebsite();
                    }

                    setSelectedFavIcon();
                    getTestResult();
                })
                .catch(function (err) {
                    // localStorage.removeItem("userToken");
                    // $state.go('app.login');
                });
        }

        /**
         * Check if website route isset
         * @method checkRoute
         */
        function checkRoute() {
            var currentRoute = $state.current.name;
            var isset = false;

            currentRoute.split(".").forEach(function (value, index) {
                if (value === "websites") {
                    isset = true;
                }
            });

            return isset;
        }

        function setSelectedFavIcon() {
            var id = websitesFactory.getSelectedWebsite()["id"];
            var url = portal_path + 'websites/' + id + '/favicon';
            $scope.favicon = url;
        }

        $scope.updateSelected = function (id) {
            var website = websitesFactory.findWebsiteById(id);

            if (website) {
                $scope.selectedWebsite = website[0]
            }
        }

        $scope.$watch("selectedWebsite", function (newVal) {
            if (newVal && newVal.id != websitesFactory.getStateId()) {


                websitesFactory.setSelectedWebsite(newVal);
                websitesFactory.setStateId(newVal.id);
                websitesFactory.setStoreById(newVal.id);

                $state.go($state.current.name, {
                    id: newVal.id
                }, {
                        notify: false
                    });

                getTestResult();

            }
        });

        $scope.getFavIco = function(websiteID) {
            return portal_path + "websites/" + websiteID + "/favicon"
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.websites')
    .constant('websites_template_path', 'app/main/websites/websites.html');
})();
(function () {
    'use strict';

    angular.module("app.websites")
        .config(config)

    function config($translatePartialLoaderProvider, $stateProvider) {
        $translatePartialLoaderProvider.addPart('app/main/websites/');

        // State
        $stateProvider
            .state('app.websites', {
                url: '/website/{id:int}',
                params: {
                    id: 0
                },
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/websites/websites.html',
                        controller: 'websitesController as vm'
                    }
                }
            });
    }
})();
(function(){
    "use strict";

    /**
     * @module ghostInspector/Testsuite
     */
    angular.module("app.ghostInspector", [])
})();

(function(){
    "use strict";

    angular.module("app.ghostInspector")
    .service("giService", giService);

    function giService($http, $q, portal_path, giFactory) {
        var api = {};

        /**
         * Get list of test in a suite by suiteId
         * @method getTests
         * @param {int} id
         */
        api.getTests = function(id) {
            var result = $q.defer();

            $http.get(portal_path + "tests/ghostinspector/suite/"+ id +"/tests")
            .then(function(req) {
                if(req.data.data[0].code === "SUCCESS") {
                    var data = req.data.data[0].data.map(function(value, index) {
                        var newData = {};

                        newData.id = value._id;
                        newData.name = value.name;
                        newData.passing = value.passing != null ? value.passing : "unknown";
                        newData.dateExecutionFinished = moment(value.dateExecutionFinished).format("DD-MM-YYYY HH:mm");

                        return newData;
                    });
                    return result.resolve(data);
                } else {
                    return result.reject(void 0);
                }
            })

            return result.promise;

        }

        /**
         * Get status if suite is still running
         * @method getSuiteStatus
         * @param {int} suite_id
         */
        api.getSuiteStatus = function (suite_id) {
            var result = $q.defer();

            $http.get(portal_path + 'tests/ghostinspector/suite/' + suite_id + '/results')
                .then(function (req) {
                    if(req.status === 500) {
                        giFactory.setSuiteNeverRunned(true);
                        result.resolve("EMPTY");
                        return;
                    }

                    if(typeof req.data.data[0] != "undefined") {
                        giFactory.setSuiteNeverRunned(false);
                        result.resolve(req.data.data[0].status);
                    } else {
                        result.resolve("EMPTY");
                    }
                })
                .catch(function (err) {
                    result.reject(err);
                })

            return result.promise;
        }

        /**
         * Get steps by test id
         * @method getSteps
         * @param {int} id
         */
        api.getSteps = function(id) {
            var result = $q.defer();
            $http.get(portal_path + "/tests/ghostinspector/tests/" + id + "/results")
            .then(function(req) {

                var rawdata = req.data.data[0].result_raw;
                var status = req.data.data[0].status;
                var data = {};

                    if(status === "FINISHED") {
                        data.name = rawdata.test.name;
                        data.passing = rawdata.passing != null ? rawdata.passing : "unknown";
                        data.steps = rawdata.steps;
                    }
                return result.resolve({
                    status: status,
                    data: data
                });
            })

            return result.promise;
        }

        /**
         * Execute a single test
         * @method runTest
         * @param {int} id
         */
        api.runTest = function(id) {
            var result = $q.defer();

            $http.get(portal_path + "tests/ghostinspector/tests/" + id + "/execute")
            .then(function(req){
                //if(req.data.status === "error") {
                    //result.reject(req.data.error.code);
                //}
                result.resolve("STARTED", id)
                //result.resolve(req.data.data[0].status, req.data.data[0].id);
            });

            return result.promise;
        }

        /**
         * Get result of a single test
         * @method getTestResult
         * @param {int} id
         */
        api.getTestResult = function(id) {
            var result = $q.defer();

            $http.get(portal_path + "/tests/ghostinspector/tests/" + id + "/results")
            .then(function(req) {
                if(req.data.data[0].status === "FINISHED") {
                    var rawdata = req.data.data[0].result_raw;

                    var data = {};
                        data.name = rawdata['test']['name'];
                        data.video = rawdata['video'];
                        data.steps = rawdata['steps'];
                        data.screenshot = rawdata['screenshot'];
                        data.passing = rawdata['passing'];

                    result.resolve({
                        status: "FINISHED",
                        data: data
                    });
                } else {
                    return result.resolve(req.data.data[0]);
                }
            })

            return result.promise;
        }

        /**
         * Save suite execute status in a block by block id
         * @method getTestResult
         * @param {int} id
         * @param {int} bid
         * @param {object} data
         */
        api.setrunSuite = function(id, bid, data) {
            var results = $q.defer();

            $http({
                method: "PATCH",
                url: portal_path+"websites/"+id+"/tabs/tab-testsuite/blocks/"+bid+"/",
                data: data
            })
            .then(function(){
                results.resolve();
            });

            return results.promise;

        }

        /**
         * Get result of a test suite
         * @method suiteResult
         * @param {int} suiteId
         */
        api.suiteResult = function(suiteId) {
            var result = $q.defer();

            $http.get(portal_path + "tests/ghostinspector/suite/"+ suiteId + "/results")
            .then(function(req){
                if(req.data.data.length > 0){
                    if(req.data.data[0].result_raw) {
                        if(req.data.data[0].result_raw.data) {
                            req.data.data[0].result_raw.data[0].status = "FINISHED"
                            result.resolve(req.data.data[0].result_raw.data[0]);
                        } else {
                            result.resolve(req.data.data);
                        }
                    } else {
                        result.resolve(req.data.data);
                    }
                } else {
                    result.resolve("empty");
                }
                //
            })
            .catch(function(){
                void 0;
            });

            return result.promise;
        }

        /**
         * Execute a suite
         * @method runSuite
         * @param {int} suiteId
         */
        api.runSuite = function(suiteId) {
            $http.get(portal_path + "tests/ghostinspector/suite/" + suiteId +"/execute")
        }

        /**
         * Suite history
         * @method suiteHistory
         * @param {int} suiteId
         */
        api.suiteHistory = function (suiteId) {
            var result = $q.defer();
            $http.get(portal_path + 'tests/ghostinspector/suite/'  + suiteId + '/history')
                .then(function (req) {
                    if(req.data.status === "success") {
                        var data = req.data.data[0].map(function (value) {
                            var time = moment(value.created_at).format("DD-MM-YYYY @ HH:mm");
                            value.time = time;

                            return value;
                        });

                        result.resolve(data);
                    }
                });
            return result.promise;
        }

        /**
         * Suite History Details
         * @method suiteHistoryDetails
         * @param {int} historyIdsuiteHistoryDetails
         */
        api.suiteHistoryDetails = function (historyId) {
            var result = $q.defer();

            $http.get(portal_path + 'tests/ghostinspector/suite/history/'+historyId)
                .then(function (req) {
                    var data = {};

                    var resultRaw = req.data.data[0].result_raw;

                    data.countFailing = resultRaw.countFailing;
                    data.countPassing = resultRaw.countPassing;
                    data.countUnknown = resultRaw.countUnknown;
                    data.countTest = resultRaw.countFailing + resultRaw.countPassing + resultRaw.countUnknown;
                    data.passing = resultRaw.passing;

                    result.resolve(data);

                });
            return result.promise;
        }

        return api;
    }
})();

(function () {
    "use strict";

    angular.module("app.ghostInspector")
        .factory("giFactory", giFactory)

    function giFactory() {
        var api = {};

        api.testData = [];
        api.selected = {};
        api.selectedId = "";
        api.latestResult = {
            status: "unknown",
            time: "0:00"
        };
        api.tabId = 0;
        api.interval = null;
        api.teststatus = "";
        api.suiteNeverRunned = false;
        api.testSuite = {
            running: false
        }

        api.getTestData = function () {
            return this.testData;
        }

        api.setTestData = function (data) {
            api.testData = data;
        }

        api.setSelected = function (data) {
            this.selected = data;
        }

        api.getSelected = function () {
            return this.selected;
        }

        api.setSelectedId = function (id) {
            this.selectedId = id;
        }

        api.getSelectedId = function () {
            return this.selectedId;
        }

        api.getStatusName = function (bool) {
            switch (bool) {
                case true:
                    return 'Goed';
                    break;
                case false:
                    return 'Fout'
                    break;
                default:
                    return 'Onbekend'
                    break;
            }
        }

        api.getTabId = function () {
            return this.tabId;
        }

        api.setTabId = function (id) {
            this.tabId = id;
        }

        api.getInterval = function() {
            return this.interval;
        }

        api.setInterval = function(fn) {
            this.interval = fn
        }

        api.getTestStatus = function () {
            return this.teststatus;
        }

        api.setTestStatus = function (status) {
            this.teststatus = status;
        }

        api.getLatestResult = function () {
            var result = {
                status: "",
                time: ""
            };
            var status = "";

            if(this.latestResult.status) {
                status = "FINISHED";
            } else if(this.latestResult.status === "empty") {
                status = "empty";
            }
            else {
                status = "ERROR";
            }

            switch(status) {
                case 'empty':
                    result.status = "empty";
                    break;
                case 'ERROR':
                    result.status = "niet succesvol";
                    break;
                case 'FINISHED':
                    result.status = "succesvol";
                    break;
                case 'STARTED':
                    result.status = "bezig";
                    break;
            }

            result.time = this.latestResult.time;

            return result;
        }

        api.setLatestResult = function (result) {
            this.latestResult = result;
        }

        api.getSuiteNeverRunned = function () {
            return this.suiteNeverRunned;
        }

        api.setSuiteNeverRunned = function (bool) {
            this.suiteNeverRunned = bool;
        }

        return api;
    }
})();

(function () {
    "use strict";

    angular.module("app.ghostInspector")
        .controller("giController", giController)
        .controller("giResultController", giResultController)
        .controller("giStepsController", giStepsController)
        .controller("giSingleTestController", giSingleTestController)
        .controller("giMoreInfoController", giMoreInfoController)
        .controller("giTestsuiteDoneController", giTestsuiteDoneController)
        .controller("giTestsuiteHistoryDoneController", giTestsuiteHistoryDoneController);

    function giController(giService, giFactory, testsuite_path, $mdDialog, websitesFactory, $scope, tabsService, $interval, dataTableLoc, $state, SupportService) {
        var vm = this;

        vm.suiteRunning = false;
        vm.testDemo = false;
        vm.testEmpty = false;
        vm.testNotRunned = false;
        vm.suiteNotRunned = false;
        vm.testHistory = [];
        vm.suiteId = 0;
        vm.latestResult = {
            status: "",
            time: ""
        };
        vm.selected = "";
        vm.paths = [
            testsuite_path + "testsuite.table.test.html",
            testsuite_path + "overview/table.account.html",
            testsuite_path + "testsuite.table.history.html"
        ];

        function init() {
            var website = websitesFactory.getSelectedWebsite();

            if (website.options.ghostinspector_enable) {
                $mdDialog.hide();

                var suite = website.options.ghostinspector_suite;
                vm.suiteId = website.options.ghostinspector_suite;
                clearInterval();
                getTabs(website.id, suite);
                giService.getTests(suite)
                    .then(function (data) {
                        giFactory.setTestData(data);
                        vm.dataList = data;

                        if(data.length <= 1) {
                            vm.testDemo = true;
                        }
                    })

                giService.suiteResult(suite)
                    .then(function (data) {
                        if(data === "empty") {
                            giFactory.setLatestResult({status: "unknown", time: "0:00"});
                            vm.latestResult = giFactory.getLatestResult();
                            vm.testNotRunned = true;

                            return;
                        }

                        if(data.status) {
                            giFactory.setLatestResult({status: data.passing, time: moment(data.dateExecutionFinished).format("DD-MM-YYYY HH:mm")});
                            vm.latestResult = giFactory.getLatestResult();
                            vm.testNotRunned = false;
                            return;
                        }

                        if(data[0].status) {
                            giFactory.setLatestResult({status: data[0].passing, time: moment(data[0].dateExecutionFinished).format("DD-MM-YYYY HH:mm")});
                            vm.latestResult = giFactory.getLatestResult();
                            vm.testNotRunned = false;
                            return;
                        }
                    });

                giService.suiteHistory(suite)
                    .then(function (data) {
                        vm.testHistory = data;
                    });

            } else {
                vm.testDemo = true;
                vm.testEmpty = true;
            }
        }

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                resetLocalVar();
                init();

            }
        });

        function resetLocalVar() {
            vm.testDemo = false;
            vm.testNotRunned = false;
            vm.testEmpty = false;
            vm.suiteRunning = false;
            vm.suiteNotRunned = false;
            vm.testHistory = [];
            vm.latestResult = {
                status: "",
                time: ""
            };
        }

        function getTabs(wId, suite_id) {
            tabsService.getBlocksByTabName("testsuite", wId)
                .then(function (data) {
                    data["widgets"].forEach(function (v, i) {
                        if (v["widget"] === "gi-suite") {
                            giService.getSuiteStatus(suite_id)
                                .then(function (status) {
                                    if(giFactory.getSuiteNeverRunned()) {
                                        suiteNeverRun();
                                    }

                                    if(status === "STARTED") {
                                        vm.suiteRunning = true;
                                        suitePolling(suite_id);
                                    }
                                })
                        }
                    });
                });
        }

        function suiteNeverRun() {
            vm.suiteNotRunned = true;
        }

        vm.more_info = function () {
            $mdDialog.show({
                controller: "giMoreInfoController as vm",
                templateUrl: testsuite_path + "modals/testsuite.modal.moreinfo.html",
                parent: angular.element(document.getElementById("dashboard"))
            })
        }

        vm.openSupportTicket = function(subject) {
            var onderwerp = "";
            switch (subject) {
                case 'info':
                    onderwerp = "Meer informatie over het onderdeel Test suite in het Experius Portal";
                    break;
                case 'test':
                    onderwerp = "Een extra test aanvragen voor de Test suite";
                    break;

            }

            SupportService.openTicketDialog(websitesFactory.selected["id"], onderwerp);
        }

        function clearInterval(websiteId) {
            if(giFactory.getInterval() != null) {
                $interval.cancel(giFactory.getInterval());
                giFactory.setInterval(null);
            }
        }

        function suitePolling(suiteId) {
            var website = websitesFactory.getSelectedWebsite();
            var wid = website["id"];
            var bid = giFactory.getTabId();
            var obj = {
                options: {}
            }

            var execute = function () {
                var webid = websitesFactory.getSelectedWebsite()["id"];
                giService.getSuiteStatus(suiteId)
                    .then(function (status) {
                        if(giFactory.getSuiteNeverRunned()) {
                            suiteNeverRun();
                        }

                        if(status === "FINISHED") {

                            giService.suiteResult(suiteId)
                                .then(function (req) {

                                    var data;

                                    if(req.length > 0) {
                                        data = req[0];
                                    } else {
                                        data = req;
                                    }

                                    if(data.status === "FINISHED") {
                                        vm.suiteRunning = false;
                                        clearInterval();
                                        giFactory.setLatestResult({
                                            status: data.passing,
                                            time:  moment(data.dateExecutionFinished).format("DD-MM-YYYY HH:mm")
                                            });
                                        vm.latestResult = giFactory.getLatestResult();
                                        getNewResult(suiteId);
                                        vm.suiteNotRunned = false;
                                        vm.testNotRunned = false;
                                        $mdDialog.show({
                                            controller: "giTestsuiteDoneController as vm",
                                            templateUrl: 'app/main/testsuite/modals/testsuite.modal.suitedone.html',
                                            parent: angular.element(document.getElementById("dashboard")),
                                            locals: {
                                                webid: webid,
                                                data: data
                                            }
                                        });
                                    }
                                });
                        }
                    })
            };

            execute();
            giFactory.setInterval(
                $interval(execute, 30000)
            )
        }

        function getNewResult(suiteId) {

            giService.getTests(suiteId)
                .then(function (data) {
                    giFactory.setTestData(data);
                    vm.dataList = data;

                    if(data.length <= 1) {
                        vm.testDemo = true;
                    } else {
                        vm.testDemo = false;
                    }
                });

            giService.suiteHistory(suiteId)
                .then(function (data) {
                    vm.testHistory = data;
                });
        }

        vm.startTest = function () {
            if (vm.selected != "") {
                giFactory.setSelected(vm.selected);
                var webid = websitesFactory.getSelectedWebsite()["id"];

                $mdDialog.show({
                    controller: "giSingleTestController as vm",
                    templateUrl: testsuite_path + "modals/testsuite.modal.showResults.html",
                    locals: {
                        webid: webid
                    },
                    parent: angular.element(document.body)
                });

            }
        }

        vm.showSteps = function (id) {

            giFactory.setSelectedId(id);
            var webid = websitesFactory.getSelectedWebsite()["id"];

            $mdDialog.show({
                controller: "giStepsController as vm",
                templateUrl: testsuite_path + "modals/testsuite.modal.showsteps.html",
                parent: angular.element(document.body)
            })
                .finally(function () {
                    var testStatus = giFactory.getTestStatus();

                    if(testStatus === "executeTestResult") {
                        $mdDialog.show({
                            controller: "giSingleTestController as vm",
                            templateUrl: testsuite_path + "modals/testsuite.modal.showResults.html",
                            locals: {
                              webid: webid
                            },
                            parent: angular.element(document.getElementById("dashboard"))
                        })
                    }
                })
        }

        vm.showResults = function (id, passing) {
            giFactory.setSelectedId(id);
            var webid = websitesFactory.getSelectedWebsite()["id"];
            var testpassing = 0;

            $mdDialog.show({
                controller: "giResultController as vm",
                templateUrl: testsuite_path + "modals/testsuite.modal.showResults.html",
                parent: angular.element(document.body),
                locals: {
                    webid: webid,
                    passing: passing
                }
            })
                .finally(function () {
                    var testStatus = giFactory.getTestStatus();

                    if(testStatus === "executeTestResult") {
                        $mdDialog.show({
                            controller: "giSingleTestController as vm",
                            templateUrl: testsuite_path + "modals/testsuite.modal.showResults.html",
                            locals: {
                                webid: webid
                            },
                            parent: angular.element(document.getElementById("dashboard"))
                        })
                    }
                })
        }

        vm.startSingleTest = function (id) {
            giFactory.setSelectedId(id);
            var webid = websitesFactory.getSelectedWebsite()["id"];

            $mdDialog.show({
                controller: "giSingleTestController as vm",
                templateUrl: testsuite_path + "modals/testsuite.modal.showResults.html",
                locals: {
                    webid: webid
                },
                parent: angular.element(document.getElementById("dashboard"))
            })
                .finally(function () {
                    if(window["HOTFIX_GI"]) {
                        window['HOTFIX_GI'] = false;
                        vm.startTestSuite();
                    } else {
                        var suiteId = vm.suiteId;
                        getNewResult(suiteId);
                    }
                });
        }

        vm.statusName = function (bool) {
            return giFactory.getStatusName(bool);
        }

        vm.startTestSuite = function () {
            var website = websitesFactory.getSelectedWebsite();
            var wid = website["id"];
            var bid = giFactory.getTabId();
            var suiteId = website["options"]["ghostinspector_suite"];

            suitePolling(suiteId);
            vm.suiteRunning = true;

            giService.runSuite(suiteId);

        }

        vm.dtoptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            lengthMenu: [5, 10, 20, 30, 50, 100],
            pageLength: 5,
            responsive: true,
            language: {
                url: dataTableLoc
            }
        };

        vm.showHistory = function (id) {
            var webid = websitesFactory.getSelectedWebsite()["id"];

            giService.suiteHistoryDetails(id)
                .then(function (data) {
                    data.noSupport = true;

                    $mdDialog.show({
                        controller: "giTestsuiteHistoryDoneController as vm",
                        templateUrl: 'app/main/testsuite/modals/testsuite.modal.done.html',
                        parent: angular.element(document.getElementById("dashboard")),
                        locals: {
                            webid: webid,
                            data: data
                        }
                    });
                });
        };
    }

    function giSingleTestController(giService, giFactory, SupportService, $sce, $mdDialog, $interval, webid, dataTableLoc) {
        var vm = this;
            vm.novideo = true;
            vm.noscreen = true;

        function init() {
            var id = giFactory.getSelectedId();
            vm.isLoading = true;

            giService.runTest(id)
                .then(function (data, tid) {
                    if(data === "STARTED") {
                        var execute = $interval(function () {
                                giService.getTestResult(id)
                                    .then(function (result) {
                                        if (result.status === "FINISHED") {
                                            vm.isLoading = false;
                                            vm.data = result.data

                                            if(result.data.video) {
                                                vm.novideo = false;
                                            }

                                            if(result.data.screenshot) {
                                                vm.noscreen = false;
                                            }
                                            $interval.cancel(execute);
                                        }

                                        /* HOTFIX*/
                                        if(result.status === "ERROR") {
                                            window['HOTFIX_GI'] = true;
                                            $interval.cancel(execute);
                                            $mdDialog.hide();
                                        }

                                    })
                            }, 10000);

                        execute;
                    }

                    if(data === "FINISHED") {
                        giService.getTestResult(id)
                            .then(function (result) {
                                if (result.status === "FINISHED") {
                                    vm.isLoading = false;
                                    vm.data = result.data

                                    if(result.data.video) {
                                        vm.novideo = false;
                                    }

                                    if(result.data.screenshot) {
                                        vm.noscreen = false;
                                    }
                                }
                            })
                    }
                })
                .catch(function (err) {
                    if(err === "GHOSTINSPECTOR_ERROR") {
                        var execute = $interval(function () {
                            giService.getTestResult(id)
                                .then(function (result) {
                                    if (result.status === "FINISHED") {
                                        vm.isLoading = false;
                                        vm.data = result.data

                                        if(result.data.video) {
                                            vm.novideo = false;
                                        }

                                        if(result.data.screenshot) {
                                            vm.noscreen = false;
                                        }
                                        $interval.cancel(execute);
                                    }
                                })
                        }, 10000);

                        execute;
                    }
                })
        }

        init();

        vm.videoSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }

        vm.statusName = function (str) {
            return giFactory.getStatusName(str);
        }

        vm.openTicketDialog = function () {
            var title = "";
            SupportService.openTicketDialog(webid, title);
        }
    }

    function giResultController(giService, giFactory, $sce, $mdDialog, webid, passing, SupportService) {
        var vm = this;
            vm.novideo = true;
            vm.noscreen = true;

        function init() {
            var id = giFactory.getSelectedId();
            vm.isLoading = true;
            giService.getTestResult(id)
                .then(function (result) {
                    if(result.status === "ERROR") {

                        giFactory.setTestStatus("executeTestResult")
                        return $mdDialog.hide();
                    }
                    if(passing) {
                        result.data.passing = passing;
                    }

                    vm.isLoading = false;
                    vm.data = result.data;

                    if(result.data.video) {
                        vm.novideo = false;
                    }

                    if(result.data.screenshot) {
                        vm.noscreen = false;
                    }
                })
        }

        init();

        vm.openTicketDialog = function () {
            var title = "";
            SupportService.openTicketDialog(webid, title);
        }

        vm.videoSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }

        vm.statusName = function (str) {
            return giFactory.getStatusName(str);
        }
    }

    function giStepsController(giService, giFactory, $mdDialog) {
        var vm = this;
        vm.isLoading = true;

        function init() {
            var id = giFactory.getSelectedId();

            giService.getSteps(id)
                .then(function (result) {
                    if(result.status === "ERROR") {

                        giFactory.setTestStatus("executeTestResult")
                        return $mdDialog.hide();
                    }

                    vm.data = result.data;
                    vm.isLoading = false;
                });
        }

        init();

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }
    }

    function giTestsuiteDoneController($mdDialog, data, giFactory, webid, SupportService) {
        var vm = this;
        vm.data = data;
        vm.hideSupportButton = false;
        vm.amountTests = (data.result_raw.countUnknown + data.result_raw.countFailing + data.result_raw.countPassing);

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }

        vm.statusName = function(bool) {
            return giFactory.getStatusName(data.passing);
        }

        if(data.result_raw.passing) {
            vm.hideSupportButton = true;
        }

        vm.openTicketDialog = function () {
            var title = "";
            SupportService.openTicketDialog(webid, title);
        }
    }

    function giTestsuiteHistoryDoneController($mdDialog, data, giFactory, webid, SupportService) {
        var vm = this;
        vm.data = data;
        vm.hideSupportButton = false;
        vm.amountTests = (data.countUnknown + data.countFailing + data.countPassing);

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }

        vm.statusName = function(bool) {
            return giFactory.getStatusName(data.passing);
        }

        if(data.passing) {
            vm.hideSupportButton = true;
        }

        vm.openTicketDialog = function () {
            var title = "";
            SupportService.openTicketDialog(webid, title);
        }
    }

    function giMoreInfoController($mdDialog) {
        var vm = this;

        vm.closeDialoog = function () {
            $mdDialog.hide();
        }
    }
})();

(function(){
    "use strict";

    angular.module("app.ghostInspector")
    .constant("testsuite_path", "app/main/testsuite/")
})();
(function(){
    "use strict";

    angular.module("app.ghostInspector")
    .config(config)

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.testsuite', {
                url: '/testsuite',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/testsuite/testsuite.html',
                        controller: 'giController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('Test Suite', {
            title: 'Test Suite',
            icon: 'icon-checkbox-marked-outline',
            state: 'app.websites.testsuite',
            class: '700',
            weight: 60,
            type: 'testsuite'
        });

        $translatePartialLoaderProvider.addPart('app/main/testsuite');
    }
})();

(function(){
    "use strict";

    /**
     * @module Tabs
     */
    angular.module("app.tabs", []);

})();
(function () {
    "use strict";

    angular.module("app.tabs")
        .service("tabsService", tabsService);

    function tabsService($q, $http, portal_path, websitesFactory, tabsFactory) {
        var api = {};

        /**
         * Get blocks by tab name and website id
         * @method getBlocksByTabName
         * @param {String} tabName
         * @param {int} websiteId
         */
        api.getBlocksByTabName = function (tabName, websiteId) {
            var result = $q.defer();

            $http.get(portal_path + "websites/" + websiteId + "/tabs/tab-" + tabName + "/blocks/")
                .then(function (req) {
                    if (req.data.data.length > 0) {
                        var data = api.setWidgets(req.data.data, tabName);

                        result.resolve(data);
                        return;
                    }

                    //Else Create new block
                    return api.createTabs(tabName, websiteId, result);
                })
                .then(function(req) {
                    if(req) {
                        var data = api.setWidgets(req);
                        result.resolve(data);
                    }
                })
                .catch(function (err) {
                    result.reject(err);
                    void 0;
                });
            
            return result.promise;
        }

        api.setWidgets = function(req, tabName) {

            var widgets = req.map(function (value) {
                var item = {};

                item.id = value.id;
                item.website = value.website;
                item.order = value.order;
                item.widget = value.widget;
                item.options = value.options;
                item.data_code = value.data_code;
                item.tab = tabName

                return item;
            });

            var stores = websitesFactory.getStores();

            var data = {
                widgets: widgets,
                stores: stores
            }
            
            return data;
        }

        /**
         * Create Tabs
         * @method createTabs
         * @param {String} tabName
         * @param {int}  websiteId
         * @param {Promise} result
         */
        api.createTabs = function (tabName, websiteId, result) {
            var widgets = tabsFactory.getWidgets(tabName);
            var promises = [];

            widgets.forEach(function(value, index){
                var result = $q.defer();

                $http({
                    method: "POST",
                    url: portal_path + "websites/"+websiteId+"/tabs/tab-"+tabName+"/blocks/",
                    data: {
                        widget: value,
                        order: index + 1,
                        options: {}
                    }
                })
                .then(function(req){
                    result.resolve(req.data.data[0]);
                })
                .catch(function(err){
                    result.reject(err);
                });

                promises.push(result.promise);

            });

            return $q.all(promises);

        }

        return api;
    }
})();

(function(){
    "use strict";

    angular.module("app.tabs")
    .factory("tabsFactory", tabsFactory);

    function tabsFactory() {
        var api = {};

        api.tabsWigetList = {
            sales: ["magento-orders", "magento-sales"],
            magento: ["magento-versions", "website-environment_info", "website-responsetime", "magento-module_versions", "magento-module_manual", "magento-module_count", "magento-module_outdated", "magento-magento_versions"],
            testsuite: ["gi-suite", "gi-single"]
        }

        api.getWidgets = function(name) {
            if(this.tabsWigetList[name]) {
                return this.tabsWigetList[name];
            }
        }

        return api;
    }
})();
(function(){
    'use strict';

    angular.module('app.support')
        .service('SupportService', SupportService);

    function SupportService(portal_path, $http, $q, $mdDialog, support_ticket_path){
        var SupportService = {};

        /**
         * Get Support Contract by website id
         *
         * @param {int} id
         *
         * @return {Promise}
         */
        SupportService.getContract = function(id) {
            var results = $q.defer();

            $http({
                url: portal_path+'websites/'+id+'/support'
            })
            .then(function(data){
                if(data.data.data[0].hours > 0) {
                    results.resolve(data.data.data);
                } else {
                    results.reject({
                        err: "NoSupport",
                        message: "Sorry, you don't have a support contract"
                    });
                }
            })
            .catch(function(err){
                results.reject(err);
            });

            return results.promise;
        }

        /**
         * Get amount of support hours of the month
         */
        SupportService.getSupportHours = function(id, month) {
            var results = $q.defer();

            if(typeof month === 'undefined') {
                var currentMonth = moment().format("YYYYMM");
            } else {
                var currentMonth = month;
            }

            $http({
                url: portal_path+'websites/'+id+'/support/months/'+currentMonth
            })
            .then(function(data){
                if(data.data.data.length > 0) {
                    results.resolve(data.data.data[0]);
                } else {
                    results.reject({
                        error: "notFound",
                        message: "Sorry, No data found!"
                    })
                }

            })
            .catch(function(err){
                results.reject(err);
            });

            return results.promise;
        }

        SupportService.getSupportMonths = function(id) {
            var results = $q.defer();
            $http({
                url: portal_path+'websites/'+id+'/support/months'
            })
            .then(function(data){
                results.resolve(data.data.data);
            })
            .catch(function(err){
                results.reject(err);
            });

            return results.promise;
        }

        /**
         * Get support tickets
         * @method getSupportTickets
         * @param {int} id
         * @param {String} start
         * @param {String} end
         * @param {String} status
         *
         * @return {Object}
         */
        SupportService.getSupportTickets = function(id, start, end, status) {
            var results = $q.defer();

            $http({
                url: portal_path+'websites/'+id+'/support/tickets?range_start='+start+'&range_end='+end+'&status='+status
            })
            .then(function(data){
                if(data.data.data.length > 0) {
                    results.resolve(data.data.data);
                } else {
                    results.reject({
                        error: "notFound",
                        message: "Sorry, No data found!"
                    })
                }
            })
            .catch(function(err){
                results.resolve(err);
            })

            return results.promise;
        }

        SupportService.createTicket = function(websiteid, title, description) {
            var result = $q.defer();

            $http({
                method: "POST",
                url: portal_path + 'websites/'+websiteid+'/support/tickets',
                data: {
                    title: title,
                    description: description
                }
            })
            .then(function(){
                result.resolve();
            })
            .catch(function(){
                result.reject();
            });

            return result.promise;
        }

        SupportService.getFile = function(websiteid, month, type) {
            $http({
                method: "GET",
                responseType: 'arraybuffer',
                url: portal_path + 'websites/'+websiteid+'/support/months/'+ month+'/download/'+type
            })
            .then(function(pdf){
                var blob = new Blob([pdf.data], {type: 'application/pdf' });
                saveAs(blob, "summary-" + month + ".pdf");
            });
        }

        SupportService.openTicketDialog = function (id, title) {
            $mdDialog.show({
                controller: "createTicketController as vm",
                templateUrl: support_ticket_path + 'summary/modal/createticket.html',
                parent: angular.element(document.body),
                fullscreen: false,
                bindToController: true,
                locals: {
                    title: title,
                    websiteId: id
                }
            });
        }

        return SupportService;
    }
})();

(function () {
    'use strict';

    angular.module('app.support')
        .factory('SupportFactory', SupportFactory)

    function SupportFactory(portal_path) {
        var model = {};
        model.contract = {
            hour_price: 0,
            hours: 0,
            type: "",
            type_id: 0,
            website: ""
        };

        model.supportHours = {
            id: 0,
            corrected_hours: "0",
            support_hours: "0",
            data: "2016-01-01",
            credit: 0,
            hour_price: "0"
        }

        model.supporttickets = [];
        model.supportmonths = [];

        model.getContract = function () {
            return model.contract;
        }

        model.setContract = function (item) {
            model.contract = item;
        }

        model.getSupportHours = function () {
            return model.supportHours;
        }

        model.setSupportHours = function (item) {
            model.supportHours = item;
        }


        model.getSupportTickets = function () {
            return model.supporttickets;
        }

        model.setSupportTickets = function (items) {
            model.supporttickets = items;
        }

        model.setSupportMonths = function (data) {
            model.supportmonths = data;
        }

        model.getSupportMonths = function () {
            return model.supportmonths;
        }

        model.findHoursByMonth = function (month) {
            return model.supportmonths.filter(function (value, index) {
                var date = moment(value.date).format("YYYY-MM");
                if (date === month) {
                    return value;
                }
            });
        }

        model.clear = function () {
            this._clearContract();
            this._clearSupportHours();
        }

        model._clearContract = function () {
            this.contract = {
                hour_price: 0,
                hours: 0,
                type: "",
                type_id: 0,
                website: ""
            };
        }

        model._clearSupportHours = function() {
            this.supportHours = {
                id: 0,
                corrected_hours: "0",
                support_hours: "0",
                data: "2016-01-01",
                credit: 0,
                hour_price: "0"
            }
        }

        model.OpenSupportTicker = function (subject) {

        }

        return model;
    }
})();

(function(){
    'use strict';

    angular.module("app.support")
    .constant('support_ticket_path', 'app/main/support/');
})();
(function(){
    'use strict';

    angular.module('app.support')
    .config(config)

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.websites.support', {
                url    : '/support',
                middleware: ['AuthMiddleware'],
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/support/summary/support.summary.html',
                        controller : 'SupportSummaryController as vm'
                    }
                },
                resolve: {
                }
        });
        msNavigationServiceProvider.saveItem('support', {
            title    : 'Support Tickets',
            icon     : 'icon-comment-text',
            state    : 'app.websites.support.summary',
            class:  '500',
            weight: 30
        });
    }
})();

(function(){
    'use strict';

    angular.module("app.social", []);
})();
(function(){
    "use strict";

    angular.module("app.social")
    .service("SocialService", SocialService)

    function SocialService($http, $q, $sce) {
        var api = {};

        api.getBlogPosts = function() {
            var result = $q.defer();

            $http.get("https://www.experius.nl/wp-json/wp/v2/posts?limit=10")
            .then(function(req){
                req.data.map(function(val){
                    var date = moment(val.date);
                    val.date = date.format("DD-MM-YYYY");
                    return val;
                });

                result.resolve(req.data);
            })
            .catch(function(){
                result.reject();
            });
            return result.promise;
        };

        api.getFacebookPosts = function() {
            var result = $q.defer();

            $http.get("https://graph.facebook.com/v2.8/174696342547928/posts/?access_token=345284382258386|-9wLKCw2bG-BvxSXYyfjdobGkLc&limit=10&fields=attachments,message,created_time")
            .then(function(req){

                req.data.data.map(function(val){
                    var date = moment(val["created_time"]);
                    val["created_time"] = date.format("DD-MM-YYYY");

                    return val;
                });

                var data = req.data.data.filter(function(val) {
                    if(typeof val.message != "undefined") {
                        return val;
                    }
                });

                result.resolve(data);
            })
            .catch(function(){
                result.reject();
            });

            return result.promise;
        }

        api.getTwitterPosts = function() {

        }

        api.defaultObject = function() {
            return {
                loaded: false,
                data: []
            }
        }

        api.createLink = function() {
            $(".more-link").attr("target", "_blank");
        }   

        return api;
    }
})();
(function(){
    "use strict";

    angular.module("app.social")
    .factory("SocialFactory", SocialFactory)

    function SocialFactory() {
        var api = {};
        api.blogPosts = [];
        api.facebookPosts = [];

        api.getBlogPosts = function() {
            return this.blogPosts;
        }

        api.setBlogPosts = function(posts) {
            this.blogPosts = posts
        }

        api.getFacebookPosts = function () {
            return this.facebookPosts;
        }

        api.setFacebookPosts = function(posts) {
            this.facebookPosts = posts
        }

        return api;
    }
})();
(function () {
    "use strict";

    angular.module("app.social")
        .controller("SocialController", SocialController)

    function SocialController(SocialService, SocialFactory, $sce) {
        var vm = this;
        vm.blogPosts = Object.create(SocialService.defaultObject());
        vm.facebookPosts = Object.create(SocialService.defaultObject());
        vm.twitterPosts = Object.create(SocialService.defaultObject());


        if (SocialFactory.getBlogPosts().length === 0) {
            SocialService.getBlogPosts()
                .then(function (data) {

                    SocialFactory.setBlogPosts(data);
                    vm.blogPosts.loaded = true;
                    vm.blogPosts.data = data;

                    setTimeout(function(){
                      SocialService.createLink();  
                    });
                })
                .catch(function () {
                    vm.blogPosts.loaded = true;
                });
        } else {
            vm.blogPosts.loaded = true;
            vm.blogPosts.data = SocialFactory.getBlogPosts();
        }

        if (SocialFactory.getFacebookPosts().length === 0) {
            SocialService.getFacebookPosts()
                .then(function (data) {
                    SocialFactory.setFacebookPosts(data);
                    vm.facebookPosts.loaded = true;
                    vm.facebookPosts.data = data;
                })
                .catch(function () {
                    vm.facebookPosts.loaded = true;
                });
        } else {
            vm.facebookPosts.loaded = true;
            vm.facebookPosts.data = SocialFactory.getFacebookPosts();
        }

        vm.renderHtml = function (html_code, type) {
            if (type === "fb") {
                return $sce.trustAsHtml(linkifyHtml(html_code, {
                    target: {
                        url: "_blank"
                    }
                }));
            }

            return $sce.trustAsHtml(html_code);
        }
        //SocialService.getTwitterPosts();
    }
})();
(function(){
    "use strict";

    angular.module("app.social")
    .constant("fb_token", "32434")
})();
(function () {
    "use strict";

    angular.module("app.social")
        .config(config);

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.social', {
                url: '/social',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/social/social.html',
                        controller: 'SocialController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('social', {
            title: 'Experius Actueel',
            icon: 'icon-view-dashboard',
            state: 'app.social',
            class: '500',
            weight: 99
        });

        $translatePartialLoaderProvider.addPart('app/main/social');
    }
})();

(function(){
    'use strict';

    angular.module('app.settings', ['app.settings.overview', 'app.settings.account'])
})();

(function(){
    'use strict';

    angular.module('app.settings')
    .service('SettingsService', SettingsService)

    function SettingsService(portal_path, $http, $q){
        var SettingsService = {};

        /**
         * Get allowed addresses.
         *
         * @return {Promise}
         */
        SettingsService.getAddresses = function() {
            var results = $q.defer();

            $http({
                url: portal_path+'firewall/addresses'
            })
            .then(function(data){
                results.resolve(data.data.data);
            })
            .catch(function(err){
                results.reject(err);
            });

            return results.promise;
        }

        /**
         * Delete address.
         * @param id
         */
        SettingsService.deleteAddress = function(id) {
            var results = $q.defer();

            $http({
                method: 'DELETE',
                url: portal_path+'firewall/addresses/'+id
            })
            .then(function(data) {
                results.resolve(true);
            })
            .catch(function(err) {
                results.reject(err);
            });

            return results.promise;
        }

        /**
         * Add address.
         * @param address
         */
        SettingsService.addAddress = function(address, description) {
            var results = $q.defer();

            $http({
                method: 'POST',
                url: portal_path+'firewall/addresses',
                data: {
                    address: address,
                    description: description
                }
            })
            .then(function(data) {
                if (data.status < 200 || data.status > 299) {
                    return results.reject(data.status, data);
                }
                results.resolve(true);
            })
            .catch(function(err) {
                results.reject(null, err);
            });

            return results.promise;
        }


        SettingsService.validateAddress = function(address) {
            return (
                (
                    address === 'current'
                ) || (
                    /^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/.test(address)
                )
            );
        }


        SettingsService.getIp = function() {
            var results = $q.defer();

            $http({
                url: portal_path+'firewall/ip'
            })
                .then(function(data) {
                    results.resolve(data.data);
                })
                .catch(function(err) {
                    results.reject(err);
                });

            return results.promise;
        }

        SettingsService.getAdminProtection = function (id) {
            var result = $q.defer();

                $http({
                    url: portal_path + 'websites/' + id+ '/admin_firewall'
                })
                    .then(function (req) {
                        result.resolve(req.data.data[0].admin_protection);
                    })
                    .catch(function (err) {
                       result.reject(err);
                    });

            return result.promise;
        }

        SettingsService.setAdminProtection = function (id, bool) {
            $http({
                method: "PUT",
                url: portal_path + 'websites/' + id + '/admin_firewall',
                data: {
                    admin_protection: bool
                }
            });
        }

        return SettingsService;
    }
})();

(function(){
    'use strict';

    angular.module('app.settings')
    .factory('SettingsFactory', SettingsFactory)

    function SettingsFactory(portal_path) {
        var model = {};

        model.ipaddressInput = '';
        model.ipaddresses = [];

        model.getAddresses = function () {
            return model.ipaddresses;
        }

        model.setAddresses = function(addresses) {
            model.ipaddresses = addresses;
        }

        return model;
    }
})();

(function(){
    'use strict';

    angular.module("app.settings")
    .constant('settings_path', 'app/main/settings/');
})();

(function(){
    'use strict';

    angular.module('app.settings')
    .config(config)

    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.websites.settings', {
                url    : '/settings',
                middleware: ['AuthMiddleware'],
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/overview/settings.overview.html',
                        controller : 'SettingsOverviewController as vm'
                    }
                },
                resolve: {
                }
        });
        msNavigationServiceProvider.saveItem('settings', {
            title    : 'Beveiliging',
            icon     : 'icon-lock',
            state    : 'app.websites.settings.overview',
            class:  '500',
            translate: 'SETTINGS.NAV',
            weight: 90
        });

        $translatePartialLoaderProvider.addPart('app/main/settings/');
    }
})();

(function(){
    'use strict';

    angular.module('sentry', []);

})();

(function () {
    'use strict';

    angular.module('sentry')
        .factory('sentryFactory', sentryFactory)

    function sentryFactory(sentry) {
        return {}
    }

    if(!localStorage.getItem("tdbg")){
        Raven
        .config('https://f58f2ded9de64abb83bde3f61fc8cad7@sentry.io/138454', {
            ignoreUrls: ["http://localhost:3000", "https://portal.tom.xpdev.nl/social"],
            environment: 'production'
        })
        .addPlugin(Raven.Plugins.Angular)
        .install();
    } else {
        void 0;
    }
})();

(function () {
    'use strict';

    angular.module('sentry')
        .controller('sentryController', sentryController)

    function sentryController(sentryFactory) {

        function init() {
        }

        function sentryrun() {
            //sentryFactory.run();
        }

        init();
    }
})();

(function(){
    "use strict";

    angular.module("app.sales", []);
})();
(function () {
    "use strict";

    angular.module("app.sales")
        .factory("SalesFactory", SalesFactory);

    function SalesFactory() {
        var api = {};
        api.dashboard = [];
        api.selectedDashboard = {};
        api.data = [];

        api.setDashboard = function (dashboard) {
            this.dashboard = dashboard;
        }

        api.getDashboard = function () {
            return this.dashboard;
        }

        api.findDashboardById = function (id) {
            if (typeof this.dashboard != 'undefined') {
                this.dashboard.filter(function (item) {
                    if (item.website === id) {
                        api.selectedDashboard = Object.create(item);
                    }
                });

                return this.selectedDashboard;
            }
        }

        api.transforDashboard = function () {
            var arr = this.selectedDashboard.widgets.filter(function (widgetItem) {
                switch (widgetItem.widget.code) {
                    case "magento-orders":
                        return widgetItem;
                        break;
                    case "magento-sales":
                        return widgetItem;
                        break;
                }
            });

            this.selectedDashboard.dashboards = arr;

            return this.selectedDashboard;
        }

        api.setData = function(item, id) {
            item.id = id;

            this.data.push(item)
        }

        api.findDataById = function(id) {
            return this.data.filter(function(value, index) {
                if(value.id === id) {
                    return value;
                }
            });
        }

        api.clearData = function() {
            this.data = [];
        }

        return api;
    }
})();
(function () {
    "use strict";

    angular.module("app.sales")
        .controller("SalesController", SalesController);

    function SalesController($scope, websitesFactory, dashboardService, SalesFactory, tabsService) {
        var vm = this;

        function init() {
            var website = websitesFactory.getSelectedWebsite();

            if(!checkByte()) {
                return;
            }

            getTabs(website.id);
        }
        
        $scope.$watch(function(){
            return websitesFactory.selected
        }, function(website){
            if (website && websitesFactory.getSelectedWebsite()) {
                var id = websitesFactory.getSelectedWebsite()["id"];
                var data = SalesFactory.findDataById(id);

                if(data.length > 0 ){
                    $scope.$broadcast("newBoard", data[0]);
                    vm.data = data[0].widgets;
                    vm.stores = data[0].stores;

                    checkByte();
                } else {
                    init();                      
                }

            }
        });

        function getTabs(wId) {
            tabsService.getBlocksByTabName("sales", wId)
                .then(function (data) {
                    $scope.$broadcast("newBoard", data);
                    vm.data = data.widgets;
                    vm.stores = data.stores;
                    SalesFactory.setData(data, wId);
                });
        }

        function checkByte() {
            var website = websitesFactory.getSelectedWebsite();
            if (!websitesFactory.getLiveEnv() || !(websitesFactory.getTypeCode() == "magento" || websitesFactory.getTypeCode() == "magento2")) {
                websitesFactory.setStoreById(website.id);
                $scope.$broadcast("noByte", true);
                websitesFactory.setStoreById(website.id);
                return false;
            }

            $scope.$broadcast("noByte", false);
            return true;            
        }
    }
})();

(function(){
    "use strict";

    angular.module("app.sales")
    .config(config)

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.sales', {
                url: '/sales',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales/sales.html',
                        controller: 'SalesController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('sales', {
            title: 'Sales',
            icon: 'icon-elevation-rise',
            state: 'app.websites.sales',
            class: '500',
            weight: 20
        });

        $translatePartialLoaderProvider.addPart('app/main/sales');
    }
})();

(function(){
    'use strict';

    angular.module('app.releasenotes', [])
})();
(function () {
    'use strict';

    angular.module('app.releasenotes')
        .directive('releaseNotes', releaseNotes);

    function releaseNotes(releasenote_template_path) {
        return {
            scope: {
                hide: '='
            },
            template: '',
            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {

                $scope.closeDialog = function(ev) {
                    $mdDialog.hide(ev);
                }

                if(!$scope.hide) {
                    $mdDialog.show({
                        templateUrl: releasenote_template_path
                    });
                }
            }]
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.releasenotes')
        .constant('releasenote_template_path', 'app/main/releasenotes/releasenotes.html');
})();
(function () {
    'use strict';

    angular
        .module('app.panel', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        // $stateProvider
        //     .state('app.panel', {
        //         url: '/disclaimer',
        //         middleware: ['AuthMiddleware'],
        //         views: {
        //             'content@app': {
        //                 templateUrl: 'app/main/panel/panel.html',
        //                 controller: 'PanelController as vm'
        //             }
        //         },
        //         resolve: {
        //             PanelData: function (msApi) {
        //
        //             }
        //         }
        //     });

        $stateProvider
            .state('app.contact', {
                url: '/contact',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/panel/contact.html',
                        controller: 'PanelController as vm'
                    }
                },
                resolve: {
                    PanelData: function (msApi) {

                    }
                }
            });

        //Add navigation Panel item
        msNavigationServiceProvider.saveItem('Panel', {
            title: 'Contact',
            icon: 'icon-apps',
            state: 'app.contact',
            class: '500',
            weight: 110
        });

        // msNavigationServiceProvider.saveItem('Closed beta', {
        //     title: 'Beta Version',
        //     icon: 'icon-alert-octagon',
        //     state: 'app.panel',
        //     class: 'beta-menu-item2',
        //     translate: 'PANEL.DISCLAIMER',
        //     weight: 9999
        // });

        $translatePartialLoaderProvider.addPart('app/main/panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.panel')
        .controller('PanelController', PanelController);

    /** @ngInject */
    function PanelController($http, portal_path  )
    {
        this.user = localStorage.getItem("userToken");
    }
})();

(function () {
    "use strict";

    angular.module('app.pagespeed', []);
})();

(function () {
    "use strict";

    angular.module('app.pagespeed')
        .service("pagespeedService", pagespeedService)

    function pagespeedService(portal_path, $q, $http, pagespeedFactory) {
        var api = {};

        api.getPageSpeedInfo = function (wId) {
            var result = $q.defer();

            $http.get(portal_path + 'websites/' + wId + '/pagespeed/google'  )
                .then(function (req) {

                    if(req.data.data[0].length > 0) {
                        var obj = req.data.data[0][0];

                        var newData  = {};
                        newData.date = moment(obj.created_at);
                        newData.mobile = {
                            score: obj.mobile
                        };

                        newData.desktop = {
                            score: obj.desktop
                        };


                        pagespeedFactory.setData(newData);
                    }

                    result.resolve();
                })
                .catch(function (e) {
                   result.reject(e);
                });

            return result.promise;
        }

        api.getOptions = function (wId) {
            var result = $q.defer();

            $http.get(portal_path + 'websites/' + wId + '/pagespeed/experius' )
                .then(function (req) {
                    if(req.data.data[0].length > 0) {

                        if(req.data.data[0]) {
                            var data = req.data.data[0].filter(function (objvalue) {
                               if(objvalue.name != "404 Module") {
                                   return objvalue;
                               }
                            });
                            pagespeedFactory.setOptions(data);
                            result.resolve();
                        }

                        result.reject();
                    }
                });

            return result.promise;
        }

        return api;
    }
})();

(function () {
    "use strict";

    angular.module('app.pagespeed')
        .factory("pagespeedFactory", pagespeedFactory);

    function pagespeedFactory() {
        var api = {};
            api.isSet = false;
            api.testDate = null;
            api.options = [];
            api.score = {
                mobile: 0,
                desktop: 0
            }

            api.setData = function (data) {
                this.isSet = true;
                this.testDate = data.date.format("DD-MM-YYYY");
                this.score.mobile = data.mobile.score;
                this.score.desktop = data.desktop.score;
            }

            api.getScore = function () {
                return this.score;
            }

            api.getDate = function () {
                return this.testDate;
            }

            api.setOptions = function (options) {
                this.options = options;
            }

            api.getOptions = function () {
                return this.options;
            }

            api.reset = function () {
                this.isSet = false;
                this.testDate = null;
                this.score = {
                    mobile: 0,
                    desktop: 0
                }
                this.options = [];
            }

        return api;
    }
})();

(function () {
    "use strict";

    angular.module('app.pagespeed')
        .controller("pagespeedController", pagespeedController);

    function pagespeedController(pagespeedService, $scope, websitesFactory, pagespeedFactory, $state, SupportService) {
        var vm = this;
            vm.isSet = false;
            vm.score = {
                mobile: 0,
                desktop: 0
            }
            vm.scoreDate = "0-0-1983";
            vm.options = [];

        function init() {
            var id = websitesFactory.getSelectedWebsite()["id"];
            pagespeedService.getPageSpeedInfo(id)
                .then(function () {
                    if(pagespeedFactory.isSet) {
                        vm.score = pagespeedFactory.getScore();
                        vm.scoreDate = pagespeedFactory.getDate();
                        vm.isSet = true;
                    } else {
                        vm.isSet = false;
                    }
                });

            pagespeedService.getOptions(id)
                .then(function () {
                    vm.options = pagespeedFactory.getOptions();
                });
        }


        vm.getScoreName = function (score) {
            var scoreName = "PAGESPEED.SCORES.POOR";

            if(score <= 59) {
                scoreName = "PAGESPEED.SCORES.POOR";
            } else if (score <= 84) {
                scoreName = "PAGESPEED.SCORES.NEEDSWORK";
            } else {
                scoreName = "PAGESPEED.SCORES.GOOD"
            }

            return scoreName;
        }

        vm.getScoreColor = function (score) {
            var color = "score-green";

            if(score <= 59) {
                color = "score-red";
            } else if (score <= 84) {
                color = "score-yellow";
            } else {
                color = "score-green";
            }

            return color
        }

        vm.getIcon = function (score, type) {
            var icon = "SPRITE_mobile_poor";

            if(score <= 59) {
                icon = "SPRITE_" + type + "_poor";
            } else if (score <= 84) {
                icon = "SPRITE_" + type + "_needswork";
            } else {
                icon = "SPRITE_" + type + "_good";
            }

            return icon;
        }

        vm.openSupportTicket = function (title) {
            SupportService.openTicketDialog(websitesFactory.selected["id"], title);
        }

        vm.isImplemented = function (bool) {

            if(bool) {
                return true;
            }

            return false;
        }

        vm.getRowClass = function (bool) {
            var Cssclass = "";

            if(bool) {
                Cssclass = "isImpl"
            }

            return Cssclass;
        }

        vm.getNumeral = function (num) {
            var split = num.toString().split('.');
            var str = split[0];

            if(split[1] !== '0') {
                str += ',' + split[1];
            }

            return str;
        }

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                pagespeedFactory.reset();
                init();
            }
        })
    }
})();

(function () {
    "use strict";

    angular.module('app.pagespeed')
        .config(config);

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.pagespeed', {
                url: '/pagespeed',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pagespeed/pagespeed.html',
                        controller: 'pagespeedController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('PageSpeed', {
            title: 'PageSpeed',
            icon: 'icon-speedometer',
            state: 'app.websites.pagespeed',
            class: '500',
            weight: 70
        });

        $translatePartialLoaderProvider.addPart('app/main/pagespeed');
    }
})();

(function(){
    'use strict';
    angular.module('app.nobyte', [])
})();
(function () {
    'use strict';

    angular.module('app.nobyte')
        .directive('nobyteServer', nobyteServer)

    function nobyteServer($mdDialog, $state, nobyte_template_path) {
        var byte = {};
        byte.template = '';
        byte.transclude = true;
        byte.controller = ['$scope', '$mdDialog', '$state', 'nobyte_template_path', function ($scope, $mdDialog, $state, nobyte_template_path) {
            $scope.$on('noByte', function (ev, data) {
                if(!data) {
                    Dialog();
                } else {
                    $mdDialog.hide();
                }
            });

            function Dialog() {
                //if (arguments[0]) {
                $mdDialog.show({
                    parent: angular.element("#dashboard"),
                    autoWrap: true,
                    templateUrl: nobyte_template_path
                    // controller: function () {
                    //     console.log("hallo");
                    //     var closeDialog = function () {
                    //         console.log("asd")
                    //         $mdDialog.hide();
                    //         $state.go('app.support.summary');
                    //     }
                    // },
                    //bindToController: false
                }, $mdDialog.alert());

                function DialogController($scope, $mdDialog, $state) {
                    $scope.closeDialog = function () {

                    }
                }
                //}
            }
        }];

        return byte;
    }
})();

(function () {
    'use strict';

    angular.module('app.nobyte')
        .controller('noByteController', noByteController);

    function noByteController($scope, $mdDialog, $state, nobyte_template_path) {
        $scope.closeDialog = function () {
            $mdDialog.hide();
            $state.go('app.websites.support.summary');
        }

        $scope.$on("noByte", function(e, value) {
            if(value) {
                Dialog();
            } else {
                $mdDialog.hide();
            }
        });

        function Dialog() {
            $mdDialog.show({
                parent: angular.element("#dashboard"),
                autoWrap: true,
                controller: noByteController,
                templateUrl: nobyte_template_path
            }, $mdDialog.alert());
        }
    }
})();
(function(){
    'use strict';
    angular.module('app.nobyte')
    .constant('nobyte_template_path', 'app/main/nobyte/nobyte.html');
})();
(function(){
    "use strict";

    angular.module("app.magento", []);
})();
(function () {
  "use strict";

  angular.module("app.magento")
    .service("magentoService", magentoService)

  function magentoService($http, $q, portal_path) {
    var api = {};

    api.getConfluencePage = function (id) {
      var result = $q.defer();

      $http.get(portal_path + "wordpress/" + id + "?expand=space,body.view,version,container")
        .then(function (req) {
          result.resolve(req.data);
        });


      return result.promise;
    }

    api.getMagentoManual = function (edition) {
      var result = $q.defer();

      $http.get(portal_path + "manuals/" + edition)
        .then(function (req) {
          if(req.data.error){
            result.reject();
          } else {
            result.resolve(req.data);
          }

        })
        .catch(function(err){
          result.reject(err);
        });

      return result.promise;
    }

    api.cacheFlush = function (id) {
        var result = $q.defer();
        $http.get(portal_path + 'websites/' + id+ '/flush_cache')
            .then(function (req) {
                if(req.data.data) {
                    result.resolve();
                }
            })
            .catch(function (err) {
               result.reject(err);
            });


        return result.promise;
    }

    return api;
  }
})();

(function(){
    "use strict";

    angular.module("app.magento")
    .factory("MagentoFactory", MagentoFactory)

    function MagentoFactory() {
        var api = {};
        api.data = [];

        api.setData = function(item, id) {
            item.id = id;

            this.data.push(item);
        }

        api.findDataById = function(id) {
            return this.data.filter(function(value, index) {
                if(value.id === id) {
                    return value;
                }
            });
        }

        api.clearData = function() {
            this.data = [];
        }

        return api;
    }
})();
(function () {
    "use strict";

    angular.module("app.magento")
        .controller("MagentoController", MagentoController)

    function MagentoController($scope, websitesFactory, tabsService, MagentoFactory, magentoModule) {
        var vm = this;

        function init() {
            var website = websitesFactory.getSelectedWebsite();

            isAvailable();
            getTabs(website.id);
        }

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                var id = websitesFactory.getSelectedWebsite()["id"];
                var data = MagentoFactory.findDataById(id);

                if (data.length > 0) {
                    $scope.$broadcast("newBoard", data[0]);
                    vm.data = data[0].widgets;
                    vm.stores = data[0].stores;
                    magentoModule.clearData();
                    isAvailable();
                } else {
                    magentoModule.clearData();
                    init();
                }
            }
        });

        function getTabs(wId) {
            tabsService.getBlocksByTabName("magento", wId)
                .then(function (data) {
                    $scope.$broadcast("newBoard", data);
                    vm.data = data.widgets;
                    vm.stores = data.stores;
                    MagentoFactory.setData(data, wId);
                });
        }

        function isAvailable() {
            var website = websitesFactory.getSelectedWebsite();

            if (!websitesFactory.getLiveEnv()) {
                websitesFactory.setStoreById(website.id);
                $scope.$broadcast("noByte", true);
                websitesFactory.setStoreById(website.id);
                return;
            } 

            if(websitesFactory.getTypeCode() == "magento2" || websitesFactory.getTypeCode() == "magento" ) {
                $scope.$broadcast("noByte", false);                   
            } else {
                $scope.$broadcast("noByte", true);
            }

        }
    }
})();

(function(){
    "use strict";

    angular.module("app.magento")
    .config(config)

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.magento', {
                url: '/magento',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/magento/magento.html',
                        controller: 'MagentoController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('Magento', {
            title: 'Magento',
            icon: 'icon-magentologo',
            state: 'app.websites.magento',
            class: '500',
            weight: 12
        });

        $translatePartialLoaderProvider.addPart('app/main/magento');
    }
})();

(function(){
  "use stric";

  angular.module("app.kennisbank", ["app.kennisbank.magentomanual", "app.kennisbank.nomanual"])
})();
(function(){
    "use strict";

    angular.module("app.kennisbank")
        .factory("kennisbankFactory", kennisbankFactory);

    function kennisbankFactory() {
        var api = {};

        api.magentoModuleList = [];
        api.magentoLink = {
            loaded: false,
            found: false,
            link: ""
        }

        api.setMagentoLink = function (obj) {
            this.magentoLink = obj;
        }

        api.getMagentoLink = function () {
            return this.magentoLink;
        }

        api.setMagentoModuleList = function (list) {
            this.magentoModuleList = list;
        }

        api.getMagentoModuleList = function () {
            return this.magentoModuleList;
        }

        return api;
    }
})();

(function () {
  "use strict";

  angular.module("app.kennisbank")
    .controller("KennisbankController", KennisbankController);

  function KennisbankController($scope, websitesFactory, magentoModule, widgetService, kennisbank_path, magentoService, $state) {
    var vm = this;
    vm.loadMagentoModules = true;
    vm.paths = [kennisbank_path + "magentomanual.table.html"];
    vm.magentoModules = {
      loaded: false,
      found: false,
      modules: []
    }

    vm.magentoManual = {
      loaded: false,
      found: false,
      edition: "community",
      data: []
    }

    function init() {
        $state.go("app.kennisbank.magentomanual");
    }

    init();

    vm.getLink = function (link) {
      return link.manual_link;
    };

    function getMagentoManual(edition) {
      magentoService.getMagentoManual(edition)
        .then(function (data) {
          vm.magentoManual.data = data["data"][0];
          vm.magentoManual.loaded = true;
          vm.magentoManual.found = true;
        })
        .catch(function (err) {
          vm.magentoManual.loaded = true;
          vm.magentoManual.found = false;
        });
    }

    function getType(name) {
      if (name === 1) {
        return "community";
      } else {
        return "enterprise";
      }
    }

    function getMagentoType(magento) {
      if (magento === "magento") {
        return "magento1-";
      } else {
        return "magento2-";
      }
    }

    function loadModules() {
      var datacode = "magento_module_infos";
      var website = websitesFactory.selected;

      if (website) {
        var website_id = website.id;
        var options = {
          range_start: moment().format(),
          store: 1,
          website: website_id,
          options: {
            interval: 300
          }
        }

        widgetService.getWidgetData(datacode, options)
          .then(function (data) {
            if (data.items.length > 0) {
              createMagentoManual(data.items[0]);
            } else {
                vm.magentoModules.loaded = true;
            }
          });
      }
    }

    function dataReset() {
      vm.magentoModule = {
        loaded: false,
        found: false,
        modules: []
      }

      vm.magentoManual = {
        loaded: false,
        found: false,
        edition: "community",
        data: []
      }
    }

    //Set all modules in a list is document id isset
    function createMagentoManual(items) {
      var arr = [];

      items.forEach(function (val) {
        val.docIsset = false;
        val.readIsset = false

        val.namesplit = val.name.replace("/", "-");

        //Check if document or readme isset
        if (val.documentation_id != "") {
          val.docIsset = true;
          arr.push(val);

          return;
        }

        //Check if readme isset
        if (val.readme) {
          val.readIsset = true;
          arr.push(val);
        }
      });

      if (arr.length > 0) {
        vm.magentoModules.found = true;
      } else {
        vm.magentoModules.found = false;
      }

      vm.magentoModules.modules = arr;
      vm.magentoModules.loaded = true;
    }

    $scope.$watch(function () {
      return websitesFactory.selected;
    }, function (newVal, oldVal) {
      if (newVal) {
        init();
        magentoModule.clearData();
        dataReset();
      }
    });
  }
})();

(function(){
  "use strict";
  
  angular.module("app.kennisbank")
  .constant("kennisbank_path", "app/main/kennisbank/")
})();
(function(){
  "use strict";

  angular.module("app.kennisbank")
  .config(config);

  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.kennisbank', {
                url: '/kennisbank',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/kennisbank/kennisbank.html',
                        controller: 'KennisbankController as vm'
                    }
                }
            });
		//
		// msNavigationServiceProvider.saveItem('Kennisbank', {
         //    title: 'Kennisbank',
         //    icon: 'icon-book-multiple',
         //    state: 'app.kennisbank',
         //    class: '500',
         //    weight: 40
		// });

        $translatePartialLoaderProvider.addPart('app/main/kennisbank');
  }
})();

(function(){
  angular.module('app.invoice', []);
})();
(function(){
  angular.module('app.invoice')
  .service('invoiceService', invoiceService)

  function invoiceService($http, $q, portal_path) {
    var api = {};

    api.getInvoice = function() {
      var result = $q.defer();

        $http.get(portal_path+"exact/invoices")
        .then(function(req){
          if(req.data.data) {
              if(req.data.data.length > 0) {
                  result.resolve(req.data.data);
              } else {
                  result.reject();
              }

          }
        })
        .catch(function(){
          result.reject();
        });
      return result.promise;
    }

    api.getFile = function(path, month) {
            $http({
                method: "GET",
                responseType: 'arraybuffer',
                url: path
            })
            .then(function(pdf){
                var blob = new Blob([pdf.data], {type: 'application/pdf' });
                saveAs(blob, "factuur-"+month+".pdf");
            });
    }

    return api;
  }
})();

(function () {
  angular.module('app.invoice')
    .controller('invoiceController', invoiceController);

  function invoiceController(invoice_path, $scope, websitesFactory, invoiceService, portal_path, dataTableLoc, $translateSanitization) {
    var vm = this;
    vm.paths = [invoice_path + "invoice.table.html"];
    vm.invoiceModule = {
      loaded: false,
      found: false,
      data: []
    }

    $scope.dtoptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      lengthMenu: [5, 10, 20, 50, 100],
      pageLength: 5,
      responsive: true,
        language: {
            url: dataTableLoc
        },
        order: [1, 'ASC']
    };

    function init() {
      var website = websitesFactory.selected;
      $translateSanitization.useStrategy(null);

      if (website) {
        invoiceService.getInvoice()
          .then(function (data) {
            vm.invoiceModule.loaded = true;
            vm.invoiceModule.found = true;
            vm.invoiceModule.data = data;
          })
          .catch(function () {
            vm.invoiceModule.loaded = true;
            vm.invoiceModule.found = false;
          });
      }
    }
    init();

    vm.getDownloadlink = function (path, month) {
      var newPath = portal_path + path

      invoiceService.getFile(newPath, month);
    };

    function dataReset() {
      vm.invoiceModule = {
        loaded: false,
        found: false,
        data: []
      };
    }

    $scope.$watch(function () {
      return websitesFactory.selected;
    }, function (newVal) {
      if (newVal) {
        dataReset();
        init();
      }
    });
  }
})();

(function(){
  "use strict";
  
  angular.module("app.invoice")
  .constant("invoice_path", "app/main/invoice/")
})();
(function () {
    angular.module('app.invoice')
        .config(config)

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.invoice', {
                url: '/invoice',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/invoice/invoice.html',
                        controller: 'invoiceController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('Invoices', {
            title: 'Facturen',
            icon: 'icon-receipt',
            state: 'app.websites.invoice',
            class: '500',
            translate: 'PANEL.INVOICE',
            weight: 80
        });

        $translatePartialLoaderProvider.addPart('app/main/invoice');
    }
})();

(function(){
  "use strict";

  angular.module("app.hotjar", []);
  
})();
(function () {
  "use strict";

  angular.module("app.hotjar")
    .config(config);

  function config() {
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
      h._hjSettings = { hjid: 495551, hjsv: 5 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script'); r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, '//static.hotjar.com/c/hotjar-', '.js?sv=');
  }
})();

(function () {
    "use strict";

    angular.module('app.ga')
        .service('gaService', gaService);

    /**
     * Service for Google Analytics
     *
     * @class gaService
     * @param $http
     * @param $q
     * @param portal_path
     * @param gaFactory
     * @return {{}}
     */
    function gaService($http, $q, portal_path, gaFactory) {
        var api = {};

        /**
         * Get Google Analytics API key
         *
         * @method getKey
         * @return {Promise}
         */
        api.getKey = function () {
            var result = $q.defer();

            $http.get(portal_path + 'ganalytics/key')
                .then(function (req) {
                    var data = req.data.data;

                    if(data) {
                        gaFactory.setData(data);
                        result.resolve();
                    }

                    result.reject();

                })
            return result.promise;
        }

        /**
         * Checks if Google Analytics is ready
         *
         * @method gapiReady
         */
        api.gapiReady = function () {
            var result = $q.defer();

            var key = gaFactory.getKey();
            gapi.analytics.ready(function() {
                gapi.analytics.auth.authorize({
                    "serverAuth": {
                        "access_token": key
                    }
                });

                gaFactory.setViewSelector();
                    var ViewSelector = gaFactory.getViewSelector();
                    ViewSelector.on('change', function(ids) {

                        gaFactory.setViewIds(ids);
                        result.resolve();
                    });
            });

            return result.promise;
        }

        /**
         * Get Conversion rate per browser provided by Google Analytics
         *
         * @method getConversionBrowser
         * @param ids
         * @return {Promise}
         */
        api.getConversionBrowser = function (ids) {
            var result = $q.defer();

            gapi.analytics.ready(function() {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:transactionsPerSession, ga:transactions',
                        dimensions: 'ga:browser',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                    },
                    chart: {
                        allowHtml: true,
                        container: 'conversionBrowserHide',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;

                    var total = {
                        conversionBrowser: 0,
                        transactions: 0
                    };

                    if(dataRows) {
                        //Calculate Total
                        dataRows.forEach(function (value) {
                            total.conversionBrowser += value.c[1].v;
                            total.transactions += value.c[2].v;
                        });

                        var data = dataRows.map(function (value) {
                            var obj = {};
                            obj.transactions = {};
                            obj.conversionBrowser = {};
                            obj.browser = "";

                            obj.browser = value.c[0].v;
                            obj.conversionBrowser.rawvalue = numeral(value.c[1].v).format('0.00');
                            obj.conversionBrowser.percentage = total.conversionBrowser / 100 * obj.conversionBrowser.rawvalue;
                            obj.transactions.rawvalue = numeral(value.c[2].v).value();
                            obj.transactions.percentage = (total.transactions / 100) * obj.transactions.rawvalue;

                            return obj;
                        });

                        result.resolve(data);
                    } else {
                        result.resolve([]);
                    }
                })

                gChart.set({query: {ids: ids}}).execute();
            });

            return result.promise;
        }

        /**
         * Get page count with pageTitle not found| niet gevonden
         *
         * @methis get404NotFound
         * @param ids
         * @return {Promise}
         */
        api.get404NotFound = function (ids) {
            var result = $q.defer();

            gapi.analytics.ready(function() {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:pageviews',
                        dimensions: 'ga:pageTitle',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                        filters: 'ga:pageTitle=~(not found|niet gevonden)'
                    },
                    chart: {
                        allowHtml: true,
                        container: 'PageNotFound',
                        type: 'TABLE'
                    }
                });
                var totalCount = 0;
                var regexTerms = /(404|not found|niet gevonden)/ig;

                gChart.on("success", function (response) {
                    var rows = response.data.rows;
                    if(rows) {
                        rows.forEach(function (value) {
                            if (regexTerms.test(value.c[0].v)) {
                                totalCount += value.c[1].v;
                            }
                        });
                    }
                    result.resolve(numeral(totalCount).value());
                });

                gChart.set({query: {ids: ids}}).execute();
            });

            return result.promise;
        }

        /**
         * Get Exit rate per page data provide by Google Analytics
         *
         * @method getLeavePage
         * @param ids
         * @return {Promise}
         */
        api.getLeavePage = function (ids) {
            var result = $q.defer();

            gapi.analytics.ready(function () {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:exits, ga:exitRate',
                        dimensions: 'ga:exitPagePath',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                        'max-results': 30,
                        'sort': '-ga:exits'
                    },
                    chart: {
                        allowHtml: true,
                        container: 'LeavepageHide',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var rows = response.data.rows;

                    if(rows) {
                        var newdata = rows.map(function (value) {
                            var newObj = {};
                            newObj.label = value.c[0].v;
                            newObj.counts = value.c[1].v;
                            newObj.percentage = numeral(value.c[2].v).format('0');

                            return newObj;
                        });

                        result.resolve(newdata);
                    } else {
                        result.resolve([]);
                    }
                });

                gChart.set({query: {ids: ids}}).execute();
            });


            return result.promise;
        }

        /**
         * Get the Conversion rate per Device
         *
         * @method getConversionDevice
         * @param ids
         * @return {Promise}
         */
        api.getConversionDevice = function (ids) {
            var result = $q.defer();

            gapi.analytics.ready(function () {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:transactionsPerSession, ga:transactions',
                        dimensions: 'ga:deviceCategory',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                    },
                    chart: {
                        allowHtml: true,
                        container: 'conversionBrowserHide',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;

                    var total = {
                        conversionBrowser: 0,
                        transactions: 0
                    };

                    //Calculate Total
                    if(dataRows) {
                        dataRows.forEach(function (value) {
                            total.conversionBrowser += value.c[1].v;
                            total.transactions += value.c[2].v;
                        });


                        var data = dataRows.map(function (value) {
                            var obj = {};
                            obj.transactions = {};
                            obj.conversionBrowser = {};
                            obj.device = "";

                            obj.device = value.c[0].v;
                            obj.conversionBrowser.rawvalue = numeral(value.c[1].v).format('0.00');
                            obj.conversionBrowser.percentage = total.conversionBrowser / 100 * obj.conversionBrowser.rawvalue;
                            obj.transactions.rawvalue = numeral(value.c[2].v).value();
                            obj.transactions.percentage = (total.transactions / 100) * obj.transactions.rawvalue;

                            return obj;
                        });

                        result.resolve(data);
                    } else {
                        result.resolve([]);
                    }
                })

                gChart.set({query: {ids: ids}}).execute();
            });

            return result.promise;
        }

        /**
         * Get top ten search querys
         *
         * @method getTopSearchQuery
         * @param ids
         * @return {Promise}
         */
        api.getTopSearchQuery = function (ids) {
            var result = $q.defer();

            //gapi.analytics.ready(function () {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:searchUniques, ga:searchExitRate',
                        dimensions: 'ga:searchKeyword',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                        'max-results': 10,
                        'sort': '-ga:searchUniques'
                    },
                    chart: {
                        allowHtml: true,
                        container: 'TopSearchQueryHide',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;

                    if(dataRows) {
                        var data = dataRows.map(function (value) {
                            var newObj = {};
                                newObj.label = value.c[0].v;
                                newObj.hits = value.c[1].v;
                                newObj.percentage = numeral(value.c[2].v).format("0");

                                return newObj;
                        });

                        result.resolve(data);
                    } else {
                        result.resolve([]);
                    }
                });

                gChart.set({query: {ids: ids}}).execute();
           //});

            return result.promise;
        }

        /**
         * Get Bounce page data provide by Google Analytics
         *
         * @method getBouncePage
         * @param ids
         * @return {Promise}
         */
        api.getBouncePage = function (ids) {
            var result = $q.defer();

            var gChart = new gapi.analytics.googleCharts.DataChart({
                query: {
                    metrics: 'ga:pageviews, ga:bounceRate',
                    dimensions: 'ga:pagePath',
                    'start-date': '30daysAgo',
                    'end-date': 'today',
                    'max-results': 10,
                    'sort': '-ga:bounceRate'
                },
                chart: {
                    allowHtml: true,
                    container: 'bouncePageHide',
                    type: 'TABLE'
                }
            });

            gChart.on("success", function (response) {
                var dataRows = response.data.rows;

                if(dataRows) {
                    var data = dataRows.map(function (value) {
                        var newObj = {};
                            newObj.label = value.c[0].v;
                            newObj.pageCount = value.c[1].v;
                            newObj.bounce = value.c[2].v;

                            return newObj;
                    });

                    result.resolve(data);
                } else {
                    result.resolve([]);
                }
            });

            gChart.set({query: {ids: ids}}).execute();

            return result.promise;
        }

        /**
         * Get Top sold products base on top ten querys
         *
         * @method getTopSoldProducts
         * @param ids
         * @return {Promise}
         */
        api.getTopsoldProducts = function (ids) {
            var result = $q.defer();

            var gChart = new gapi.analytics.googleCharts.DataChart({
                query: {
                    metrics: 'ga:searchResultViews, ga:searchExits',
                    dimensions: 'ga:searchKeyword',
                    'start-date': '30daysAgo',
                    'end-date': 'today',
                    'max-results': 10,
                    'sort': '-ga:searchResultViews'
                },
                chart: {
                    allowHtml: true,
                    container: 'bouncePageHide',
                    type: 'TABLE'
                }
            });

            gChart.on("success", function (response) {
                var dataRows = response.data.rows;

                if(dataRows) {
                    var data = dataRows.map(function (value) {
                        var newObj = {};
                        newObj.label = value.c[0].v;
                        newObj.pageCount = value.c[1].v;
                        newObj.bounce = value.c[2].v;

                        return newObj;
                    });

                    result.resolve(data);
                } else {
                    result.resolve([]);
                }
            });

            gChart.set({query: {ids: ids}}).execute();

            return result.promise;
        }

        /**
         * Check if 404 module is active
         *
         * @method get404Module
         * @param wId
         * @return {Promise}
         */
        api.get404Module = function (wId) {
            var result = $q.defer();

            $http.get(portal_path + 'websites/' + wId + '/pagespeed/experius' )
                .then(function (req) {
                    if(req.data.data.length > 0) {

                        if(req.data.data) {
                            var data = req.data.data.filter(function (objvalue) {
                                if(objvalue.name === "404 Module") {
                                    return objvalue;
                                }
                            });

                            if(data.length > 0 && data[0].implemented) {
                                result.resolve(true);
                            } else {
                                result.resolve(false);
                            }
                        }

                        result.reject();
                    }
                });

            return result.promise;
        }

        return api;
    }
})();

(function () {
    "use strict";

    angular.module('app.ga')
        .factory("gaFactory", gaFactory)

    function gaFactory() {
        var api = {};
            api.data = [];
            api.active = false;
            api.pageActive = false;
            api.key = null;
            api.email = null;
            api._doReset = false;
            api.ViewSelector = null;
            api.ViewSelectorIsSet = null;
            api.ViewIds = null;
            api.ViewChange = 0;
            api.activeOrClose = "noactive";

            api.setData = function (data) {
                this.data = data;

                this.setKey(data.key);
                this.setEmail(data.email);
                this.setActive(data.active);
            }

            api.setKey = function (key) {
                this.key = key;
            }

            api.getKey = function () {
                return this.key;
            }

            api.setActive = function (active) {
                this.active = active;
            }

            api.getActive = function () {
                return this.active;
            }

            api.setEmail = function (email) {
                this.email = email;
            }

            api.getEmail = function () {
                return this.email;
            }

            api.reset = function () {
                this.data = [];
                this.active = false;
                this.key = null;
                this.email = null;
                this._doReset = false;
            }

            api.setViewSelector = function () {
                this.ViewSelector = new gapi.analytics.ViewSelector({
                    container: 'view-selector'
                });

                this.ViewSelector.execute();
            }

            api.getViewSelector = function () {
                return this.ViewSelector;
            }

            api.getViewIds = function () {
                return this.ViewIds
            }

            api.setViewIds = function (ids) {
                this.ViewIds = ids;
            }

            api.increaseViewChange = function () {
                this.ViewChange++;
            }

            api.ViewSelectorEvent = function () {
              var selector = this.ViewSelector;
              var self = this;

              selector.on('change', function (ids) {
                  self.ViewIds = ids;
                  self.ViewSelectorIsSet = true;
                  self.increaseViewChange();
              });
            };

            api.reset = function () {
                this.ViewIds = null;
                this.ViewSelectorIsSet = null;
            }

        return api;
    }
})();

(function () {
    "use strict";
    angular.module("app.ga")
        .controller("gaController", gaController)
        .controller("gaNoActiveControllor", gaNoActiveControllor);
    /**
     * Controller for module app.ga
     *
     * @class gaController
     * @param $scope
     * @param websitesFactory
     * @param gaService
     * @param gaFactory
     * @param $mdDialog
     * @param $state
     * @param SupportService
     */
    function gaController($scope, websitesFactory, gaService, gaFactory, $mdDialog, $state, SupportService) {
        var vm = this;

        function init() {


            //Prevents rerender
            if(gaFactory.pageActive) {
                gaFactory.reset();
                gaFactory.ViewSelector.execute();
                return;
            }

            gaService.getKey()
                .then(function () {
                    var isActive = gaFactory.getActive()
                    if(isActive) {
                        gaService.gapiReady()
                            .then(function () {
                                gaFactory.ViewSelectorIsSet = true;
                                gaFactory.pageActive = true;
                                gaFactory.increaseViewChange();
                                gaFactory.ViewSelectorEvent();

                                // var ViewSelector = gaFactory.getViewSelector();
                                // ViewSelector.on('change', function(ids) {
                                //
                                // })
                            });
                    } else {
                        if(gaFactory.activeOrClose === "noactive") {
                            $mdDialog.show({
                                locals: {title: "GA.NOACCESS.TITLE"},
                                controller: "gaNoActiveControllor as vm",
                                templateUrl: 'app/main/ga/modals/notaccess.html'
                            })
                                .finally(function () {
                                    if (gaFactory._doReset) {
                                        gaFactory.reset();
                                        init();
                                    }
                                });
                        } else {
                            gaFactory.activeOrClose = "noactive";
                        }
                    }
                });
        }

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                init();
            }
        });

        /**
         * Open new ticket dialog
         *
         * @event openSupportTicker
         * @param title {string}
         */
        $scope.$on('openSupportTicket', function (ev, title) {
            SupportService.openTicketDialog(websitesFactory.selected["id"], title);
        });


        /**
         * Open Modal if app don't have access to Google Analytics
         *
         * @method openModal
         */
        vm.openModal = function () {
            $mdDialog.show({
                locals: {title: "GA.NOACCESS.TITLE2"},
                controller: "gaNoActiveControllor as vm",
                templateUrl: 'app/main/ga/modals/notaccess.html'
            })
                .finally(function () {
                    if(gaFactory._doReset) {
                        gaFactory.reset();
                        init();
                    }
                });
        }

    }

    /**
     * Controller for NoActive module
     *
     * @class gaNoActiveController
     * @param gaFactory
     * @param $mdDialog
     * @param title
     */
    function gaNoActiveControllor(gaFactory, $mdDialog, title) {
        var vm = this;
            vm.email = gaFactory.getEmail();
            vm.title = title;

        vm.closeDialoog = function () {
            gaFactory.activeOrClose = "close";
            $mdDialog.hide();
        }

        vm.accountAdd = function () {
            gaFactory._doReset = true;
            $mdDialog.hide();
        }
    }
})();

(function () {
    "use strict";

    angular.module("app.ga")
        .constant("ga_widget_path", "app/main/ga/widgets/")
        .constant("ga_path", "app/main/ga/")
})();

(function(){
    "use strict";

    angular.module("app.ga")
    .config(config);

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('app.websites.dashboard.ga', {
                url: '/analytics',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ga/ga.html',
                        controller: 'gaController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('Dashboard.Analytics', {
            title: 'Conversie',
            icon: 'icon-percent',
            state: 'app.websites.dashboard.ga',
            class: '500',
            weight: 10
        });

        $translatePartialLoaderProvider.addPart('app/main/ga');
    }

})();

(function(){
    "use strict";

    angular.module('app.exbtw', []);
    
})();
(function(){
    "use strict";

    angular.module("app.exbtw")
    .directive("exBtw", exBtw);

    function exBtw() {
        var tmpl = {};
        tmpl.templateUrl = "app/main/exbtw/exbtw.html";
        

        return tmpl; 
    }
})();
(function(){
    'use strict';

    angular.module('app.exloading', []);
})();
(function(){
    'use strict';

    angular.module('app.exloading')
    .directive("exLoading", exLoading);

    function exLoading() {
        var tmpl = {};
        tmpl.template = '<div class="exLoading"><div class="loader">Loading...</div></div>';
        return tmpl;
    }
})();
(function(){
    'use strict';

    angular
    .module('app.errormessage', []);

})();
(function(){
    'use strict';

    angular
    .module('app.errormessage')
    .directive('errormessage', errormessage);

    function errormessage() {
        return {
            restrict: 'E',
            scope: {
                header: '@',
                text: '@'
            },
            templateUrl: 'app/main/errormessage/errormessage.html'
        };
    }
})();
(function(){
    "use strict";

    angular.module("app.dashboardv2")
        .service("dashboardServicev2", dashboardService);

    /**
     * Service for the Dashboard module
     *
     * @param $http
     * @param $q
     * @param portal_path
     * @param dashboardFactoryv2
     * @param gaFactory
     * @class dashBoardService
     */
    function  dashboardService($http, $q, portal_path, dashboardFactoryv2, gaFactory) {
        var api = {};

        /**
         * Get Magento Sales
         *
         * @method getSales
         * @param websiteid
         * @return {Promise}
         */
        api.getSales = function (websiteid) {
            var result = $q.defer();
            $http.get(portal_path + 'websites/' + websiteid + '/dashboard/data/sales')
                .then(function (req) {
                    if(req) {
                        dashboardFactoryv2.setData(req.data.data[0]);
                        result.resolve(true);
                    }

                    result.reject();
                })
                .catch(function (e) {
                    result.reject(e);
                });

            return result.promise;
        }

        /**
         * Provide the general info about a Magento shop
         *
         * @method getGeneralInfo
         * @param websiteid
         * @return {Promise}
         */
        api.getGeneralInfo = function (websiteid) {
            var result = $q.defer();
            $http.get(portal_path + 'websites/' + websiteid + '/dashboard/data/status')
                .then(function (req) {
                    if(req) {
                        var website = {};
                        var suite = {};
                        website.loading = false;
                        website.online_status = req.data.data[0].online_status;
                        website.last_loadtime_date = moment(req.data.data[0].last_loadtime_date).format("DD-MM-YYYY HH:mm");
                        website.last_loadtime = req.data.data[0].last_loadtime;

                        suite.last_suite_run = moment(req.data.data[0].last_suite_run).format("DD-MM-YYYY HH:mm")
                        dashboardFactoryv2.setWebsiteInfo(website);
                        dashboardFactoryv2.setSuiteInfo(suite);

                        if(req.data.data[0].last_suite_tests.length > 0) {
                            dashboardFactoryv2.setTestInfo(req.data.data[0].last_suite_tests);
                        }

                        result.resolve();
                    }
                })

            return result.promise;
        }

        /**
         * Checks if Google Analytics API is loaded
         *
         * @method gapiReady
         */
        api.gapiReady = function () {
            var result = $q.defer();

            var key = gaFactory.getKey();
            gapi.analytics.ready(function() {
                gapi.analytics.auth.authorize({
                    "serverAuth": {
                        "access_token": key
                    }
                });

                dashboardFactoryv2.setViewSelector("general-ga-hidden");
                var ViewSelector = dashboardFactoryv2.getViewSelector();
                ViewSelector.on('change', function(ids) {

                    dashboardFactoryv2.setViewId(ids);
                    result.resolve();
                });
            });

            return result.promise
        }

        /**
         * Get visitors by Google Analytics
         *
         * @method getVisitors
         * @param id
         * @param obj
         * @return {Promise}
         */
        api.getVisitors = function (id, obj) {
            var result = $q.defer();

            gapi.analytics.ready(function() {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:users',
                        'start-date': obj.startDate,
                        'end-date': obj.endDate,
                    },
                    chart: {
                        allowHtml: true,
                        container: obj.container,
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;
                    dataRows.forEach(function (value) {
                        result.resolve(value.c[0].v)
                    });
                });

                gChart.set({query: {ids: id}}).execute();
            });

            return result.promise;
        }

        /**
         * Get revenue provide by Google Analytics
         *
         * @method getRevenue
         * @param id
         * @return {Promise}
         */
        api.getRevenue = function (id) {
            var result = $q.defer();

            gapi.analytics.ready(function() {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:transactionRevenue',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                    },
                    chart: {
                        allowHtml: true,
                        container: 'shopRevenue',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;
                    dataRows.forEach(function (value) {
                        var value = "€" + numeral(value.c[0].v).format('0,0.00');
                        result.resolve(value);
                    });
                });

                gChart.set({query: {ids: id}}).execute();
            });

            return result.promise;
        }

        /**
         * Get conversion rate provide by Google Analytics
         *
         * @method getConversion
         * @param id
         * @return {Promise}
         */
        api.getConversion = function (id) {
           var result = $q.defer();

           gapi.analytics.ready(function () {
               var gChart = new gapi.analytics.googleCharts.DataChart({
                   query: {
                       metrics: 'ga:transactionsPerSession',
                       'start-date': '30daysAgo',
                       'end-date': 'today',
                   },
                   chart: {
                       allowHtml: true,
                       container: 'conversionRate',
                       type: 'TABLE'
                   }
               });

               gChart.on("success", function (response) {
                   var dataRows = response.data.rows;
                   dataRows.forEach(function (value) {
                       var value = numeral(value.c[0].v).format('0.00') + '%';
                       result.resolve(value);
                   });
               });

               gChart.set({query: {ids: id}}).execute();
           });

           return result.promise;
        }

        /**
         * Get ordervalue by Google Analytics
         *
         * @method getOrderValue
         * @param id
         * @return {Promise}
         */
        api.getOrderValue = function (id) {
            var result = $q.defer();

            gapi.analytics.ready(function () {
                var gChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:revenuePerTransaction',
                        'start-date': '30daysAgo',
                        'end-date': 'today',
                    },
                    chart: {
                        allowHtml: true,
                        container: 'orderValue',
                        type: 'TABLE'
                    }
                });

                gChart.on("success", function (response) {
                    var dataRows = response.data.rows;
                    dataRows.forEach(function (value) {
                        var value = numeral(value.c[0].v).format('0');
                        result.resolve(value);
                    });
                });

                gChart.set({query: {ids: id}}).execute();
            });

            return result.promise;
        }

        api.getCmsParentPage = function () {
            var result = $q.defer();

            $http.get(portal_path + 'dashboard/cms/pages')
                .then(function (req) {
                    result.resolve(req.data.data[0]);
                });

            return result.promise;
        }

        return api;
    }
})();

(function(){
    "use strict";

    angular.module("app.dashboardv2")
        .factory("dashboardFactoryv2", dashboardFactory);

    function  dashboardFactory() {
        var api = {};
            api.data = {};
            api.generalData = {};
            api.ViewSelector = null;
            api.viewId = 0;
            api.websiteInfo = {
                loading: false,
                online_status: false,
                last_loadtime_date: 0,
                last_loadtime: 0
            }
            api.suiteInfo = {
                last_suite_run: false
            }
            api.testInfo = [];

            api.setData = function (data) {
                this.data = data;
            }

            api.getData = function () {
                return this.data;
            }

            api.setGeneralData = function (data) {
                this.generalData = data;
            }

            api.getGeneralData = function () {
                return this.generalData;
            }

            api.getTodayData = function () {
                var today = {};
                today.loading = false;
                today.today_orders = this.data.today_orders;
                today.today_revenue = this.data.today_revenue;

                return today;
            }

            api.getHistoryData = function () {
                this.data.history.loading = false;
                return this.data.history;
            }

            api.setViewSelector = function (selector) {
                this.ViewSelector = new gapi.analytics.ViewSelector({
                    container: selector
                });

                this.ViewSelector.execute();
            }

            api.setViewId = function (id) {
                this.viewId = id;
            }

            api.getViewId = function () {
                return this.viewId;
            }

            api.getViewSelector = function () {
                return this.ViewSelector;
            }

            api.setWebsiteInfo = function (websiteInfo) {
                this.websiteInfo = websiteInfo;
            }

            api.getWebsiteInfo = function () {
                return this.websiteInfo;
            }

            api.setSuiteInfo = function (info) {
                this.suiteInfo = info;
            }

            api.getSuiteInfo = function () {
                return this.suiteInfo;
            }

            api.setTestInfo = function (tests) {
                this.testInfo = tests;
            }

            api.getTestInfo = function () {
                return this.testInfo;
            }

        return api;
    }
})();

(function(){
    "use strict";

    angular.module("app.dashboardv2")
        .controller("DashboardControllerv2", DashboardController);

    /**
     * DashboardController for the dashboard module
     *
     * @param $scope
     * @param websitesFactory
     * @constructor
     */
    function  DashboardController($scope, websitesFactory, dashboardServicev2) {
        var vm = this;
            vm.cmsData = {
                list: [],
                loaded: false
            }
        function init() {
            getCmsPages();
        }

        function getCmsPages() {
            dashboardServicev2.getCmsParentPage()
                .then(function (cmsData) {
                    vm.cmsData.list = cmsData;
                    vm.cmsData.loaded = true;
                });
        }

        $scope.$watch(function () {
            return websitesFactory.selected
        }, function (website) {
            if (website && websitesFactory.getSelectedWebsite()) {
                reset();
                init();
            }
        });

        /**
         * @event gaStatus;
         * @param {boolean} Set the status of Google Analytics
         */
        $scope.$on('gaStatus', function (ev, status) {
            $scope.$broadcast('active', status);
        });

        function reset() {

        }
    }
})();

(function () {
    "use strict";
    angular.module("app.dashboardv2")
        .constant("dashboard_path", "app/main/dashboard/")
})();

(function(){
    "use strict";

    angular.module("app.dashboardv2")
        .config(config);

    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider
            .state('app.websites.dashboard', {
                url: '/dashboard',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardControllerv2 as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('Dashboard', {
            title: 'Analytics',
            icon: 'icon-resize-bottom-right',
            state: 'app.websites.dashboard',
            class: '500',
            weight: 10
        });

        msNavigationServiceProvider.saveItem('Dashboard.IncreaseVisitors', {
            title: 'Bezoekers',
            icon: 'icon-people',
            state: 'app.websites.dashboard.increasevisitor',
            class: '500 disable-menu-item',
            weight: 12
        });

        // msNavigationServiceProvider.saveItem('Dashboard.IncreaseConversion', {
        //     title: 'Conversie verhogen',
        //     icon: 'icon-resize-bottom-right',
        //     state: 'app.websites.dashboard.increaseconversion',
        //     class: '500 disable-menu-item',
        //     weight: 13
        // });

        msNavigationServiceProvider.saveItem('Dashboard.IncreaseOrders', {
            title: 'Orderwaarde',
            icon: 'icon-resize-bottom-right',
            state: 'app.websites.dashboard.increaseorders',
            class: '500 disable-menu-item',
            weight: 14
        });

        $translatePartialLoaderProvider.addPart('app/main/dashboard');
    }
})();

(function(){
    "use strict";

    angular.module('app.custompage', ["app.custompage.custom"])
})();

(function(){
    "use strict";

    angular.module('app.custompage')
        .service("customPageService", CustomPageService);

    function CustomPageService($http, $q, portal_path) {
        var api = {};

        api.test = function () {
            void 0;
        }

        api.getMenuItems = function () {
            var result = $q.defer();

            $http.get(portal_path + 'dashboard/cms/pages/menu')
                .then(function (req) {
                    var data = req.data.data[0];

                    if(data) {
                        result.resolve(data);
                    } else {
                        result.reject();
                    }
                });

            return result.promise;
        }

        return api;
    }
})();

(function(){
    "use strict";

    angular.module('app.custompage')
        .service("customPageController", CustomPageController);

    function CustomPageController(msNavigationServiceProvider) {
        var vm = this;

        msNavigationServiceProvider.saveItem('TestItem', {
            title: '',
            icon: 'icon-resize-bottom-right',
            state: 'app.custompage.custom',
            class: '500',
            weight: 10
        });
    }
})();

(function(){
    "use strict";

    angular.module('app.custompage')
        .config(config)

    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.custompage', {
                url: '/custom',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/custompage/custom.html',
                        controller: 'customPageController'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('app.cms', ['app.cms.group', 'app.cms.single', 'app.cms.widgets', 'app.cms.breadcrumbs']);

})();

(function () {
    'use strict';

    angular.module('app.cms')
        .service("cmsService", cmsService);

    function cmsService($http, $q, portal_path) {
        var api = {};

        api.getSinglePage = function (slug) {
            var result = $q.defer();

            $http.get(portal_path + 'dashboard/cms/pages/' + slug)
                .then(function (req) {
                    if (req.data) {
                        result.resolve(req.data.data[0]);
                    }
                });

            return result.promise;
        }

        api.getPages = function (slug) {
            var result = $q.defer();

            $http.get(portal_path + 'dashboard/cms/pages')
                .then(function (req) {
                    var newData = req.data.data[0].filter(function (obj) {

                        if(obj.slug === slug) {
                            return obj
                        }
                    });

                    result.resolve(newData[0]);
                });

            return result.promise;
        }

        api.getAdBlock = function (websiteId) {
            var result = $q.defer();

            $http.get(portal_path + 'websites/' + websiteId + '/blockedimages')
                .then(function (req) {
                    if(req.data.data[0].length > 0) {
                        result.resolve(req.data.data[0])
                    } else {
                        result.reject();
                    }
                })
            return result.promise;
        }

        return api;
    }
})();

(function () {
    'use strict';

    angular.module('app.cms')
        .controller("cmsController", cmsController);

    function cmsController($state, cmsService) {
        var vm = this;
        var current = $state.current.url;
        var slugs = ['bezoekers-verhogen', 'orderwaarde-verhogen'];
            vm.title = '';
            vm.content = '';
            vm.loaded = false;

        vm.renderHtml = function (html) {
            return html;
        }

        function init() {
            if (current === '/bezoekers') {
                loadData(slugs[0]);
            } else {
                loadData(slugs[1]);
            }
        }

        init();


        function loadData(slug) {
            cmsService.getPages(slug)
                .then(function (data) {
                   vm.title = data.title;
                });

            cmsService.getSinglePage(slug)
                .then(function (data) {
                   vm.content = data.content;
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.cms')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('app.websites.cms', {
                url: '/cms',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/cms.html',
                        controller: 'cmsController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increasevisitor', {
                url: '/bezoekers',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/cms.html',
                        controller: 'cmsController as vm'
                    }
                }
            });

        $stateProvider
            .state('app.websites.dashboard.increaseorders', {
                url: '/orderwaarde',
                middleware: ['AuthMiddleware'],
                views: {
                    'content@app': {
                        templateUrl: 'app/main/cms/cms.html',
                        controller: 'cmsController as vm'
                    }
                }
            });
    }
})();

(function () {
    "use strict";

    angular.module('app.changelog', []);
})();

(function () {
    "use strict";

    angular.module('app.changelog')
        .factory('changelogFactory', changelogFactory)

    function changelogFactory () {
        var api = {};

        api.showChangelog = false;

        return api;
    }
})();

(function () {
    "use strict";

    angular.module('app.changelog')
        .directive('changelog', changelog)

    function changelog() {
        var directive = {
            restrict: 'EA',
            controller: changelogController,
            templateUrl: 'app/main/changelog/changelog.html',
            controllerAs: 'vm',
            bindToController: true
        }

        changelogController.$inject = ['$mdDialog', '$rootScope', 'changelogFactory', 'version', '$timeout'];

        function changelogController($mdDialog, version, $timeout) {
            var vm = this;

            var alreadyRead = localStorage.getItem("changelog");
            var userVersion = localStorage.getItem("exVersion");

            if (userVersion < userVersion) {
                localStorage.removeItem("changelog")
            }

            if (alreadyRead && userVersion >= version) {

            } else {
                $timeout(function () {
                    $mdDialog.show({
                        controller: DialogController,
                        templateUrl: 'app/main/changelog/changelog.popup.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        targetEvent: null
                    });
                }, 2500)
            }
        }

        function DialogController($scope, $mdDialog, version) {
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.answer = function (answer) {
                localStorage.setItem("changelog", true);
                localStorage.setItem("exVersion", version);
                $mdDialog.hide(answer);
            };
        }

        return directive
    }
})();

(function () {
    "use strict";

    angular.module('app.changelog')
        .config(config)

    function config() {

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');    
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $window, jwtHelper, $state)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.rotate180deg = false;

        // Auth
        vm.user = localStorage.getItem("userToken");



        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.logout = logout;
        vm.settings = settings;
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            getInitials();
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            //localStorage.clear();
            localStorage.removeItem("userToken");
            localStorage.removeItem("userMail");
            $window.location.assign('/login');
        }

        /**
         * Settings Function
         */
        function settings() {
            $state.go("app.websites.settings.account");
        }


        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            if(vm.rotate180deg) {
                vm.rotate180deg = false;
            } else {
                vm.rotate180deg = true;
            }

            $rootScope.$emit("toggleNav");
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        function getInitials() {
            var token = localStorage.getItem("userToken");
            var tokenPayload = jwtHelper.decodeToken(token);
            var username = tokenPayload.username;

            vm.firstLetter = username[0]
        }
    }

})();

(function(){
  "use strict";

  angular.module("app.takeover", [])
  
})();
(function(){
  "use strict";

  angular.module("app.takeover")
  .service("TakeoverService", TakeoverService)

  function TakeoverService(portal_path, $http, $q) {
    var api = {};

    api.getToken = function(token) {
      var result = $q.defer();

      $http({
        method: 'POST',
        url: portal_path+"auth/takeover",
        data: {
          takeover: token
        }
      })
      .then(function(req){
        if(req.status != 200) {
            result.reject();
        }

        if(req.data.data.length > 0) {
          result.resolve(req.data.data[0])
        }
      })
      .catch(function(err){
        localStorage.setItem("userToken", "");
        result.reject(err.error.message);
      });

      return result.promise;
    };

    return api;

  }
})();

(function(){
  "use strict";

  angular.module("app.takeover")
  .controller("TakeoverController", TakeoverController);

  function TakeoverController(TakeoverService, $state) {
    var token = atob($state.params.token)

    TakeoverService.getToken(token)
    .then(function(userToken){
      localStorage.setItem("userToken", userToken);
      $state.go("app.websites.magento");
    })
    .catch(function(err){
      $state.go('app.login');
    });
  }
})();

(function () {
    "use strict";

    angular.module("app.takeover")
        .config(config)

    function config($stateProvider) {
        $stateProvider
            .state('app.takeover', {
                url: '/takeover/:token',
                views: {
                    'main@': {
                        template: '',
                        controller: 'TakeoverController as vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    /**
     * Main Module of the fuse
     * @module fuse
     */
    angular
        .module('fuse', loadModule());

    function loadModule() {
        if (localStorage.getItem("tdbg")) {
            return debugModule();
        }

        return productionModule();
    }

    function debugModule() {
        return [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Main panel
            'app.panel',

            // Insights
            'app.insights',

            // Login
            'app.login',

            //Sales
            'app.sales',

            //Magento
//            'app.magento', // MER-1510

            // Websites
            'app.websites',

            // Tabs
            'app.tabs',

            //Widgets
            'app.insights.dashboard.widgets',

            // Excl BTW
            'app.exbtw',

            // Support
            'app.support',

            // Settings
            'app.settings',

            // Error Message
            'app.errormessage',

            // Authorization
            'app.auth',

            // Release notes
            'app.releasenotes',

            //NoByte hosting
            'app.nobyte',

            // Ex loading
            'app.exloading',

            // Social Media
            'app.social',

            //Wootric
            'wootric',

            // Google Analytics
            'angular-google-analytics',

            // Ghost Inspector
            'app.ghostInspector',

            // Sentry
            'sentry',

            //Kennisbank
//            'app.kennisbank', // MER-1508

            //Takeover
            'app.takeover',

            //Facturen
            'app.invoice',

            //Angular JWT
            'angular-jwt',

            // Google Analytics
            'app.ga',

            // Google PageSpeed
            'app.pagespeed',

            // Dashboard
            'app.dashboardv2',

            'app.cms',

            // Changelog
            'app.changelog',

            //Custom page
            'app.custompage'

        ];
    }

    function productionModule() {
        return [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Main panel
            'app.panel',

            // Insights
            'app.insights',

            // Login
            'app.login',

            //Sales
            'app.sales',

            //Magento
//            'app.magento', // MER-1510

            // Websites
            'app.websites',

            // Tabs
            'app.tabs',

            //Widgets
            'app.insights.dashboard.widgets',

            // Excl BTW
            'app.exbtw',

            // Support
            'app.support',

            // Settings
            'app.settings',

            // Error Message
            'app.errormessage',

            // Authorization
            'app.auth',

            // Release notes
            'app.releasenotes',

            //NoByte hosting
            'app.nobyte',

            // Ex loading
            'app.exloading',

            // Social Media
            'app.social',

            //Wootric
            'wootric',

            // Google Analytics
            'angular-google-analytics',

            // Ghost Inspector
            'app.ghostInspector',

            //Sentry/Raven
            'ngRaven',

            // Sentry
            'sentry',

            //Kennisbank
//            'app.kennisbank', // MER-1508

            //Takeover
            'app.takeover',

            //Hotjar
            'app.hotjar',

            //Facturen
            'app.invoice',

            //Angular JWT
            'angular-jwt',

            // Google Analytics
            'app.ga',

            // Google PageSpeed
            'app.pagespeed',

            // Dashboard
            'app.dashboardv2',

            'app.cms',

            // Changelog
            'app.changelog',

            //Custom page
            'app.custompage'
        ];
    }
})();

(function(){
    'use strict';

    angular.module('fuse')
    .factory('MainFactory', MainFactory);

    function MainFactory() {
        var factory = {};
        var isLoaded = [];

        /**
         * Checks what is loaded
         * @param {Array} dep
         * @return Array
         */
        factory.WIL = function(dep) {
            return dep.filter(function(value, index){
                if(isLoaded.indexOf(value) > -1) {
                } else {
                    isLoaded.push(value);
                    return value;
                }
            });
        }

        return factory;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, MainFactory, $timeout, changelogFactory, $mdDialog, version)
    {
        var alreadyRead = localStorage.getItem("changelog");
        var userVersion = localStorage.getItem("exVersion");

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        $scope.$on('WIL', function(e, value){
            var notLoaded = MainFactory.WIL(value["dep"]);
            var from = value["from"];

            notLoaded.forEach(function(value, index){
                var name = value+"loaded";

                $timeout(function(){
                    $scope.$broadcast("get"+value);
                });
            });

            $timeout(function(){
                $scope.$broadcast(from+"DepLoad");
            });
        });

        if(userVersion < userVersion) {
            localStorage.removeItem("changelog");
        }
        if(alreadyRead && userVersion >= version) {

        } else {
            $timeout(function () {
                $mdDialog.show({
                    controller: function ($scope, $mdDialog, version) {
                        $scope.hide = function () {
                            $mdDialog.hide();
                        };

                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };

                        $scope.answer = function (answer) {
                            localStorage.setItem("changelog", true);
                            localStorage.setItem("exVersion", version);
                            $mdDialog.hide(answer);
                        };
                    },
                    templateUrl: 'app/main/changelog/changelog.popup.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    targetEvent: null
                });
            }, 2000)
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $rootScope, websitesFactory, $state, msNavigationService)
    {
        var vm = this;
        var navigation = msNavigationService.getNavigation();

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // When Toggle event is triggered by another controller or function
        $rootScope.$on("toggleNav", function()
        {
            vm.folded = !vm.folded;
        });


        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        function findNavigationById(id) {
            var result = navigation.filter(function (val, idx) {
                if(val._id === id) {
                    return val;
                }
            });

            return result;
        }

        function deleteItem(id) {
            msNavigationService.deleteItem(id);
        }

        function addItem(menuItem, className) {
            msNavigationService.saveItem(menuItem._path, {
                title: menuItem.title,
                icon: menuItem.icon,
                state: menuItem.state,
                class: className,
                weight: menuItem.weight
            });
        }

        function disableMenuItem(id, bool) {
            var menuItem = findNavigationById(id);

            if(menuItem.length > 0) {
                deleteItem(id);

                if(bool) {
                    addItem(menuItem[0], "disable-menu-item");
                } else {
                    addItem(menuItem[0], "500");
                }

                msNavigationService.sort();
            }

        }

        //Watch website
        $scope.$watch(function () {
            return websitesFactory.selected;
        }, function(website) {
            if(website && websitesFactory.getSelectedWebsite()) {
                var supportDisable = websitesFactory.isSupportDisable();
                var typeCode = website.type_code;

                if(typeCode === 'magento' || typeCode === 'magento2') {
                    disableMenuItem('Magento', false);
                } else {
                    disableMenuItem('Magento', true);
                }

                if (supportDisable) {
                    disableMenuItem('support', true);
                    if($state.current.name === 'app.websites.support.summary') {
                        $state.go('app.social');
                    }
                } else {
                    disableMenuItem('support', false);
                }

            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function(){
    'use strict';
    angular.module('app.auth', [])
})();
(function(){
    'use strict';

    angular.module('app.auth')
    .service('AuthService', AuthService);

    function AuthService($location, $q, $http, portal_path) {
        var api = {};
        var auth_user = localStorage.getItem("userToken");
        /*
        *   Check if the user have a token and is not empty
        *
        *   @return {Boolean}
        */

        api.isLoggedIn = function() {
            if(auth_user != null && auth_user != '') {
                return true;
            }
                return false;
        }

        api.renewToken = function () {
            var token = localStorage.getItem("userToken");

            $http.post(portal_path + "auth/jwt/refresh", {
                token: token
            })
                .then(function (res) {
                    if(res.data.data) {
                        localStorage.setItem("userToken", res.data.data);
                    }
                });
        }

        return api;
    }
})();

(function(){
    'use strict';

    angular
        .module('app.auth')
        .factory('AuthMiddleware', AuthMiddleware);

        /*
        *   Middleware logic for Authorization
        *
        *   @param {Object} authService
        *   @param {Object} $state
        *
        *   @return {Object}
        */

        function AuthMiddleware(AuthService, $state) {

            var AuthMiddleware = this;

            /*
            *   Inject function for auth Middleware will be called before every route
            *
            *   @param {Object} event
            *
            *   @return {void}
            */
            AuthMiddleware.run = function(event) {
                if(!AuthService.isLoggedIn()) {
                    event.preventDefault();
                    $state.go('app.login');
                }

                AuthMiddleware.isValidToken()
            }

            AuthMiddleware.isValidToken = function() {
                var token = localStorage.getItem("userToken")

                if(!token) {
                    $state.go('app.login');
                    return
                }

                var split = token.split(".");
                var json = JSON.parse(atob(split[1]));
                var created_at = moment.unix(json.exp);
                var arr = [created_at.add(1, "days").unix(), created_at.add(30, "days").unix()]
                var today = moment(new Date()).unix();
                var sum1 = arr[0] - today;
                var sum2 = arr[1] - today;

                if(sum2 <= 0) {
                    localStorage.removeItem("userToken");
                    location.href = "login"
                } else if(sum1 <= 150) {
                    AuthService.renewToken();
                }
            }

            return {
                run: AuthMiddleware.run,
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    /**
     * To kickstart the application
     *
     * @class runBlock
     * @constructor
     */
    function runBlock($rootScope, $timeout, $state, $injector, Analytics) {

        $rootScope.Object = Object;

        // Activate loading indicator & Auth Middleware
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            $rootScope.loadingProgress = true;

            callMiddlewares(event, toState, $injector);
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }

    /**
     * Calls middleware function
     *
     * @method callMiddleware
     * @param {object} event
     * @param {object} currentState
     * @param {object} inject
     *
     * @return {void}
     */
    function callMiddlewares(event, state, inject) {
        if (state && state.hasOwnProperty('middleware')) {
            if (typeof state.middleware === 'object') {
                angular.forEach(state.middleware, function (middleWare) {
                    callMiddleware(middleWare, event, inject);
                });
            }
        }
    }

    /**
     * Injects middleware
     * @method callMiddleware
     * @param {object} event
     * @param {object} inject
     * @return {void}
     */
    function callMiddleware(middleWare, event, inject) {
        try {
            inject.get(middleWare).run(event);
        } catch (e) {
            void 0;
        }
    }

    // Load JIRA.
    jQuery.ajax({
        url: "https://jira.experius.nl/s/477d748e0ce5db1a187d6107e4fb5f50-T/yvioqv/72004/903fc37efd70ba50a17546cb8c7ad2f5/2.0.21/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-UK&collectorId=edaeb289",
        type: "get",
        cache: true,
        dataType: "script"
    }).then(function () {
        window.ATL_JQ_PAGE_PROPS = {
            "triggerFunction": function (showCollectorDialog) {
                jQuery('body').on('click', '#provideFeedback', function(e) {
                  e.preventDefault();
                  showCollectorDialog();
                });

                jQuery('body').on('click', '#disclaimer-feedback', function(e) {
                  e.preventDefault();
                  showCollectorDialog();
                });
            }
        };
    });
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {

        //Turn on HTML5 History API;
        $locationProvider.html5Mode(true);

        var auth_user = localStorage.getItem("userToken");

        var layoutStyle = initRouteCheck(auth_user, $urlRouterProvider);

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layoutStyle,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: 'app/toolbar/toolbar.html',
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    }
                }
            });
    };

    /**
     * Checks if user already has a token
     *
     * @method initRouteCheck
     * @param {object} user
     * @param {object} $urlRouterProvider
     * @return (string)
     */
    function initRouteCheck(user, $urlRouterProvider) {
        var layoutStyle = 'app/user/login/login.html';
        var startPage = localStorage.getItem('startPage');

        if(location.pathname === "/") {
            $urlRouterProvider.otherwise('/login');
        }

        //If user isset;
        if (user) {
            layoutStyle = "app/main/main.html";
            $urlRouterProvider.otherwise('/website/0/dashboard');
        }
            layoutStyle = "app/main/main.html";
         return layoutStyle;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(wootricFactory, sentryFactory, $state, customPageService, msNavigationService)
    {
        var vm = this;
        var token = localStorage.getItem("userToken");

        customPageService.getMenuItems()
            .then(function(menuItems) {
                menuItems.forEach(function(val, idx) {
                    createMenuItem(val);
                });
            });

        function createMenuItem(obj) {
            var weight = 0;

            if(obj.priority) {
                weight = obj.priority;
            }

            msNavigationService.saveItem(obj.slug, {
                title: obj.title,
                icon: obj.navbar_menu_icon,
                state: 'app.custompage.custom',
                stateParams: {
                   slug: obj.slug
                },
                class: '500',
                weight: weight
            });
        }
    }
})();

(function () {
 "use strict"; 

 angular.module("fuse")
.constant("portal_path", "https://merlin.experius.nl/portal-api/")
.constant("sentry", true)
.constant("wootric", true)
.constant("ga", true)
.constant("dataTableLoc", "app/data/datatables/Dutch.json")
.constant("version", "1.1");
 
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    /**
     * config for the application
     * @module fuse
     * @main config
     */
    function config($httpProvider, $resourceProvider, ChartJsProvider, $mdDateLocaleProvider, $translateProvider, AnalyticsProvider, ga, portal_path) {
        var authIntercept = function authInterceptor() {
            return {
                request: function (config) {
                    var url = config.url.split(".");
                    var userSession = localStorage.getItem('userToken');

                    if (userSession != null && userSession != '') {
                        var setAuth = true;
                        //Ghost inspector temp fix
                        // url.forEach(function(value, index) {
                        //     if(value === "ghostinspector" || value === "view,version,container") {
                        //         setAuth = false
                        //     }
                        // });

                        if(setAuth) {
                            config.headers['Authorization'] = 'JWT ' + userSession;
                        }
                    }

                    return config;
                },

                requestError: function (config) {
                    return config;
                },

                response: function (res) {
                    if(res.config.url.includes(portal_path)) {
                        if(res.status === 401) {
                            localStorage.removeItem("userToken");
                            location.href = "login"
                        }
                    }
                    return res;
                },

                responseError: function (res) {
                    return res;
                }
            }
        }

        moment.locale('nl');
        $httpProvider.interceptors.push(authIntercept);

        $mdDateLocaleProvider.formatDate = function (date) {
            return !date ? '' : moment(date).format('DD-MM-YYYY');
        };

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('nl');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        if(!ga) {
            AnalyticsProvider.enterTestMode();
        }

        AnalyticsProvider.setAccount([
            {
                tracker: 'UA-91658630-1',
                name: "Live",
                fields: {
                    cookieDomain: "portal.experius.nl",
                    cookieName: 'expt',
                    cookieExpires: 20000
                },
                crossLinkDomains: ["experius.nl"],
                trackEvent: true
            },
            {
                tracker: 'UA-91658630-2',
                name: "Staging",
                fields: {
                    cookieDomain: "portal.tom.xpdev.nl",
                    cookieName: 'expt',
                    cookieExpires: 20000
                },
                crossLinkDomains: ["xpdev.nl"],
                trackEvent: true
            }
        ]);

        AnalyticsProvider.trackPages(true);
        AnalyticsProvider.trackUrlParams(true);
        AnalyticsProvider.setPageEvent('$stateChangeSuccess');

        numeral.register('locale', 'nl', {
            delimiters: {
                thousands: '.',
                decimal: ','
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal : function (number) {
                return number === 1 ? 'euro' : 'euros';
            },
            currency: {
                symbol: '€'
            }
        });

// switch between locales
        numeral.locale('nl');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $http, portal_path)
    {
        var api = {};

        // Entry point for all global API calls such as login etc

        // Base Url
        api.baseUrl = 'app/data/';

        // Login
        api.Login = function(email, password) {
            return $http.post(portal_path + "auth/jwt",{ email:email, password: password }, {});
        }

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.insights', [
            'app.insights.dashboard'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $provide)
    {
        var user = JSON.parse(localStorage.getItem("user"));

        var website_id = (user) ?  user.websites[0].id : 0;
        var dashboard_id = (user) ?  user.dashboards[0].id : 0;

        // Add navigation items
        // msNavigationServiceProvider.saveItem('insights', {
        //     title: 'insights',
        //     weight: 1,
        //     icon : 'icon-chart-areaspline',
        // });


        // msNavigationServiceProvider.saveItem('insights.dashboard', {
        //     title    : 'dashboards',
        //     icon     : 'icon-view-dashboard'
        // });

        // For every dashboard declared in the user object create the navigation item
        if(user)
        {
            user.dashboards.forEach(function(x,i)
            {
                msNavigationServiceProvider.saveItem( x.name.replace(/ /g, '').toLowerCase() , {
                    title    : x.name,
                    state    : 'app.insights_dashboard',
                    class    : "dashboard-item",
                    icon     : 'icon-chart-areaspline',
                    stateParams: {'id': dashboard_id, 'wid': website_id}
                    });
            });
        }


        // msNavigationServiceProvider.saveItem('insights.websites', {
        //     title    : 'websites',
        //     icon     : 'icon-desktop-mac',
        //     state    : 'app.insights_websites'
        // });

        // msNavigationServiceProvider.saveItem('insights.reports', {
        //     title    : 'reports',
        //     icon     : 'icon-file-document-box',
        //     state    : 'app.insights_reports'
        // });

        // msNavigationServiceProvider.saveItem('insights.settings', {
        //     title    : 'settings',
        //     icon     : 'icon-cog',
        //     state    : 'app.insights_settings'
        // });
    };

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/navigation/navigation.html","<md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center\" ng-if=\"!vm.folded\"><a href=\"#\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/icons/logo_experius_minimal.svg\"></md-icon><span class=\"logo-bold\">experius\n<span class=\"logo-portal\"> portal</span></span></a></div><div class=\"logo-folded\" layout-align=\"center\" layout=\"row\" \nng-if=\"vm.folded\"><img src=\"/assets/images/logo/exerpius_logo.png\"></div></md-toolbar><ms-navigation \nclass=\"scrollable extra-flavour\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/main.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content><button \nid=\"provideFeedback\" hide-xs hide-sm><span ng-if=\"!vm.folded\" translate=\"NAVIGATION.HELPUS\">Help ons verbeteren </span>\n<span ng-if=\"vm.folded\"><md-icon md-svg-src=\"assets/angular-material-assets/icons/ic_feedback_white_24px.svg\">\n</md-icon></span></button></div></div>");
$templateCache.put("app/toolbar/toolbar.html","<div class=\"cover\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><div \nclass=\"toolbar-separator\"></div><a class=\"website-title-toolbar\">{{ vm.user.company_name }}</a></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"toolbar-separator\"></div><website-block></website-block><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><div class=\"profile-circle\"><span class=\"circle\"><span class=\"initials\">{{vm.firstLetter}}\n</span></span></div><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>{{ vm.user.firstname + \" \" + vm.user.lastname}}\n</span><md-icon md-font-icon=\"keyboard_arrow_down\" class=\"icon s16\" hide-xs>keyboard_arrow_down</md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"settings\" class=\"icon\">\nsettings</md-icon><md-button ng-click=\"vm.settings()\" translate=\"TOOLBAR.ACCOUNTSETTING\">Accountinstellingen\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"exit_to_app\" class=\"icon\">exit_to_app\n</md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.LOGOUT\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/changelog/changelog.popup.html","<md-dialog aria-label=\"Mango (Fruit)\" class=\"centerChangelogPopup\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Experius portal ontwikkeling</h2><span flex></span></div></md-toolbar><md-dialog-content \nclass=\"changelog-dialog\"><div class=\"md-dialog-content\"><p>\nVandaag is er een nieuwe versie van het Experius Portal live gegaan. Via deze pop-up ontvang je een korte samenvatting van de meest belangrijke nieuwe features en verbeteringen.\n</p><p>Vergeet niet om zelf ook feedback te leveren via de Feedback knop rechts onderin je scherm!</p><h3 \nclass=\"changelog-h3\">Nieuwe features</h3><p>\nExtra bescherming tegen hackers - scherm zelf het Magento admin gedeelte van je webshop af op basis van 1 of meerdere IP-adressen. Kijk onder het tabje “Beveiliging”.\n</p><p>\nCache flush - Vanaf nu kun je de Magento cache van je live webshop zelf legen (of “flushen” zoals we dat noemen). Je vindt de knop onder “Magento” aan de linker kant.\n</p><p>\nAnalytics - Koppel je Google Analytics account en krijg inzicht in de grootste verbeterpunten voor je shop. Je koppelt eenvoudig je Google Analytics account links onder “Analytics”.\n</p><p>\nHandleidingen - Alle handleidingen die horen bij je shop worden nu links getoond onder “Handleidingen”, inclusief de Magento handleiding die hoort bij jouw shop.\n</p><h3 class=\"changelog-h3\">Verbeteringen</h3><ul><li>Besteedde uren per maand inzichtelijk, onder “Support Tickets”\n</li><li>Totaal aan uren voor alle openstaande tickets nu inzichtelijk, onder “Support Tickets”</li><li>\nSupport maandoverzicht op volgorde van maand gesorteerd</li></ul></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"answer(\'useful\')\">Gelezen</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cms/cms.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header cms-header\"><h1>{{vm.title}}</h1></div><div id=\"dashboard-container\" layout=\"row\" \nlayout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap><div layout-padding=\"15\" class=\"cms-content\" \nng-bind-html=\"vm.renderHtml(vm.content)\"></div></div></div></div></div>");
$templateCache.put("app/main/custompage/custompage.html","");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div ng-controller=\"noByteController as vm\"></div><div class=\"dashboard-header\"><h1 \ntranslate=\"DASHBOARD.GENERAL.TITLE\">Magento</h1></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-wrap><dashboard-general flex=\"50\" flex-md=\"100\" flex-sm=\"100\">\n</dashboard-general><dashboard-sales flex=\"50\" flex-md=\"100\" flex-sm=\"100\"></dashboard-sales></div></div><div \nclass=\"content\" layout=\"row\" flex=\"100\" layout-padding=\"15px\"><sum-bar flex=\"100\"></sum-bar></div><ex-loading \nng-show=\"!vm.cmsData.loaded\"></ex-loading><div class=\"content\" layout=\"row\" ng-show=\"vm.cmsData.loaded\"><div \nclass=\"dashboard-block\" flex=\"33\"><dashboard-cms data=\"vm.cmsData.list[0]\" \nuistate=\"app.websites.dashboard.increasevisitor.group.single\"></dashboard-cms></div><div class=\"dashboard-block\" \nflex=\"33\"><dashboard-cms data=\"vm.cmsData.list[1]\" uistate=\"app.websites.dashboard.ga.group.single\"></dashboard-cms>\n</div><div class=\"dashboard-block\" flex=\"33\"><dashboard-cms data=\"vm.cmsData.list[2]\" \nuistate=\"app.websites.dashboard.increaseorders.group.single\"></dashboard-cms></div></div></div></div>");
$templateCache.put("app/main/errormessage/errormessage.html","<div class=\"errormessage\"><span class=\"errorMessage-header\">{{header}}</span><br><span class=\"errorMessage-text\">\n{{text}}</span></div>");
$templateCache.put("app/main/exbtw/exbtw.html","<span class=\"exbtw\"><h4>Let op!</h4><h4>Bedragen zijn exclusief btw.</h4></span>");
$templateCache.put("app/main/ga/ga.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"dashboard-header ga-header\"><h1>{{\'GA.GENERAL.TITLE\' | translate}} <a href=\"#\" ng-click=\"vm.openModal()\">\nextra account toevoegen</a></h1></div><div class=\"content\"><div id=\"dashboard-container\"><section id=\"view-selector\" \nlayout-padding=\"15px\"></section><div><ms-masonry class=\"notes ga-holder\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ga404-page></ga404-page></ms-masonry-item><ms-masonry-item><ga-conversion-browser>\n</ga-conversion-browser></ms-masonry-item><ms-masonry-item><ga-leave-page></ga-leave-page></ms-masonry-item>\n<ms-masonry-item><ga-conversion-device></ga-conversion-device></ms-masonry-item><ms-masonry-item><ga-top-search-query>\n</ga-top-search-query></ms-masonry-item><ms-masonry-item><ga-bounce-page></ga-bounce-page></ms-masonry-item>\n<ms-masonry-item><ga-topsold-product></ga-topsold-product></ms-masonry-item></ms-masonry></div></div></div></div></div>");
$templateCache.put("app/main/invoice/invoice.html","<div id=\"kennisbank\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header\"><h1 translate=\"INVOICE.GENERAL.TITLE\">Magento</h1></div><div id=\"invoice-container\" \nlayout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ng-include src=\"vm.paths[0]\"></ng-include></ms-masonry-item><ms-masonry></ms-masonry></ms-masonry>\n</div></div></div></div>");
$templateCache.put("app/main/invoice/invoice.table.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><div class=\"h2\" translate=\"INVOICE.GENERAL.WIDGETTITLE\">Facturen</div></div><ex-loading \nng-show=\"!vm.invoiceModule.loaded\"></ex-loading><div ng-show=\"vm.invoiceModule.loaded && vm.invoiceModule.found\"><table\n class=\"dataTable hover\" datatable=\"ng\" dt-options=\"dtoptions\"><thead><tr><th translate=\"INVOICE.TABLE.PUBDATE\">\nPublicatiedatum</th><th translate=\"INVOICE.TABLE.TYPE\">Type (Factuur of Kreditfactuur)</th><th \ntranslate=\"INVOICE.TABLE.INVOICENUM\">Type (Factuur of Kreditfactuur)</th><th translate=\"INVOICE.TABLE.PRICE\">\nType (Factuur of Kreditfactuur)</th><th translate=\"INVOICE.TABLE.DLINK\">Type (Factuur of Kreditfactuur)</th></tr>\n</thead><tbody><tr ng-repeat=\"invoice in vm.invoiceModule.data\"><td>{{invoice.created}}</td><td>{{invoice.type}}</td>\n<td>{{invoice.invoice_id}}</td><td>{{invoice.amount_dc}}</td><td><a \nng-click=\"vm.getDownloadlink(invoice.download_url, invoice.created)\" href=\"#\">Download Factuur</a></td></tr></tbody>\n</table></div><div ng-show=\"vm.invoiceModule.loaded && !vm.invoiceModule.found\"><h3>\n{{\'INVOICE.GENERAL.NOTFOUND\' | translate}}</h3></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/kennisbank/kennisbank.html","<div id=\"kennisbank\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header\"><h1 translate=\"KENNISBANK.GENERAL.TITLE\">Magento</h1></div><div \nid=\"supportticket-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap>\n<ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ng-include src=\"vm.paths[0]\"></ng-include></ms-masonry-item><ms-masonry></ms-masonry></ms-masonry>\n</div></div></div></div>");
$templateCache.put("app/main/kennisbank/magentomanual.table.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><div class=\"h2\">\nMagento {{vm.magentoManual.edition}} {{\'KENNISBANK.GENERAL.EDITION\' | translate}} {{\'KENNISBANK.GENERAL.MANUAL\' | translate}}\n</div></div><ex-loading ng-show=\"!vm.magentoManual.loaded\"></ex-loading><div \nng-show=\"vm.magentoManual.loaded && vm.magentoManual.found\"><a ng-href=\"{{vm.getLink(vm.magentoManual.data)}}\" \ntarget=\"_blank\">{{\'KENNISBANK.MANUAL.CHECK\' | translate}}</a></div><div \nng-show=\"vm.magentoManual.loaded && !vm.magentoManual.found\"><h3>Er is helaas geen handleiding beschikbaar.</h3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nlayout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><div class=\"h2\" translate=\"KENNISBANK.MANUAL.TITLE\">\nMagento module handleiding</div></div><ex-loading ng-show=\"!vm.magentoModules.loaded\"></ex-loading><div \nng-show=\"vm.magentoModules.loaded && vm.magentoModules.found\"><table class=\"dataTable hover\"><thead><tr><th \ntranslate=\"KENNISBANK.MANUAL.NAME\">Module naam</th><th translate=\"KENNISBANK.MANUAL.ACTION\">Actie</th></tr></thead>\n<tbody><tr ng-repeat=\"manual in vm.magentoModules.modules\"><td>{{manual.name}}</td><td ng-show=\"manual.docIsset\"><a \nui-sref=\"app.kennisbank.magentomanual.single({pageid: manual.documentation_id})\">\n{{\'KENNISBANK.MANUAL.CHECK\' | translate}}</a></td><td ng-show=\"manual.readIsset\"><a \nui-sref=\"app.kennisbank.magentomanual.single({pageid: \'readme-\'+manual.namesplit})\">\n{{\'KENNISBANK.MANUAL.CHECK\' | translate}}</a></td></tr></tbody></table></div><div class=\"no-manual\" \nng-show=\"vm.magentoModules.loaded && !vm.magentoModules.found\">{{\'KENNISBANK.MANUAL.NOTFOUND\' | translate}}</div>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/magento/magento.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div ng-controller=\"noByteController as vm\"></div><div class=\"dashboard-header\"><h1 translate=\"MAGENTO.GENERAL.TITLE\">\nMagento</h1></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" \nng-controller=\"WidgetsController as vm\" layout-wrap><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item ng-repeat=\"item in vm.data\"><widget-builder settings=\"item\" stores=\"vm.stores\" tab=\"magento\">\n</widget-builder></ms-masonry-item></ms-masonry></div></div></div></div>");
$templateCache.put("app/main/nobyte/nobyte.html","<md-dialog aria-label=\"List dialog\"><md-dialog-content><h1>Sorry,</h1><p class=\"h3\">\nU kunt helaas geen gebruik maken van dit onderdeel.<br></p></md-dialog-content><md-dialog-actions><md-button \nng-click=\"closeDialog()\" class=\"md-primary\">Ik begrijp het</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pagespeed/pagespeed.html","<div flex=\"100\"><div id=\"dashboard\" class=\"main pagespeed\" layout=\"row\" flex=\"75\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\" layout=\"column\" flex><div class=\"dashboard-header\"><h1>{{\'PAGESPEED.GENERAL.TITLE\' | translate}}\n</h1></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-wrap><div class=\"pagespeed-info\" layout=\"row\" flex=\"100\"><div class=\"mob-desk\" flex=\"45\" ng-show=\"!vm.isSet\"><p>\n<errormessage header=\"Helaas\" text=\"Er is geen data beschikbaar\"></errormessage></p></div><div class=\"mob-desk\" \nflex=\"45\" ng-show=\"vm.isSet\"><table class=\"pagespeed-table\"><thead><th width=\"50%\"><span class=\"sprite_icon\" \nng-class=\"vm.getIcon(vm.score.mobile, \'mobile\')\"></span><h2 class=\"score-place-title\">Mobiel</h2></th><th><span \nclass=\"sprite_icon\" ng-class=\"vm.getIcon(vm.score.desktop, \'desktop\')\"></span><h2 class=\"score-place-title\">Desktop\n</h2></th></thead><tbody><tr><td><div><div class=\"score-place\"><h2 ng-class=\"vm.getScoreColor(vm.score.mobile)\">\n{{vm.getScoreName(vm.score.mobile) | translate}}</h2><span ng-class=\"vm.getScoreColor(vm.score.mobile)\">\n{{vm.score.mobile}}</span> <span>/ 100</span></div></div></td><td><div><div class=\"score-place\"><h2 \nng-class=\"vm.getScoreColor(vm.score.desktop)\">{{vm.getScoreName(vm.score.desktop) | translate}}</h2><span \nng-class=\"vm.getScoreColor(vm.score.desktop)\">{{vm.score.desktop}}</span> <span>/ 100</span></div></div></td></tr>\n</tbody></table><span>{{\'PAGESPEED.GENERAL.LATESTDATE\' | translate}} ({{vm.scoreDate}})</span><div class=\"more-info\">\n<button class=\"md-button md-primary pagespeed-more-info\" \nng-click=\"vm.openSupportTicket(\'Wat houdt Google PageSpeed optimalisatie precies in?\')\">\n{{\'PAGESPEED.BUTTON.MORE_INFO\' | translate}}</button></div></div><div class=\"pagespeed-about\" flex=\"65\"><p>\nMet PageSpeed Insights worden de prestaties van een pagina op mobiele apparaten en desktopapparaten gemeten. De PageSpeed-score heeft een waarde tussen 0 en 100 punten. Hoe hoger de score hoe beter en met een score van 85 of hoger wordt aangegeven dat de pagina goed presteert. Omdat PageSpeed Insights voortdurend wordt verbeterd, verandert de score wanneer we nieuwe regels toevoegen of onze analyse verbeteren (bron: \n<a href=\"https://developers.google.com/speed/docs/insights/about?hl=nl\" target=\"_blank\">Google</a>).</p><p>\nMet PageSpeed Insights wordt gemeten hoe de prestaties van de pagina kunnen worden verbeterd met betrekking tot:<ul>\n<li>\nTijd voor laden van inhoud boven de vouw: de verstreken tijd vanaf het moment dat een gebruiker een nieuwe pagina aanvraagt en het moment waarop de browser de inhoud boven de vouw heeft geladen.\n</li><li>\nTijd voor laden van volledige pagina: de verstreken tijd vanaf het moment dat een gebruiker een nieuwe pagina aanvraagt tot het moment waarop de browser de pagina volledig heeft geladen.\n</li></ul></p></div></div></div><div class=\"pagespeed-options\" layout=\"column\" flex><h2>\n{{\'PAGESPEED.OPTIONS.TITLE\' | translate}}</h2><table class=\"dataTable hover\"><thead><th>\n{{\'PAGESPEED.OPTIONS.NAME\' | translate}}</th><th>{{\'PAGESPEED.OPTIONS.IMPACT\' | translate}}</th><th>\n{{\'PAGESPEED.OPTIONS.HOUREST\' | translate}}</th><th></th></thead><tbody><tr ng-repeat=\"item in vm.options\" \nng-class=\"vm.getRowClass(item.implemented)\"><td>{{item.name}}<br>{{item.description}}</td><td>\n{{vm.getNumeral(item.impact)}}/4</td><td><span ng-hide=\"vm.isImplemented(item.implemented)\">\n{{vm.getNumeral(item.hours)}}</span> <span ng-show=\"vm.isImplemented(item.implemented)\">\n{{\'PAGESPEED.OPTIONS.ACTIVE\' | translate}}</span></td><td><div ng-hide=\"vm.isImplemented(item.implemented)\"><button \nclass=\"md-button md-primary pagespeed-more-info\" \nng-click=\"vm.openSupportTicket(\'Pagespeed functie aanvragen: \' + item.name)\">{{\'PAGESPEED.OPTIONS.BTN\' | translate}}\n</button></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/panel/contact.html","<div id=\"panel\" class=\"main contact-us-page\" layout=\"column\" layout-align=\"center center\"><md-content flex=\"100\" \nlayout-padding><div class=\"h1\">Experius Contact</div><div class=\"h3\">Voor vragen neem dan contact op met Experius.\n</div><p><table><tr><td>E-mail:</td><td><a href=\"mailto:support@experius.nl\">support@experius.nl</a></td></tr><tr><td>\nTelefoon:</td><td><a href=\"tel:+31308200238\">030-8200238</a></td></tr><tr><td>Website:</td><td><a \nhref=\"https://experius.nl\" target=\"_blank\">www.experius.nl</a></td></tr></table></p></md-content></div>");
$templateCache.put("app/main/panel/panel.html","<div id=\"panel\" class=\"main\" layout=\"column\" layout-align=\"center center\"><md-content flex=\"100\" layout-padding><div \nclass=\"h1\">Disclaimer</div><div class=\"h3\">Beta</div><p>\nHet Experius Customer Portal waar je op dit moment naar kijkt is een Bèta versie van ons nieuwe portaal.<br>\nWe zijn druk bezig met de laatste testen, voordat we een officiële release communiceren naar al onze klanten.</p><div \nclass=\"h3\">Aansprakelijkheid</div><p>\nOndanks alle zorg en aandacht die besteed wordt aan het Customer Portal, is het mogelijk dat inhoud onvolledig en/of onjuist is.\n<br>De informatie in het Customer Portal worden aangeboden zonder enige vorm van garantie of aanspraak op juistheid.\n</p><p>\nIn het bijzonder is alle e-commerce data (omzet, verkopen, prognoses) onder voorbehoud van type- en programmeerfouten.\n<br>Voor de gevolgen van dergelijke fouten wordt geen aansprakelijkheid aanvaard.</p><div class=\"h3\">Doorontwikkeling\n</div><p>Zie je fouten, laat het ons dan zo snel mogelijk weten.<br>\nWij zorgen dat deze zo snel mogelijk worden verbeterd.</p><p>\nMis je een widget, een tabblad of is er een functionaliteit die je graag zou terug zien in het Customer Portal?<br>\nStuur je verbeteridee dan in via de widget linksonder de Customer Portal of mail naar <a id=\"disclaimer-feedback\" \nhref=\"mailto:portal@experius.nl\">portal@experius.nl</a>.</p></md-content></div>");
$templateCache.put("app/main/releasenotes/releasenotes.html","<md-dialog aria-label=\"List dialog\"><md-dialog-content><h1>Release notes</h1><h2>Widgets</h2><ul><li>Magento</li><li>\nWebsite</li></ul></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog($event)\" class=\"md-primary\">\nI Got it!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales/sales.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div ng-controller=\"noByteController as vm\"></div><div class=\"dashboard-header\"><h1 translate=\"SALES.GENERAL.TITLE\">\nSales</h1></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" \nng-controller=\"WidgetsController as vm\" layout-wrap><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item ng-repeat=\"item in vm.data\"><widget-builder settings=\"item\" stores=\"vm.stores\" tab=\"sales\">\n</widget-builder></ms-masonry-item></ms-masonry></div></div></div></div>");
$templateCache.put("app/main/social/social.html","<div layout=\"row\" class=\"social\"><div class=\"center\" flex ms-scroll layout=\"column\"><div class=\"dashboard-header\"><h1 \ntranslate=\"SOCIAL.GENERAL.TITLE\">Experius Actueel</h1></div><div layout=\"row\" flex=\"100\" layout-xs=\"column\"><div \nflex=\"50\" flex-xs=\"100\"><ms-widget layout=\"row\" flex=\"100\" ng-hide=\"vm.facebookPosts.loaded\"><ms-widget-front \nclass=\"white-bg\" layout-padding=\"8px\">{{vm.facebookPosts}}<ex-loading></ex-loading></ms-widget-front></ms-widget>\n<ms-widget layout=\"row\" flex=\"100\" ng-repeat=\"item in vm.facebookPosts.data\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><div class=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"50\" \nclass=\"title\">Facebook</span> <span flex=\"50\" class=\"logo-right\"><md-icon md-svg-src=\"/assets/svg/facebook-icon.svg\">\n</md-icon></span></div><div>{{item.created_time}}</div><div class=\"text\"><div class=\"image-holder\"><img \nng-src=\"{{item.attachments.data[0].media.image.src}}\" width=\"45%\"></div><p \nng-bind-html=\"vm.renderHtml(item.message, \'fb\')\"></p></div></ms-widget-front></ms-widget></div><div flex=\"50\" \nflex-xs=\"100\"><ms-widget layout=\"row\" flex=\"100\" ng-hide=\"vm.blogPosts.loaded\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading></ex-loading></ms-widget-front></ms-widget><ms-widget layout=\"row\" flex=\"100\" \nng-repeat=\"item in vm.blogPosts.data\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"80\" class=\"title\" \nng-bind-html=\"vm.renderHtml(item.title.rendered)\"></span> <span flex=\"20\" class=\"logo-right\"><md-icon \nmd-svg-src=\"/assets/svg/experius-logo.svg\"></md-icon></span></div><div>{{item.date}}</div><div class=\"text\" \nng-bind-html=\"vm.renderHtml(item.excerpt.rendered)\"></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/testsuite/testsuite.html","<div flex=\"100\"><div id=\"dashboard\" class=\"main test-main\" layout=\"row\" flex=\"75\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\" layout=\"column\"><div ng-controller=\"noByteController as vm\"></div><div class=\"dashboard-header\">\n<h1 translate=\"TESTSUITE.GENERAL.TITLE\">Test Suite</h1><h4 \nng-class=\"{\'succesvol\':\'passed\', \'niet succesvol\':\'failing\', \'unknown\':\'unknown\'}[vm.latestResult.status]\" \nng-hide=\"vm.latestResult.status === \'bezig\' || vm.testEmpty\" ng-show=\"!vm.testNotRunned\">\nLaatst uitgevoerde tests {{vm.latestResult.status}} (tijd: {{vm.latestResult.time}} )</h4><p>\nDe test suite maakt het mogelijk om volledig geautomatiseerd de werking van de webshop te testen. Dit wordt gedaan door het uitvoeren van zogenaamde test scripts. Een overzicht van de actieve tests en de test historie wordt op deze pagina weergegeven. Naast het automatisch uit laten voeren van de testen is het ook mogelijk om de testen handmatig te starten door op de onderstaande link ‘start gehele suite’ te klikken.\n</p><p ng-show=\"vm.testDemo\">\nHet voordeel van geautomatiseerd testen is het zeker zijn van een correcte werking van de webshop en het tijdig ontdekken van eventuele fouten in de werking van de webshop. Het geautomatiseerd testen van de werking van de site is al mogelijk vanaf € 19,- per maand (\n<a href=\"#\" ng-click=\"vm.more_info()\">meer informatie over prijzen</a>\n). Hiermee worden de 4 meest kritieke processen van de webshop iedere dag getest.</p><p>\nDe top 5 meest gebruikte tests op dit moment zijn:<ol><li>\nToevoegen product aan winkelwagen (deze test is gratis toegevoegd aan uw account)</li><li>\nCheckout flow niet ingelogde gebruiker</li><li>Checkout flow ingelogde gebruiker</li><li>Werking zoekfunctie</li><li>\nVerzending contact formulier</li></ol></p></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-wrap><div layout-padding=\"15px\" flex=\"100\"><button \nclass=\"md-button md-primary btn-startSuite test-start\" ng-show=\"!vm.suiteRunning\" ng-hide=\"vm.testEmpty\" \nng-click=\"vm.startTestSuite()\"><i class=\"material-icons\">play_arrow</i> {{ \'TESTSUITE.GENERAL.RUN\' | translate }}\n</button> <button class=\"md-button md-primary btn-startSuite test-start\" ng-show=\"vm.suiteRunning\" disabled=\"disabled\">\n<i class=\"material-icons\">query_builder</i> {{ \'TESTSUITE.GENERAL.ISRUN\' | translate }}</button> <button \nng-show=\"vm.testDemo\" class=\"md-button md-primary test-more-info\" ng-click=\"vm.openSupportTicket(\'info\')\">\n{{\'TESTSUITE.GENERAL.MOREINFO\' | translate}}</button> <button ng-show=\"!vm.testDemo\" \nclass=\"md-button md-primary test-more-info\" ng-click=\"vm.openSupportTicket(\'test\')\">\n{{\'TESTSUITE.GENERAL.EXTRATEST\' | translate}}</button></div><div layout-padding=\"15px\" flex=\"100\" layout=\"column\">\n<ng-include src=\"vm.paths[0]\" flex=\"100\"></ng-include><ng-include src=\"vm.paths[2]\" flex=\"100\" \nng-hide=\"vm.suiteNotRunned\"></ng-include></div></div></div></div></div></div>");
$templateCache.put("app/main/testsuite/testsuite.table.history.html","<h2 ng-hide=\"vm.testEmpty\">{{\'TESTSUITE.HISTORY.TITLE\' | translate}}</h2><div ng-hide=\"vm.testEmpty\"><table \nclass=\"dataTable row-border testsuite-table\" datatable=\"ng\" dt-options=\"vm.dtoptions\"><thead><th \ntranslate=\"TESTSUITE.HISTORY.DATE\"></th><th translate=\"TESTSUITE.HISTORY.VIEW\"></th></thead><tbody><tr \nng-repeat=\"history in vm.testHistory \"><td><h3>{{history.time}}<h3></h3></h3></td><td><button \nclass=\"md-button md-primary test-more-info\" ng-click=\"vm.showHistory(history.id)\">\n{{\'TESTSUITE.HISTORY.VIEW\' | translate}}</button></td></tr></tbody></table></div>");
$templateCache.put("app/main/testsuite/testsuite.table.test.html","<h2 class=\"testTitle\" ng-hide=\"vm.testEmpty\">Actieve testen</h2><div ng-hide=\"vm.testEmpty\"><table \nclass=\"dataTable row-border testsuite-table\" datatable=\"ng\" dt-options=\"vm.dtoptions\"><thead><th \ntranslate=\"TESTSUITE.TABLE.TESTS.NAME\"></th><th translate=\"TESTSUITE.TABLE.TESTS.STATUS\"></th><th \ntranslate=\"TESTSUITE.TABLE.TESTS.TESTED\"></th></thead><tbody><tr ng-repeat=\"data in vm.dataList\"><td><div><div \nclass=\"md-title\">{{data.name}}</div></div><div class=\"actions\"><ul><li><button class=\"btn-action\" \nng-click=\"vm.startSingleTest(data.id)\" ng-disabled=\"vm.suiteNotRunned\"><i class=\"material-icons\">play_arrow</i>\n {{\'TESTSUITE.TABLE.TESTS.ACTIONS.RUN\' | translate}}</button></li><li ng-show=\"data.passing != \'unknown\'\"><button \nclass=\"btn-action\" ng-click=\"vm.showSteps(data.id)\" ng-disabled=\"vm.suiteNotRunned\"><i class=\"material-icons\">\nevent_note</i> {{\'TESTSUITE.TABLE.TESTS.ACTIONS.STEPS\' | translate}}</button></li><li \nng-show=\"data.passing != \'unknown\'\"><button class=\"btn-action\" ng-click=\"vm.showResults(data.id, data.passing)\" \nng-disabled=\"vm.suiteNotRunned\"><i class=\"material-icons\">view_list</i>\n {{\'TESTSUITE.TABLE.TESTS.ACTIONS.RESULT\' | translate}}</button></li></ul></div><div class=\"no-test-run\" \nng-show=\"vm.suiteNotRunned\"><span>{{\'TESTSUITE.GENERAL.NOTEST\' | translate}}</span></div></td><td><label \nng-class=\"{true:\'passed\', false:\'failing\', \'unknown\':\'unknown\'}[data.passing]\" ng-hide=\"vm.suiteNotRunned\">\n{{ vm.statusName(data.passing) }}</label></td><td><div class=\"testtime\" ng-hide=\"vm.suiteNotRunned\"><span>\n{{data.dateExecutionFinished}}</span></div></td></tr></tbody></table></div><div ng-hide=\"vm.testEmpty\"><button \nng-show=\"vm.testDemo\" class=\"md-button md-primary test-more-info\" ng-click=\"vm.openSupportTicket(\'test\')\">\n{{\'TESTSUITE.GENERAL.EXTRATEST\' | translate}}</button></div>");
$templateCache.put("app/main/websites/websites.html","<div class=\"website-block\" ng-controller=\"websitesController\"><md-menu-bar><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><md-icon class=\"favico\"><img ng-src=\"{{selectedWebsite.favico}}\" \nalt=\"\" onerror=\"this.onerror=null;this.src=\'/assets/images/logo/magento.png\'\"></md-icon><span>{{selectedWebsite.name}}\n</span><md-icon md-font-icon=\"keyboard_arrow_down\" class=\"icon keydown\" hide-xs>keyboard_arrow_down</md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-repeat=\"website in websites\" \nng-click=\"updateSelected(website.id)\"><md-icon><img ng-src=\"{{getFavIco(website.id)}}\" \nonerror=\"this.onerror=null;this.src=\'/assets/images/logo/magento.png\'\" alt=\"\"></md-icon><md-button>{{website.name}}\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/user/login/login-form.html","<div class=\"title\" translate=\"LOGIN.FORM.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"{{ \'LOGIN.ERR.EMAIL.REQUIRE\' | translate}}\">\nE-mail field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{ \'LOGIN.ERR.EMAIL.NOTVALID\' | translate}}\">E-mail must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"{{\'LOGIN.FORM.PASSWORD\' | translate}}\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"{{\'LOGIN.ERR.PASSWORD.REQUIRE\' | translate}}\">Password field is required</span></div><errormessage \nclass=\"errorHolder\" ng-show=\"vm.loginFail\" header=\"\" text=\"{{\'LOGIN.ERR.GENERAL.NOTMATCH\' | translate}}\"></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><a ui-sref=\"app.user_reset-password-step-1\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORM.FORGOTPW\">Forgot Password?</a></div><md-button \nng-click=\"vm.login()\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.FORM.LOGIN\">LOG IN</md-button></form>");
$templateCache.put("app/user/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"logo\" layout=\"row\" layout-align=\"center\"><img \nsrc=\"assets/images/logo/experius_portal.png\" alt=\"\"></div><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div \nui-view=\"content\"></div></div></div></div>");
$templateCache.put("app/user/reset-password-step-1/reset-password-step-1.html","<div layout=\"column\" id=\"forgot_pass\"><div class=\"login-back\"><a ui-sref=\"app.login\"><i \nclass=\"material-icons forgot_pass_back\">keyboard_backspace</i></a></div><div class=\"title\" ng-if=\"vm.isSend\" \ntranslate=\"STEP1.MSG2\">\nIf the email address entered was associated with the Experius portal we have sent you an email with instructions</div>\n<div class=\"title\" ng-if=\"!vm.isSend\" translate=\"STEP1.MSG1\">\nEnter an email to receive a verification code. This email may be used to send you a password reset code.</div><form \nname=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float ng-if=\"!vm.isSend\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"{{\'STEP1.EMAIL\' | translate}}\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"STEP1.REQUIRE.EMAIL.REQUIRE\">E-mail field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"STEP1.REQUIRE.EMAIL.NOTVALID\">\nE-mail must be a valid e-mail address</span></div></div></md-input-container><md-button ng-click=\"vm.sendCode()\" \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Next\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\">{{\'STEP1.BTN\' | translate}}</md-button>\n</form></div>");
$templateCache.put("app/user/reset-password-step-2/reset-password-step-2.html","<div layout=\"column\" id=\"forgot_pass\"><div class=\"title\" translate=\"STEP2.TITLE\">Enter a verification code</div><form \nname=\"forgotPasswordFormStep2\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"code\" \nname=\"code\" ng-model=\"vm.code\" placeholder=\"Code\" required><div ng-messages=\"forgotPasswordFormStep2.code.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"STEP2.REQUIRE.CODE.REQUIRE\">\nVerification code field is required</span></div></div></md-input-container><md-button ng-click=\"vm.verifyCode()\" \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Next\" \nng-disabled=\"forgotPasswordFormStep2.$invalid || forgotPasswordFormStep2.$pristine\">{{\'STEP2.BTN\' | translate}}\n</md-button></form></div>");
$templateCache.put("app/user/reset-password-step-3/reset-password-step-3.html","<div layout=\"column\" id=\"forgot_pass\" ng-init=\"vm.init()\"><div class=\"title\" ng-if=\"!vm.passIsChanged\" \ntranslate=\"STEP3.TITLE\">Enter new password</div><form name=\"resetPasswordFormStep3\" ng-if=\"!vm.passIsChanged\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"{{\'STEP3.PASS\' | translate}}\" ng-minlength=\"6\" ng-maxlength=\"18\" \nng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])/\" ng-change=\"vm.passwordCheck()\" required><div \nng-messages=\"resetPasswordFormStep3.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"STEP3.REQUIRE.PASSWORD.REQUIRE\">Password field is required</span></div><div ng-message=\"minlength\"><span \ntranslate=\"STEP3.REQUIRE.PASSWORD.TOSHORT\">Password is too short.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"STEP3.REQUIRE.PASSWORD.TOLONG\">Password is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"STEP3.REQUIRE.PASSWORD.PATTERN\">Password must including 1 uppercase letter and 1 lowercase letter</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password2\" ng-model=\"vm.form.password2\" placeholder=\"{{\'STEP3.PASS2\' | translate}}\" ng-minlength=\"6\" \nng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])/\" ng-change=\"vm.passwordCheck()\" required><div \nng-messages=\"resetPasswordFormStep3.password2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span\n translate=\"STEP3.REQUIRE.PASSWORD.REQUIRE\">Password field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"STEP3.REQUIRE.PASSWORD.NOMATCH\">Password do not match</span></div><errormessage class=\"errorHolder\" \nng-if=\"vm.showError\" header=\"Something went wrong,\" text=\"{{vm.errMessage}}\"></div></md-input-container><md-button \nng-click=\"vm.newPass()\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"New password\" \nng-disabled=\"resetPasswordFormStep3.$invalid || vm.formStep3Disabled\">{{\'STEP3.BTN\' | translate}}</md-button></form>\n<div ng-if=\"vm.passIsChanged\"><div class=\"title\" translate=\"STEP3.MSG\">Your password is successfully changed</div>\n<md-button ui-sref=\"app.login\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"New password\">\n{{\'STEP3.LOGIN\' | translate}}</md-button></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/cms/breadcrumbs/cms.breadcrumbs.html","<div class=\"cms-breadcrumb\"><ul><li ng-repeat=\"crumb in vm.crumbs\"><a href=\"#\" \nng-click=\"vm.gotoState(crumb.parent, crumb.slug, $index)\">{{crumb.title}}</a></li></ul></div>");
$templateCache.put("app/main/cms/single/cms.single.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header cms-header\"><h1>{{vm.title}}</h1></div><div class=\"breadcrumbs\" layout-padding=\"15\">\n<cms-breadcrumbs data=\"vm._data\"></cms-breadcrumbs></div><div id=\"dashboard-container\" layout=\"column\" \nlayout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap><div layout-padding=\"15\" class=\"cms-content\" \nng-bind-html=\"vm.renderHtml(vm.content)\"></div><cms-widget ng-show=\"vm.widget.isset\" load=\"vm.widget\"></cms-widget>\n</div></div></div></div>");
$templateCache.put("app/main/cms/group/cms.group.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header cms-header\"><h1>{{vm.title}}</h1></div><div class=\"breadcrumbs\" layout-padding=\"15\">\n<cms-breadcrumbs data=\"vm._data\"></cms-breadcrumbs></div><div id=\"dashboard-container\" layout=\"row\" layout-md=\"column\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-wrap><div layout-padding=\"15\" class=\"cms-content\" \nng-bind-html=\"vm.renderHtml(vm.content)\"></div></div></div></div></div>");
$templateCache.put("app/main/cms/widgets/cms.widgets.html","<div class=\"cms-widget\"><div ng-show=\"vm.cmsData.loaded\"></div><div class=\"adblock\" ng-show=\"vm.adBlockTable.loaded\" \nlayout-padding=\"15\"><h2>{{vm.load.name}}</h2><p>{{vm.load.description}}</p><table class=\"dataTable\"><thead><th>\nBestandsnaam</th><th>Locatie</th></thead><tbody><tr ng-repeat=\"item in vm.adBlockTable.data\"><td>{{item.path}}</td><td>\n{{item.filename}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/custompage/custom/custom.html","<div id=\"dashboard\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header\"><h1>{{vm.title}}</h1></div><div id=\"dashboard-container\" class=\"cms-content\" \nlayout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap ng-bind-html=\"vm.getHTML(vm.html)\" \nlayout-padding=\"15px\"></div></div></div></div>");
$templateCache.put("app/main/dashboard/cms/dashboard.cms.html","<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><h3 class=\"dashboard-h3 info-header\">{{vm.title}}\n</h3><table layout-padding=\"8px\"><tr ng-repeat=\"item in vm.table\" class=\"{{item.class}}\"><td \nng-if=\"item.type === \'header\'\">{{item.title}}:</td><td ng-if=\"item.type === \'header\'\"></td><td \nng-if=\"item.type === \'item\'\">{{item.title}}</td><td ng-if=\"item.type === \'item\' && item.status === \'Active\'\"><a \nhref=\"#\" ng-click=\"vm.gotoState(item.parent, item.slug)\">Lees meer</a></td><td \nng-if=\"item.type === \'item\' && item.status === \'Draft\'\">Binnenkort beschikbaar</td><td ng-if=\"item.type === \'clear\'\">\n</td><td ng-if=\"item.type === \'clear\'\"></td></tr></table></ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/general/dashboard.general.html","<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div><ex-loading \nng-show=\"loading\"></ex-loading><h3 class=\"dashboard-h3\">{{\'DASHBOARD.DIRECTIVE.GENERAL.SUMMARY\' | translate}}</h3><div \nid=\"general-ga-hidden\"></div><div class=\"summaryBlock\"><table><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.TODAY\'| translate}}:</td><td></td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.REVENUE\'| translate}}:</td><td>€{{vm.createNumeral(vm.today.today_revenue, \'0,0.00\')}}\n</td></tr><tr><td>{{\'DASHBOARD.DIRECTIVE.GENERAL.AMOUNT_ORDERS\'| translate}}:</td><td>{{vm.today.today_orders}}</td>\n</tr><tr><td>{{\'DASHBOARD.DIRECTIVE.GENERAL.ACTIVE_USERS\'| translate}}:</td><td><no-ga-access ng-hide=\"vm.active\">\n</no-ga-access><div id=\"generalusers\"></div><div ng-hide=\"vm.visitor.count === 0 && vm.visitor.loading\">\n{{vm.visitor.count}}</div></td></tr><tr class=\"clearBoth\"><td></td><td></td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.HISTORY\'| translate}}:</td><td></td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.REVENUE_PAST_DAYS\'| translate}}:</td><td>\n€{{vm.createNumeral(vm.history.revenue_30_days, \'0,0.00\')}}</td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.REVENUE_LAST_MONTH\'| translate}}:</td><td>\n€{{vm.createNumeral(vm.history.revenue_last_month, \'0,0.00\')}} (<span \nng-class=\"{\'positive\':\'passed-color\', \'negative\':\'failing-color\'}[vm.overallpercentageClass(vm.history.revenue_last_year_difference)]\">\n{{vm.overallpercentage(vm.history.revenue_last_year_difference)}}%</span>)</td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.ORDERS_PAST_DAYS\'| translate}}:</td><td>{{vm.history.orders_30_days}}</td></tr><tr><td>\n{{\'DASHBOARD.DIRECTIVE.GENERAL.ORDERS_LAST_MONTH\'| translate}}:</td><td>{{vm.history.orders_last_month}} (<span \nng-class=\"{\'positive\':\'passed-color\', \'negative\':\'failing-color\'}[vm.overallpercentageClass(vm.history.orders_last_year_difference)]\">\n{{vm.overallpercentage(vm.history.orders_last_year_difference)}}%</span>)</td></tr></table></div><a \nui-sref=\"app.websites.sales\" class=\"linkto-suite\">Meer omzet statistieken</a></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/sales/dashboard.sales.html","<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div><ex-loading \nng-show=\"loading\"></ex-loading><h3 class=\"dashboard-h3\">\n{{\'DASHBOARD.DIRECTIVE.SALES.STATUS\'| translate}} ({{\'DASHBOARD.DIRECTIVE.SALES.LATEST_TEST\'| translate}} {{vm.websiteInfo.last_loadtime_date}})\n</h3><div class=\"webshop-status\"><table><tr><td>{{\'DASHBOARD.DIRECTIVE.SALES.SITE_IS\'| translate}}:</td><td \nng-class=\"{true:\'passed-color\', false:\'failing-color\'}[vm.websiteInfo.online_status]\">\n{{vm.isOnline(vm.websiteInfo.online_status)}}</td></tr><tr><td>{{\'DASHBOARD.DIRECTIVE.SALES.LOAD_TIME\'| translate}}:\n</td><td>{{vm.websiteInfo.last_loadtime}} ms</td></tr></table></div><div class=\"test-list\"><h3 class=\"dashboard-h3\">\n{{\'DASHBOARD.DIRECTIVE.SALES.ACTIVE_TEST\'| translate}} ({{\'DASHBOARD.DIRECTIVE.SALES.LATEST_TEST\'| translate}} {{vm.suiteInfo.last_suite_run}})\n</h3><table><tr ng-repeat=\"test in vm.testInfo\"><td>{{test.data.testName}}:</td><td \nng-class=\"{true:\'passed-color\', false:\'failing-color\', \'unknown\':\'unknown\'}[test.passing]\">\n{{vm.isPassing(test.passing)}}</td></tr></table></div><a ui-sref=\"app.websites.testsuite\" class=\"linkto-suite\">\nBekijk volledige status</a></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/sumbar/dashboard.sumbar.html","<no-ga-access ng-hide=\"vm.active\"></no-ga-access><div class=\"bar\" ng-show=\"vm.active\"><div layout-padding=\"15px\"><span>\nResultaat afgelopen 30 dagen: </span><span>{{vm.revenue}} (omzet) = </span><span>{{vm.users}} (bezoekers)</span><span>\n X </span><span>{{vm.conversion}} (conversie)</span><span> X </span><span>€ {{vm.orderValue}} (orderwaarde)</span>\n</div></div><div class=\"sumBlock\"><div id=\"shopRevenue\"></div><div id=\"conversionRate\"></div><div id=\"orderValue\">\n</div><div id=\"sumUsers\"></div></div>");
$templateCache.put("app/main/ga/gaAccess/ga.gaAccess.html","<div class=\"noga\" ng-click=\"vm.openModal()\">We hebben helaas geen toegang tot uw Google Analytics account<br>\nKlik hier om toegang te verlenen aan uw Google Analytics account</div>");
$templateCache.put("app/main/ga/modals/notaccess.html","<md-dialog flex=\"100\" layout-padding=\"15px\" class=\"gaNoAccess\"><md-dialog-content><div layout=\"column\"><header \nclass=\"gaNoAccess-Header\"><h2>{{vm.title | translate}}</h2><span class=\"close\" ng-click=\"vm.closeDialoog()\"><i \nclass=\"material-icons\">close</i></span></header><div class=\"container\"><p>\nOm ons toegang te geven tot uw Google Analytics account moet u het volgende e-mail adres toevoegen: <span \nclass=\"accessmail\">{{vm.email}}</span><br>\nIn het filmpje hieronder wordt uitgelegd hoe u het e-mail adres kunt toevoegen.</p><video width=\"600\" height=\"450\" \nsrc=\"app/data/video/ga_instruction.mp4\" controls=\"true\"></video></div></div></md-dialog-content><md-dialog-actions>\n<button ng-click=\"vm.accountAdd()\">Ik heb het account toegevoegd</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/insights/dashboard/dashboard.html","<div id=\"dashboard\" class=\"main\" layout=\"row\" ng-controller=\"DashboardController as vm\"><div class=\"center\" flex \nms-scroll><div class=\"content\" layout=\"column\"><div ng-controller=\"noByteController as vm\"></div><div \nid=\"dashboard-header\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" class=\"header-white\"><website-block \nclass=\"dashboard-header\" title=\"Magento\" website=\"true\" support=\"true\"></website-block></div><div \nid=\"dashboard-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" \nng-controller=\"WidgetsController as vm\" layout-wrap><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n{{vm.data}}<ms-masonry-item ng-repeat=\"item in vm.data\"><widget-builder settings=\"item\" stores=\"vm.stores\">\n</widget-builder></ms-masonry-item></ms-masonry></div></div></div></div>");
$templateCache.put("app/main/kennisbank/magentomanual/index.html","<h1>Handleiding</h1><h3>Aan de linkerkant bevinden zich de handleidingen van modules die in uw webshop zitten.<br>\nAls de module er niet tussen staat is er helaas geen handleiding beschikbaar</h3>");
$templateCache.put("app/main/kennisbank/magentomanual/magentomanual.html","<div id=\"magentomanual\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" \nlayout=\"column\"><div class=\"dashboard-header\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><h1 \ntranslate=\"MAGENTOMANUAL.GENERAL.TITLE\">Magento Module - Handleiding</h1></div><div class=\"magentomanual-content\" \nlayout=\"row\"><div class=\"navigation\" flex=\"20\"><ex-loading ng-show=\"!loaded\"></ex-loading><ul ng-show=\"loaded\"><li \nng-show=\"magento.found\"><a href=\"{{magento.link}}\" target=\"_blank\">Magento handleiding</a></li><li \nng-repeat=\"manual in modules\"><a ng-show=\"manual.docIsset\" \nui-sref=\"app.kennisbank.magentomanual.single({pageid: manual.documentation_id})\">{{manual.name}}</a> <a \nng-show=\"manual.readIsset\" ui-sref=\"app.kennisbank.magentomanual.single({pageid: \'readme-\'+manual.namesplit})\">\n{{manual.name}}</a></li></ul></div><div class=\"pagecontent\" layout=\"column\"><no-manual \nng-show=\"vm.magentoModules.showReadErr\" title=\"{{\'NOMANUAL.GENERAL.WARNING\' | translate}}\" \nmessage=\"{{\'NOMANUAL.GENERAL.MESSAGE_1\' | translate}}\"></no-manual><no-manual ng-show=\"vm.magentoModules.showNoRead\" \ntitle=\"{{\'NOMANUAL.GENERAL.NOFOUND\' | translate}}\" message=\"{{\'NOMANUAL.GENERAL.MESSAGE_2\' | translate}}\"></no-manual>\n<div ui-view=\"manualcontent\"></div></div></div></div></div></div>");
$templateCache.put("app/main/kennisbank/magentomanual/single.html","<ex-loading ng-show=\"!vm.page.loaded\"></ex-loading><div class=\"title\" ng-show=\"vm.page.loaded\">{{vm.page.title}}</div>\n<md-content class=\"singlepagecontent\" ng-bind-html=\"vm.renderHtml(vm.page.content)\" \nng-show=\"vm.page.loaded && vm.page.found\" flex></md-content>");
$templateCache.put("app/main/kennisbank/nomanual/kennisbank.nomanual.html","<div class=\"no-manual alert alert-warning\"><div><strong>{{title}}</strong> {{message}}</div></div>");
$templateCache.put("app/main/settings/account/settings.account.html","<div id=\"settings\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header\"><h1 translate=\"SETTINGSACCOUNT.GENERAL.TITLE\">Accountinstellingen</h1></div><div \nid=\"settings-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap \nlayout-padding=\"15px\"><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ms-widget><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><start-page></start-page>\n</ms-widget-front></ms-widget></ms-masonry-item></ms-masonry></div></div></div></div>");
$templateCache.put("app/main/settings/overview/settings.overview.html","<div id=\"settings\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" layout=\"column\">\n<div class=\"dashboard-header\"><h1 translate=\"SETTINGSOVERVIEW.GENERAL.TITLE\">Instellingen</h1></div><div \nid=\"settings-container\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap><ms-masonry \nclass=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ng-include src=\"vm.paths[0]\"></ng-include></ms-masonry-item><ms-masonry-item></ms-masonry-item>\n</ms-masonry></div></div></div></div>");
$templateCache.put("app/main/settings/overview/table.account.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div class=\"h2\">Mijn gegevens</div><p \nclass=\"md-subhead\">Neem contact op met onze klantenservice indien de onderstaande gegevens niet kloppen!</p><table \nclass=\"dataTable\"><tbody></tbody></table></ms-widget-front></ms-widget>");
$templateCache.put("app/main/settings/overview/table.ipaddresses.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div class=\"h2\" \ntranslate=\"SETTINGSOVERVIEW.ACCESS.NAME\">Toegang tot ontwikkelstraat</div><p>\nStandaard wordt je staging omgeving afgeschermd van de buitenwereld om de veiligheid te garanderen. Via onderstaande tabel kun je jezelf toegang geven door je IP-adres toe te voegen.\n</p><p>\nOm ook de Magento admin van je live webshop af te schermen kun je het vinkje \"Admin afschermen\" aanvinken Je Magento admin wordt dan ook enkel toegankelijk voor de opgegeven IP-adressen\n</p><p>*Let op: dit werkt alleen als je webshop wordt gehost bij Byte op het Hypernode platform.</p><p \nclass=\"no-margin\"><table><tr><td><h3>Admin afschermen:</h3></td><td class=\"admin-protection\"><md-switch \nng-model=\"vm.adminProtection\" aria-label=\"Hypernode Admin protection\" ng-change=\"vm.setAdminProtection()\"></md-switch>\n</td></tr></table></p><table class=\"dataTable hover\"><thead><tr><td \ntranslate=\"SETTINGSOVERVIEW.ACCESS.LABELS.DESCRIPTION\">Label</td><td translate=\"SETTINGSOVERVIEW.ACCESS.LABELS.IP\">\nIP Adres</td><td translate=\"SETTINGSOVERVIEW.ACCESS.LABELS.ACTION\">Actie</td></tr></thead><tbody><tr \nng-repeat=\"item in ipAddresses\"><td>{{item.description}}</td><td>{{item.address}} / {{item.cidr}}</td><td><md-button \nclass=\"md-raised md-warn md-small\" ng-click=\"vm.deleteAddress(item.id)\"><md-tooltip md-direction=\"top\">\n{{\'SETTINGSOVERVIEW.ACCESS.LABELS.DELETEIP\' | translate}}</md-tooltip><md-icon class=\"delete-icon\" \nmd-font-set=\"material-icons\">clear</md-icon>{{\'SETTINGSOVERVIEW.ACCESS.LABELS.DELETE\' | translate}}</md-button></td>\n</tr></tbody></table><span layout=\"row\"><hr flex></span><form name=\"ipForm\"><div layout=\"row\" layout-wrap \nclass=\"ip-form\"><md-input-container class=\"md-block\" flex=\"50\" flex-gt-md=\"50\"><label \ntranslate=\"SETTINGSOVERVIEW.ACCESS.LABELS.DESCRIPTION\">IP Adres</label><input ng-model=\"vm.form.description\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\" flex-gt-md=\"50\"><label \ntranslate=\"SETTINGSOVERVIEW.ACCESS.LABELS.IP\">IP Adres</label><input ng-model=\"vm.form.ip\" name=\"ip\" \nng-pattern=\"/^(?=\\d+\\.\\d+\\.\\d+\\.\\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\\.?){4}$/\"><div \nng-messages=\"ipForm.ip.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"pattern\">\n{{\'SETTINGSOVERVIEW.ACCESS.MSG.ERR1\' | translate}}</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"50\" flex-gt-md=\"30\" layout=\"row\"><md-button class=\"md-raised md-primary block\" \nng-click=\"vm.submitAddress()\" flex=\"100\" type=\"submit\"><md-icon md-font-set=\"material-icons\" class=\"md-primary\">input\n</md-icon>{{\'SETTINGSOVERVIEW.ACCESS.LABELS.ADD\' | translate}}</md-button></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-md=\"40\" layout=\"row\"><md-button class=\"md-raised md-accent block\" \nng-click=\"vm.submitAddress(true)\" flex=\"100\" type=\"button\"><md-icon md-font-set=\"material-icons\" class=\"md-accent\">home\n</md-icon>{{\'SETTINGSOVERVIEW.ACCESS.LABELS.CURRENTIP\' | translate}}</md-button></md-input-container></div></form>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/directive/createticket.html","createticket works");
$templateCache.put("app/main/support/monthsummary/chart.spendhours.html","<ms-widget><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div class=\"h2\" \ntranslate=\"MONTHSUMMARY.SPENDHOURS.TITLE\">Maandoverzicht</div><ex-loading ng-hide=\"vm.spendhours.loaded\"></ex-loading>\n<div class=\"chart\" hide-xs ng-show=\"vm.showpie\"><canvas id=\"doughnut\" ng-show=\"vm.showpie\" \nclass=\"chart chart-doughnut\" chart-data=\"vm.spendhours.items\" chart-labels=\"vm.spendhours.labels\" \nchart-options=\"vm.chartOptions\" chart-colors=\"vm.chartColors\" hide-sm hide-xs></canvas></div><div><table \nclass=\"monthsummary-table\" ng-show=\"vm.spendhours.loaded && vm.spendhours.found\"><tr><td class=\"h2\" \ntranslate=\"MONTHSUMMARY.SPENDHOURS.LABELS.AMOUNT\">Aantal support tickets:</td><td class=\"h2\">{{vm.tickets.data.length}}\n</td></tr><tr><td class=\"h2\" translate=\"MONTHSUMMARY.SPENDHOURS.LABELS.TIME\">\nBestede tijd in uren die geaccordeerd zijn:</td><td class=\"h2\">{{vm.totalbilltime}}</td></tr></table></div>\n<errormessage ng-show=\"!vm.spendhours.found && vm.spendhours.loaded\" \nheader=\"{{\'MONTHSUMMARY.GENERAL.ERRTITLE\' | translate}}\" text=\"{{\'MONTHSUMMARY.GENERAL.TEXT\' | translate}}\">\n</errormessage></ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/monthsummary/dashboard.monthsummary.html","<ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><chart-spendhours></chart-spendhours><ng-include src=\"vm.paths[1]\"></ng-include></ms-masonry-item>\n<ms-masonry-item><ng-include src=\"vm.paths[0]\"></ng-include></ms-masonry-item></ms-masonry>");
$templateCache.put("app/main/support/monthsummary/support.monthsummary.html","<div id=\"supportmonthsummarry\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" \nlayout=\"column\"><div class=\"dashboard-header\"><h1 translate=\"MONTHSUMMARY.GENERAL.TITLE\">Maandoverzicht</h1></div><div \nlayout=\"row\" layout-sm=\"row\" layout-xs=\"row\" class=\"white-bg\" layout-padding=\"16px\" layout-align=\"center\" \nlayout-align-md=\"center\" layout-align-xs=\"none\"><div class=\"back\" ng-click=\"vm.backward()\" flex=\"5\" flex-xs=\"30\">\n<md-icon class=\"navigator\" ng-disabled=\"vm.disableBackward\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_navigate_before_white_24px.svg\"></md-icon></div><div \nclass=\"month h1\" flex=\"40\">{{vm.dateName}} {{vm.dateYear}}</div><div class=\"forward\" ng-click=\"vm.forward()\" flex=\"5\" \nflex-xs=\"30\"><md-icon class=\"navigator\" ng-disabled=\"vm.disableForward\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_navigate_next_white_24px.svg\"></md-icon></div></div><div \nclass=\"white-bg\" layout-padding=\"16px\"><a class=\"backlink\" ui-sref=\"app.websites.support.summary\"><md-icon \nclass=\"backToTickets\" md-svg-src=\"assets/angular-material-assets/icons/ic_arrow_back_black_24px.svg\"></md-icon>\n{{\'MONTHSUMMARY.GENERAL.BACK\' | translate}}</a></div><div id=\"supportmonthsummary-container\" layout=\"row\" \nlayout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap ui-view=\"dashboard\"></div></div></div></div>");
$templateCache.put("app/main/support/summary/chart.summary.html","<ms-widget layout=\"row\" hide-xs hide-sm><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><ex-loading \nng-hide=\"vm.supportticketsModel.loaded\"></ex-loading><div><canvas \nng-show=\"vm.supportticketsModel.loaded && vm.supportticketsModel.found\" id=\"bar\" class=\"chart chart-bar\" \nchart-data=\"values\" chart-labels=\"labels\" chart-series=\"series\" chart-colors=\"colors\" chart-options=\"chartOptions\" \nhide-sm hide-xs></canvas></div><errormessage ng-show=\"vm.supportticketsModel.loaded && !vm.supportticketsModel.found\" \nheader=\"Sorry\" text=\"Er is te weinig informatie beschikbaar om een overzicht te tonen\"></errormessage>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/summary/manager.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><div class=\"h2\" translate=\"SUPPORT.GENERAL.MANAGER\">Klantcoördinator</div></div><ex-loading \nng-hide=\"vm.manager.loaded\"></ex-loading><div class=\"support-manager\" ng-show=\"vm.manager.found && vm.manager.loaded\">\n<h1>{{vm.manager.name}}</h1><img src=\"{{vm.manager.img}}\"></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/summary/nosupport.html","<div class=\"nosupport-text\"><div class=\"white-bg\"><img src=\"assets/svg/support.svg\" class=\"support-logo\"></div>\n<md-content flex=\"100\" layout-padding><div class=\"h1\">Helaas, u heeft geen support contract</div><div class=\"h2\">\nWaarom een support contract</div><p>\nEen webshop is over het algemeen een dynamisch systeem waar u dagelijks mee werkt. Door het werken met het systeem kan het zijn dat u met vragen komt te zitten hoe iets ook al weer precies werkt of krijgt u ideeën hoe u de webshop verder wilt optimaliseren. Uiteraard staan wij altijd klaar als u ons belt om u met raad en daad te helpen, maar het supportcontract biedt een drietal belangrijke voordelen:\n</p><ul><li><div class=\"h3\">Voordeliger</div><p>\nOmdat supportcontracten worden afgesloten voor een periode van één jaar ligt het tarief aanzienlijk lager dan wanneer het normale tarief geldt.\n</p></li><li><div class=\"h3\">Sneller</div><p>\nDoordat wij de supportbehoefte vooraf weten, zorgen wij dat er uren gereserveerd zijn om met uw vragen aan de slag te gaan. Dit zorgt er voor dat wij snel en doeltreffend uw problemen of verbeteringen kunnen oppakken.\n</p></li><li><div class=\"h3\">Veiliger</div><p>\nEen onderdeel van het supportcontract is het zogenaamde releasemanagement. Dit betekent dat wanneer er een nieuwe (stabiele) versie is van Magento wij uw webshop kunnen overzetten naar deze nieuwe versie.\n</p></li></ul><p>\nIedere webshop en elke webshop beheerder is uniek en daarmee ook de supportbehoefte. Er is echter wel een grove inschatting te maken in de supportbehoefte die u waarschijnlijk zult wensen. In de onderstaande tabel is een overzicht gegeven op basis waarvan u een keuze kunt maken. Uiteraard kunnen wij u ook in deze keuze helpen.\n</p><div class=\"h3\"><a class=\"contact-us\" href=\"mailto:support@experius.nl\" \nng-click=\"close(); $event.preventDefault()\">Neem contact op met Experius</a></div></md-content></div>");
$templateCache.put("app/main/support/summary/support.summary.html","<div id=\"supportticket\" class=\"main\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\" \nlayout=\"column\"><div class=\"dashboard-header\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><h1 \ntranslate=\"SUPPORT.GENERAL.TITLE\">Support Tickets</h1><button class=\"createTicket\" ng-click=\"vm.createTicket()\"><div>\n{{ \'SUPPORT.GENERAL.CREATETICKET\' | translate }}</div></button></div><div id=\"supportticket-container\" layout=\"row\" \nlayout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" layout-wrap><ms-masonry class=\"notes\" \noptions=\'{\"columnCount\":2, \"responsive\": {\"xl\": 2, \"lg\": 2, \"md\": 2, \"sm\": 1, \"xs\": 1 }, \"respectItemOrder\": true }\'>\n<ms-masonry-item><ng-include src=\"vm.paths[0]\"></ng-include></ms-masonry-item><ms-masonry-item><chart-summary \ndata=\"overview\"></chart-summary></ms-masonry-item><ms-masonry-item><ng-include src=\"vm.paths[2]\"></ng-include>\n</ms-masonry-item><ms-masonry-item><ng-include src=\"vm.paths[3]\"></ng-include></ms-masonry-item></ms-masonry></div>\n</div></div></div>");
$templateCache.put("app/main/support/summary/table.opentickets.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\"><div class=\"h2\" ng-show=\"vm.supportOpenticketModel.loaded\" translate=\"SUPPORT.OPENTICKETS.NAME\">\nOpenstaande tickets</div><button ng-show=\"vm.supportOpenticketModel.loaded\" class=\"createTicket-small\" \nng-click=\"vm.createTicket()\"><div>{{ \'SUPPORT.GENERAL.CREATETICKET\' | translate }}</div></button></div><ex-loading \nng-hide=\"vm.supportOpenticketModel.loaded\"></ex-loading><div><h4 class=\"aproxtitle\">\n{{\'SUPPORT.OPENTICKETS.APROXHOUR\' | translate}}: {{vm.openhours.total}}</h4></div><div \nng-show=\"vm.supportOpenticketModel.found && vm.supportOpenticketModel.loaded\"><table class=\"dataTable hover\" \ndatatable=\"ng\" dt-options=\"dtoptions2\" dt-instance=\"dtInstanceCallback\"><thead><tr><td \ntranslate=\"SUPPORT.OPENTICKETS.LABELS.ID\">#ID</td><td translate=\"SUPPORT.OPENTICKETS.LABELS.TITLE\">Titel</td><td \ntranslate=\"SUPPORT.OPENTICKETS.LABELS.APROXTIME\">Tijdsinschatting</td><td \ntranslate=\"SUPPORT.OPENTICKETS.LABELS.ACTION\">Actie</td></tr></thead><tbody><tr \nng-repeat=\"ticket in vm.supportOpenticketModel.tickets\"><td>{{ticket.ticket_id}}</td><td>{{ticket.title}}</td><td>\n{{ticket.estimate_time}}</td><td><a ng-show=\"ticket.zendesk_id != \'\'\" \nhref=\"https://experius.zendesk.com/agent/tickets/{{ticket.zendesk_id}}\" target=\"_blank\" \ntranslate=\"SUPPORT.OPENTICKETS.LABELS.ZENDESK\"></a></td></tr></tbody></table></div><errormessage \nng-show=\"vm.supportOpenticketModel.loaded && !vm.supportOpenticketModel.found\" \nheader=\"{{\'SUPPORT.GENERAL.ERRTITLE\' | translate}}\" text=\"{{\'SUPPORT.GENERAL.TEXT\' | translate}}\"></errormessage>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/summary/table.summary.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><ex-loading \nng-hide=\"vm.supportoverviewModel.loaded\"></ex-loading><table class=\"dataTable hover\" \nng-show=\"vm.supportoverviewModel.loaded && vm.supportoverviewModel.found\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\"><thead><tr><th translate=\"SUPPORT.SUMMARY.LABELS.MONTH\">Maand</th><th \ntranslate=\"SUPPORT.SUMMARY.LABELS.HOURS\">Support uren</th><th translate=\"SUPPORT.SUMMARY.LABELS.TIME\">\nBestede tijd in uren</th><th translate=\"SUPPORT.SUMMARY.LABELS.ACTION\">Actie</th><th \ntranslate=\"SUPPORT.SUMMARY.LABELS.PDF\">Download PDF</th></tr></thead><tbody><tr ng-repeat=\"ticket in overview\"><td>\n{{ticket.dateName}}</td><td>{{ticket.totalHours}}</td><td>{{ticket.spendHours}}</td><td><a \nui-sref=\"app.websites.support.monthsummary.dashboard({month: ticket.month, year: ticket.year})\" \ntranslate=\"SUPPORT.SUMMARY.LABELS.SHOW\">Toon maandoverzicht</a></td><td><div ng-show=\"ticket.summary_pdf\" \nng-click=\"vm.getLinks(ticket)\"><i class=\"material-icons support-ticket-ico\">picture_as_pdf</i></div></td></tr></tbody>\n</table><div><errormessage ng-show=\"vm.supportoverviewModel.loaded && !vm.supportoverviewModel.found\" \nheader=\"{{\'SUPPORT.GENERAL.ERRTITLE\' | translate}}\" text=\"{{\'SUPPORT.GENERAL.text\' | translate}}\"></errormessage></div>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/summary/text.hours.html","<ms-widget layout=\"row\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><ex-loading \nng-hide=\"vm.openhours.loaded\"></ex-loading><md-content class=\"h2 text-center\" \nng-show=\"vm.openhours.loaded && vm.openhours.found\">{{\'SUPPORT.APROXHOUR.TEXT\' | translate}} <span class=\"h1\">\n{{vm.openhours.total}}</span></md-content><errormessage ng-show=\"vm.openhours.loaded && !vm.openhours.found\" \nheader=\"{{\'SUPPORT.GENERAL.ERRTITLE\' | translate}}\" text=\"{{\'SUPPORT.GENERAL.TEXT2\' | translate}}\"></errormessage>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.done.html","<md-dialog flex=\"100\" layout-padding=\"15px\" class=\"TestRunModal\"><md-dialog-content><h1>\n{{\'TESTSUITE.MODALS.DONE.TESTDONE\' | translate}}</h1><div class=\"status\"><label class=\"testlabel\">Status:</label><label\n class=\"teststatus\" ng-class=\"{true:\'passed\', false:\'failing\', \'unknown\':\'unknown\'}[vm.data.passing]\">\n{{ vm.statusName(vm.data.passing) }}</label><a ng-hide=\"vm.hideSupportButton\" ng-click=\"vm.openTicketDialog()\" \nhref=\"#\" class=\"testsupport support testsupport\" ng-hide=\"{true:true, false:false}[vm.data.passing]\">\n{{ \'TESTSUITE.GENERAL.SUPPORT\' | translate }}</a></div><div class=\"result-list\"><table><tbody><tr><td><label \nclass=\"testlabel\">{{\'TESTSUITE.MODALS.DONE.GOOD\' | translate}}:</label></td><td>\n{{vm.data.countPassing}}/{{vm.amountTests}}</td></tr><tr><td><label class=\"testlabel\">\n{{\'TESTSUITE.MODALS.DONE.FAIL\' | translate}}:</label></td><td>{{vm.data.countFailing}}/{{vm.amountTests}}</td></tr><tr>\n<td><label class=\"testlabel\">{{\'TESTSUITE.MODALS.DONE.UNKNOWN\' | translate}}:</label></td><td>\n{{vm.data.countUnknown}}/{{vm.amountTests}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions><a \nng-click=\"vm.closeDialoog()\" class=\"md-button\">Test Afronden</a></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.moreinfo.html","<md-dialog flex=\"100\" layout-padding=\"15px\" class=\"TestRunModal more-info-modal\"><md-dialog-content><div \nlayout-padding=\"15px\" layout=\"column\"><header><h2>{{\'TESTSUITE.GENERAL.MOREINFOTITLE\' | translate}}</h2><span \nclass=\"close\" ng-click=\"vm.closeDialoog()\"><i class=\"material-icons\">close</i></span></header><div class=\"container\">\n<p>Uitgangspunt voor het testen is de Critical test pack bestaande uit 4 testen:<ol><li>\nToevoegen product aan winkelwagen (deze krijgt iedereen gratis in zijn portaal 1 keer per dag)</li><li>\nCheckout proces niet ingelogde bezoeker</li><li>Checkout proces ingelogde bezoeker</li><li>Search functie</li></ol>\n<table class=\"dataTable no-bottom\"><thead><th width=\"20%\">Aantal storeviews</th><th>Frequentie tests</th></thead>\n</table><table class=\"dataTable\"><thead><th width=\"20%\"></th><th>1 keer per dag</th><th>3 keer per dag</th><th>\nIeder uur</th></thead><tbody><tr><td>1</td><td>€ 19</td><td>€ 49</td><td>€ 69</td></tr><tr><td>2</td><td>€ 35</td><td>\n€ 79</td><td>€ 119</td></tr><tr><td>3 of meer</td><td>€ 15 per extra storeview</td><td>€ 20 per extra storeview</td>\n<td>€ 30 per extra storeview</td></tr><tr><td></td><td></td><td></td><td></td></tr><tr><td>Extra test</td><td>€ 15</td>\n<td>€ 20</td><td>€ 25</td></tr></tbody></table></p><div class=\"extra\">\nInstelkosten critical test pack is 1 uur (kan worden voldaan met supporturen)<br>\nInstelkosten extra test maatwerk is 1 uur (kan worden voldaan met supporturen)</div><p></p></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.nosuite.html","<md-dialog flex=\"100\" layout-padding=\"15px\"><h2>Helaas er is nog geen test suite</h2><h3>\nJe hebt geen toegang tot dit onderdeel.</h3><div><a class=\"md-primary md-button\" href=\"mailto:support@experius.nl\">\nDirect aanvragen</a> <a ui-sref=\"app.social\" class=\"md-button\">Oke, ik begrijp het</a></div></md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.showResults.html","<md-dialog class=\"TestRunModal\"><md-dialog-content><div layout-padding=\"15px\" layout=\"column\"><header><h2 \ntranslate=\"TESTSUITE.MODALS.RESULTS.TITLE\">Test stappen</h2><span class=\"close\" ng-click=\"vm.closeDialoog()\"><i \nclass=\"material-icons\">close</i></span></header><div><ex-loading ng-show=\"vm.isLoading\"></ex-loading><h3 \nstyle=\"text-align: center\" ng-show=\"vm.isLoading\">Dit kan even duren</h3></div><div ng-show=\"!vm.isLoading\" \nlayout=\"column\"><div flex=\"100\" layout=\"column\"><h3 flex=\"100\">{{vm.data.name}}</h3><div class=\"status\"><label \nclass=\"testlabel\">Status:</label><label class=\"teststatus\" \nng-class=\"{true:\'passed\', false:\'failing\', \'unknown\':\'unknown\'}[vm.data.passing]\">{{ vm.statusName(vm.data.passing) }}\n</label><a ng-click=\"vm.openTicketDialog()\" href=\"#\" class=\"testsupport support testsupport\" \nng-hide=\"{true:true, false:false}[vm.data.passing]\">{{ \'TESTSUITE.GENERAL.SUPPORT\' | translate }}</a></div></div><div \nclass=\"media\" layout=\"row\"><md-content flex=\"100\"><md-tabs flex=\"100\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Video\"><div flex=\"100\" layout=\"column\"><div class=\"video\" flex=\"100\"><div ng-show=\"vm.novideo\"><h2>\n{{ \'TESTSUITE.GENERAL.NOVIDEO\' | translate }}</h2></div><div ng-show=\"!vm.novideo\"><video width=\"100%\" height=\"350\" \nng-src=\"{{vm.videoSrc(vm.data.video.url)}}\" controls></video></div></div></div></md-tab><md-tab label=\"Screenshot\">\n<md-content class=\"md-padding\"><div flex=\"100\" layout=\"column\"><div class=\"video\" flex=\"100\"><div \nng-show=\"vm.noscreen\"><h2>{{ \'TESTSUITE.GENERAL.NOSCREEN\' | translate }}</h2></div><div><a \nng-href=\"{{ vm.data.screenshot.original.defaultUrl }}\" target=\"_blank\"><img width=\"150\" height=\"150\" \nng-src=\"{{vm.videoSrc(vm.data.screenshot.small.defaultUrl)}}\"></a></div></div></div></md-content></md-tab></md-tabs>\n</md-content></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.showsteps.html","<md-dialog class=\"TestRunModal\" flex=\"100\"><div layout-padding=\"15px\" layout=\"column\"><header><h2 \ntranslate=\"TESTSUITE.MODALS.STEPS.TITLE\">Test resultaat</h2><span class=\"close\" ng-click=\"vm.closeDialoog()\"><i \nclass=\"material-icons\">close</i></span></header><div><ex-loading ng-show=\"vm.isLoading\"></ex-loading></div><div \nng-show=\"!vm.isLoading\" layout=\"column\"><div flex=\"100\" layout-padding=\"15px\"><h2>{{vm.data.name}}</h2></div></div><div\n class=\"steps\" layout=\"column\" flex=\"100\"><div class=\"single-step\" ng-repeat=\"item in vm.data.steps\" layout=\"row\" \nclass=\"repeated-item\" ng-class=\"{true:\'step-passed\', false:\'step-failing\', \'null\':\'step-failing\'}[item.passing]\"><div \nclass=\"num\" ng-class=\"{true:\'c-passed\', false:\'c-failing\', \'null\':\'c-failing\'}[item.passing]\" flex=\"5\"><span>\n#{{$index + 1}}</span></div><div class=\"actions\"><div><span>Commando: {{item.command}} </span><span class=\"target\">\nTarget: {{item.target}}</span></div><span class=\"url\" flex=\"100\">URL: {{item.url}}</span></div></div></div></div>\n</md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.singletest.html","<md-dialog class=\"TestRunModal\"><div layout-padding=\"15px\" layout=\"column\"><header><h2 \ntranslate=\"TESTSUITE.MODALS.STEPS.TITLE\">Test stappen</h2><span class=\"close\" ng-click=\"vm.closeDialoog()\">><i \nclass=\"material-icons\">close</i></span></header><div><ex-loading ng-show=\"vm.isLoading\"></ex-loading></div><div \nng-show=\"!vm.isLoading\" layout=\"column\"><div flex=\"100\"><h2>{{vm.data.name}} {{vm.data.passing}}</h2></div><div \nlayout=\"row\"><div flex=\"50\"><video width=\"400\" height=\"400\" controls ng-src=\"{{vm.videoSrc(vm.data.video.url)}}\">\n</video></div><div flex=\"50\"><h3 translate=\"TESTSUITE.MODALS.STEPS.TITLE\"></h3><ul><li \nng-repeat=\"item in vm.data.steps\"><div><span>{{$index + 1}}</span></div><div><span>{{item.command}}</span> <span>\n{{item.target}}</span> <span>{{item.url}}</span></div></li></ul></div></div><div ng-show=\"!vm.data.passing\"><a \nhref=\"mailto:support@experius.nl\">Maak een Support ticket aan</a></div></div></div></md-dialog>");
$templateCache.put("app/main/testsuite/modals/testsuite.modal.suitedone.html","<md-dialog flex=\"100\" layout-padding=\"15px\" class=\"TestRunModal\"><md-dialog-content><h1>\n{{\'TESTSUITE.MODALS.DONE.TESTDONE\' | translate}}</h1><div class=\"status\"><label class=\"testlabel\">Status:</label><label\n class=\"teststatus\" ng-class=\"{true:\'passed\', false:\'failing\', \'unknown\':\'unknown\'}[vm.data.passing]\">\n{{ vm.statusName(vm.data.passing) }}</label><a ng-hide=\"vm.hideSupportButton\" ng-click=\"vm.openTicketDialog()\" \nhref=\"#\" class=\"testsupport support testsupport\" ng-hide=\"{true:true, false:false}[vm.data.passing]\">\n{{ \'TESTSUITE.GENERAL.SUPPORT\' | translate }}</a></div><div class=\"result-list\"><table><tbody><tr><td><label \nclass=\"testlabel\">{{\'TESTSUITE.MODALS.DONE.GOOD\' | translate}}:</label></td><td>\n{{vm.data.result_raw.countPassing}}/{{vm.amountTests}}</td></tr><tr><td><label class=\"testlabel\">\n{{\'TESTSUITE.MODALS.DONE.FAIL\' | translate}}:</label></td><td>{{vm.data.result_raw.countFailing}}/{{vm.amountTests}}\n</td></tr><tr><td><label class=\"testlabel\">{{\'TESTSUITE.MODALS.DONE.UNKNOWN\' | translate}}:</label></td><td>\n{{vm.data.result_raw.countUnknown}}/{{vm.amountTests}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions><a ng-click=\"vm.closeDialoog()\" class=\"md-button\">Test Afronden</a></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title && !node.type\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title && node.type\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\">{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <span class=\"testfailed-count\" ng-if=\"testsuite.failed\">\n                <span class=\"failed-count\">{{testsuite.count}}</span>\n            </span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/ga/widgets/404_page/ga.404_page.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'GA.NOTFOUND.TITLE\' | translate}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"PageNotFound\"></div><ex-loading ng-show=\"loading\"></ex-loading><div layout=\"row\" class=\"PageNotFound-Container\" \nng-hide=\"loading\"><div><h1>{{count}}</h1></div><p>404-pagina’s<br>gevonden in de<br>afgelopen 30 dagen</p></div><p>\nDe bezoeker vond niet de pagina die hij verwachtte. Dé pagina bij uitstek om de<br>\nbezoeker weer op het juiste pad te zetten én een verlies in SEO positie tegen te gaan.<br>\nWeten welke pagina’s de bezoeker zocht? Hiervoor is de Experius 404 module ontwikkeld.<br>\nDeze module zorgt ervoor dat elke pagina afzonderlijk wordt opgeslagen en later voorzien<br>\nkan worden van een redirect, zodat de bezoeker altijd op het juiste pad blijft en de conversie<br>verhoogt.</p><div \nclass=\"buy-module\" ng-hide=\"moduleisActive\"><button class=\"md-button md-primary test-more-info\" \nng-click=\"openSupportTicket()\">{{\'GA.CONVERSIONBROWSER.BTN2\' | translate}}</button><p>\nMaandelijkse kosten voor deze module: €9,-</p></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/bounce_page/ga.bounce_page.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"GA.BOUNCEPAGE.TITLE\">\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div><div id=\"bouncePageHide\"></div><p>\nHet bouncepercentage geeft het percentage bezoekers aan dat alleen de bewuste pagina heeft bezocht en vervolgens direct de webshop heeft verlaten. Deze pagina’s verdienen aandacht aangezien ze een grote impact op de conversie hebben. Onderstaande tabel laat de 10 best bezochte pagina’s met een bouncepercentage hoger dan 60% zien.\n</p><div><ex-loading ng-show=\"loading\"></ex-loading><table class=\"dataTable\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\" ng-hide=\"loading\"><thead><th>{{\'GA.BOUNCEPAGE.TABLE.PAGE\' | translate}}</th><th>\n{{\'GA.BOUNCEPAGE.TABLE.PAGEVIEW\' | translate}}</th><th>{{\'GA.BOUNCEPAGE.TABLE.PERCENTAGE\' | translate}}</th></thead>\n<tbody><tr ng-repeat=\"item in data5\"><td>{{item.label}}</td><td>{{item.pageCount}}</td><td>{{item.bounce}}%</td></tr>\n</tbody></table></div><button class=\"md-button md-primary test-more-info\" ng-click=\"openSupportTicket()\">\n{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/conversion_browser/ga.conversion_browser.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'GA.CONVERSIONBROWSER.TITLE\' | translate}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"conversionBrowserHide\"></div><p>Bezoekers van de webshop gebruiken verschillende browsers. Wanneer het conversie\n<br>percentage per browser sterk verschilt, zijn er vaak maatregelen te nemen om de lagere<br>\nconversiepercentages omhoog te brengen en het rendement te verhogen.</p><div><ex-loading ng-show=\"loading\">\n</ex-loading><table class=\"dataTable\" datatable=\"ng\" dt-options=\"dtoptions\" dt-instance=\"dtInstanceCallback\" \nng-hide=\"loading\"><thead><th>{{\'GA.CONVERSIONBROWSER.TABLE.BROWSER\' | translate}}</th><th>\n{{\'GA.CONVERSIONBROWSER.TABLE.CONVBROW\' | translate}}</th><th>{{\'GA.CONVERSIONBROWSER.TABLE.TRANS\' | translate}}</th>\n</thead><tbody><tr ng-repeat=\"item in data\"><td>{{item.browser}}</td><td>{{item.conversionBrowser.rawvalue}}%</td><td>\n{{item.transactions.rawvalue}}</td></tr></tbody></table></div><button class=\"md-button md-primary test-more-info\" \nng-click=\"openSupportTicket()\">{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/conversion_device/ga.conversion_device.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'GA.CONVERSIONDEVICE.TITLE\' | translate}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"LeavepageHide\"></div><p>\nElke device heeft zijn eigen specifieke kenmerken voor interactie. Met name het mobiele verkeer groeit sterk en vergt dus aandacht. Blijft de conversie op dit device sterk achter dan zijn hier vaak mogelijkheden voor meer rendement.\n</p><ex-loading ng-show=\"loading\"></ex-loading><table class=\"dataTable\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\" ng-hide=\"loading\"><thead><th>{{\'GA.CONVERSIONDEVICE.TABLE.APP\' | translate}}</th><th>\n{{\'GA.CONVERSIONDEVICE.TABLE.CONVDEV\' | translate}}</th><th>{{\'GA.CONVERSIONDEVICE.TABLE.TRANS\' | translate}}</th>\n</thead><tbody><tr ng-repeat=\"item in data3\"><td>{{item.device}}</td><td>{{item.conversionBrowser.rawvalue}}%</td><td>\n{{item.transactions.rawvalue}}</td></tr></tbody></table><button class=\"md-button md-primary test-more-info\" \nng-click=\"openSupportTicket()\">{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/leave_page/ga.leave_page.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'GA.LEAVEPAGE.TITLE\' | translate}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"LeavepageHide\"></div><p>\nDe enige pagina die een hoog aantal uitstappunten (mensen die de webshop verlaten) mag hebben is de checkout pagina. Overige pagina\'s verdienen aandacht en eventueel optimalisatie, waarbij de winkelwagen het allerbelangrijkste is. De bezoeker is dan immers nog slechts één stap verwijderd om te converteren\n</p><ex-loading ng-show=\"loading\"></ex-loading><div ng-hide=\"loading\"><table class=\"dataTable\" datatable=\"ng\" \ndt-options=\"dtoptions\" dt-instance=\"dtInstanceCallback\"><thead><th>{{\'GA.LEAVEPAGE.TABLE.PAGE\' | translate}}</th><th>\n{{\'GA.LEAVEPAGE.TABLE.EXITPOINT\' | translate}}</th></thead><tbody><tr ng-repeat=\"item in data2\"><td>{{item.label}}</td>\n<td>{{item.counts}}</td></tr></tbody></table></div><button class=\"md-button md-primary test-more-info\" \nng-click=\"openSupportTicket()\">{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/topsearchquery/ga.topsearchquery.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'GA.TOPSEARCHQUERY.TITLE\' | translate}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"TopSearchQueryHide\"></div><p>\nDé inspiratiebron voor conversie optimalisatie. Vindt de bezoeker snel hetgeen hij wil vinden? Test zelf de resultaten op de zoekresultaten in de webshop. Vormen ze aanleiding voor het verbeteren van de navigatiestructuur of wellicht voor het verbeteren van de zoekfunctie? Onderstaand de top10.\n</p><ex-loading ng-show=\"loading\"></ex-loading><table class=\"dataTable\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\" ng-hide=\"loading\"><thead><th>{{\'GA.TOPSEARCHQUERY.TABLE.SEARCHTERM\' | translate}}</th>\n<th>{{\'GA.TOPSEARCHQUERY.TABLE.TOTALUNIQE\' | translate}}</th><th>{{\'GA.TOPSEARCHQUERY.TABLE.EXITSEARCH\' | translate}}\n</th></thead><tbody><tr ng-repeat=\"item in data4\"><td>{{item.label}}</td><td>{{item.hits}}</td><td>{{item.percentage}}%\n</td></tr></tbody></table><button class=\"md-button md-primary test-more-info\" ng-click=\"openSupportTicket()\">\n{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/ga/widgets/topsoldproduct/ga.topsoldproduct.html","<ms-widget layout=\"row\" flex=\"100\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"GA.TOPSOLDPRODUCT.TITLE\"></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div \nid=\"bouncePageHide\"></div><p>\nDe meest gekochte producten geven inzicht in het potentieel van bepaalde producten of productgroepen. Hier zijn vaak mogelijkheden voor marge verbetering. Denk aan alternatieve producten tonen bij deze producten die een hogere marge (bijvoorbeeld huismerken) hebben of een hogere opbrengst (upsell).\n</p><div><ex-loading ng-show=\"loading\"></ex-loading><table class=\"dataTable\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\" ng-hide=\"loading\"><thead><th>{{\'GA.TOPSOLDPRODUCT.TABLE.SEARCHTERM\' | translate}}</th>\n<th>{{\'GA.TOPSOLDPRODUCT.TABLE.TOTALUNIQUE\' | translate}}</th><th>{{\'GA.TOPSOLDPRODUCT.TABLE.EXITPOINT\' | translate}}\n</th></thead><tbody><tr ng-repeat=\"item in data6\"><td>{{item.label}}</td><td>{{item.pageCount}}</td><td>\n{{item.bounce}}%</td></tr></tbody></table></div><button class=\"md-button md-primary test-more-info\" \nng-click=\"openSupportTicket()\">{{\'GA.CONVERSIONBROWSER.BTN\' | translate}}</button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/settings/account/ghostMail/ghostMail.html","<div><h3>Testsuite mail ontvagen</h3><md-switch ng-model=\"vm.active\" aria-label=\"Testsuite mail ontvangen\" \nng-change=\"vm.setMail(vm.active)\"></md-switch></div>");
$templateCache.put("app/main/settings/account/startPage/startPage.html","<div><h3>Startpagina instellen</h3><md-input-container><md-select ng-model=\"vm.startPage\" \nplaceholder=\"Selecteer startpagina\"><md-option ng-value=\"opt.state\" ng-repeat=\"opt in vm.pages\">{{ opt.name }}\n</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/support/monthsummary/dashboard/table.closedtickets.html","<ms-widget><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div class=\"h2\" \ntranselate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.NAME\">Afgeronde support tickets</div><ex-loading \nng-hide=\"vm.tickets.loaded\"></ex-loading><div ng-show=\"vm.tickets.found && vm.tickets.loaded\"><div \nclass=\"download-summary\" ng-show=\"vm.supportSummary.data.summary_pdf\"><span \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.DOWNLOAD\" ng-click=\"vm.getLinks(vm.supportSummary.data)\"></span> \n<i class=\"material-icons support-ticket-ico\" ng-click=\"vm.getLinks(vm.supportSummary.data)\">picture_as_pdf</i></div>\n<table class=\"dataTable\" datatable=\"ng\" dt-options=\"vm.dtoptions\"><thead><tr><td \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.ID\">#ID</td><td \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.TITLE\">Titel</td><td \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.HOURS\">Uren</td><td \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.APPROVED\">Geaccordeerd</td><td \ntranslate=\"MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.ACTION\">Actie</td></tr></thead><tbody><tr \nng-repeat=\"ticket in vm.tickets.data\"><td>{{ticket.ticket_id}}</td><td>{{ticket.title}}</td><td>{{ticket.billed_time}}\n</td><td class=\"isApproved\"><md-icon class=\"\" ng-show=\"ticket.approved\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_check_black_24px.svg\"></md-icon></td><td><a \nng-show=\"ticket.zendesk_id != \'\'\" href=\"https://experius.zendesk.com/agent/tickets/{{ticket.zendesk_id}}\" \ntarget=\"_blank\">{{\'MONTHSUMMARYDASHBOARD.CLOSEDTICKET.LABELS.ZENDESK\' | translate}}</a></td></tr></tbody></table></div>\n<div><errormessage ng-show=\"!vm.tickets.found && vm.tickets.loaded\" \nheader=\"{{\'MONTHSUMMARYDASHBOARD.GENERAL.TITLE\' | translate}}\" \ntext=\"{{\'MONTHSUMMARYDASHBOARD.GENERAL.TEXT\' | translate}}\"></errormessage></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/monthsummary/dashboard/table.contract.html","<ms-widget><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div class=\"h2\" \nng-show=\"vm.contract.loaded && !vm.contract.found\" translate=\"MONTHSUMMARYDASHBOARD.CONTRACT.NAME\">Support Contract\n</div><div class=\"h3\" ng-show=\"vm.contract.found\" translate=\"MONTHSUMMARYDASHBOARD.CONTRACT.NAME1\">Contract</div>\n<ex-loading ng-hide=\"vm.contract.loaded\"></ex-loading><table class=\"dataTable\" \nng-show=\"vm.contract.loaded && vm.contract.found\"><thead><th translate=\"MONTHSUMMARYDASHBOARD.CONTRACT.LABELS.HOURS\">\nAantal uren per maand</th><th translate=\"MONTHSUMMARYDASHBOARD.CONTRACT.LABELS.PRICE\">Uurtarief</th></thead><tbody><tr>\n<td>{{vm.supportSummary.data.support_hours}}</td><td>&euro; {{vm.supportSummary.data.hour_price}},-</td></tr></tbody>\n</table><ng-include src=\"vm.notContract\" ng-show=\"vm.contract.loaded && !vm.contract.found\"></ng-include>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/support/summary/modal/createticket.html","<md-dialog class=\"create-ticket-modal\" layout-padding=\"18px\"><header layout=\"row\"><h1 flex=\"95\">\n{{\'SUPPORT.GENERAL.CREATETICKET\' | translate}}</h1><span class=\"close\" ng-click=\"vm.closeDialoog()\"><i \nclass=\"material-icons\">close</i></span></header><md-dialog-content layout=\"column\"><div class=\"message\"><h2 \nng-show=\"vm.success\">{{\'SUPPORT.GENERAL.TICKETMADE\' | translate}}</h2><h2 ng-show=\"vm.error\">\n{{\'SUPPORT.GENERAL.TICKETNOTMADE\' | translate}} <a \nhref=\"mailto:support@experius.nl?subject={{vm.subject}}&body={{vm.description}}\">support@experius.nl</a></h2><md-button\n class=\"md-secondary\" ng-show=\"vm.sending\" ng-click=\"vm.closeDialoog()\">Sluiten</md-button></div><div class=\"mail\" \nng-hide=\"vm.sending\"><div layout=\"column\"><md-input-container class=\"subject\"><input type=\"text\" ng-model=\"vm.subject\" \nplaceholder=\"{{\'SUPPORT.CREATETICKET.SUBJECT\' | translate}}\" required></md-input-container><md-input-container>\n<textarea ng-model=\"vm.description\" class=\"textbox\" placeholder=\"{{\'SUPPORT.CREATETICKET.DESCRIPTION\' | translate}}\">\n</textarea></md-input-container></div><div><md-button class=\"md-primary\" ng-click=\"vm.sendMail()\" \nng-disabled=\"vm.sendok\">{{\'SUPPORT.CREATETICKET.CREATE\' | translate}}</md-button></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/widgets/api/dateRangeSettings/widget-back-settings.html","<div class=\"widget-container\" layout=\"column\"><form name=\"dateRangeForm\" novalidate><div layout-padding=\"16px\">\n<md-radio-group ng-model=\"dataRangeSelected\" layout=\"row\" ng-change=\"updateRange(dataRangeSelected)\"><md-radio-button \nvalue=\"1w\">1 {{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.WEEK\' | translate}}</md-radio-button><md-radio-button value=\"1m\">\n1 {{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.MONTH\' | translate}}</md-radio-button><md-radio-button value=\"1y\">\n1 {{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.YEAR\' | translate}}</md-radio-button><md-radio-button value=\"cu\">\n{{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.CUSTOM\' | translate}}</md-radio-button></md-radio-group></div><div layout=\"row\" \nclass=\"widget-daterange\" layout-padding=\"16px\" ng-hide=\"hideRange\"><h4 layout-margin=\"7px\">\n{{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.FROM\' | translate}}:</h4><div><md-datepicker ng-model=\"minDate\" \nmd-placeholder=\"{{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.SETDATE\' | translate}}\" md-max-date=\"todayIs\" md-open-on-focus>\n</md-datepicker></div><h4 layout-margin=\"7px\">{{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.TILL\' | translate}}:</h4><div>\n<md-datepicker ng-model=\"maxDate\" md-placeholder=\"{{\'WIDGETS.SETTINGS.DATERANGE.ITEMS.SETDATE\' | translate}}\" \nmd-min-date=\"minDate\" md-max-date=\"todayIs\" ng-disabled=\"!maxDateVal\" md-open-on-focus></md-datepicker></div></div>\n</form></div>");
$templateCache.put("app/main/widgets/api/salesSummary/salesSummary.html","<div ng-show=\"summary.loaded\" id=\"salesSummaryInfo\"><h3>Omzet Samenvatting</h3><table><tr><td class=\"h3\">Totale omzet:\n</td><td class=\"h3\">{{summary.data.total_revenue}}</td></tr><tr><td class=\"h3\">Afgelopen 30 dagen:</td><td class=\"h3\">\n{{summary.data.last_30_days}}</td></tr><tr><td class=\"h3\">Vorige maand (jaar over jaar):</td><td class=\"h3\">\n{{summary.data.last_month}} ( <span ng-class=\"{\'green-fg\': summary.data.year_over_year > 0}\">\n{{summary.data.year_over_year}}%</span> )</td></tr></table></div>");
$templateCache.put("app/main/widgets/api/storeSettingsFilter/storesettings.html","<h3>{{\'WIDGETS.SETTINGS.STOREVIEW.TITLE\' | translate}}</h3><md-input-container><label>\n{{\'WIDGETS.SETTINGS.STOREVIEW.NAME\' | translate}}</label><md-select ng-model=\"selected\"><md-option \nng-value=\"opt.store_id\" ng-repeat=\"opt in stores\">{{opt.website}} - {{ opt.name }}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/widgets/api/settings/defaultheader/defaultheader.html","<div class=\"widget-default-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \nlayout-padding=\"8px\">{{name}} {{\'WIDGETS.GENERAL.SETTINGS\' | translate}}</div><div class=\"close-options\"><md-icon \nmd-font-icon=\"close\" ng-click=\"flipWidget()\">close</md-icon></div></div><div ng-transclude></div>");
$templateCache.put("app/main/widgets/api/settings/savesettings/savesettings.html","<div layout-margin=\"8px\"><md-button class=\"md-raised green-bg white-fg saveRangeSettings\" ng-click=\"saveSettings()\" \nng-disabled=\"disableBtn\" translate=\"WIDGETS.SETTINGS.SAVE\">Save options</md-button></div>");
$templateCache.put("app/main/widgets/modules/basic/text/text.html","<ms-widget layout=\"row\" flex=\"50\" draggable=\"true\"><ms-widget-front class=\"white-bg\" layout-padding=\"8px\"><div \nclass=\"widget-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Widget</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><div class=\"h1\">\n404</div><div class=\"h3\">Sorry, widget not found.</div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/magento_cacheflush/magento_cacheflush.html","<table class=\"table-magento-flush\"><tr><td>Flush cache</td><td><button ng-click=\"vm.flushCache()\" \nclass=\"btn-cache-flush\">Flush cache</button></td></tr><tr><td>Admin path</td><td><a target=\"_blank\" href=\"{{vm.url}}\">\n/{{vm.adminUrl}}</a></td></tr></table>");
$templateCache.put("app/main/widgets/modules/magento/magento_versions/magento_magento_versions_text.html","<table class=\"dataTable row-border magento-version\"><thead><th>\n{{\'WIDGETS.MODULES.MAGENTO.EDITION.LABELS.LATEST\' | translate}} Magento {{pack}} {{\'WIDGETS.MODULES.MAGENTO.EDITION.NAME\' | translate}}\n</th><th>Magento {{pack}} {{\'WIDGETS.MODULES.MAGENTO.EDITION.LABELS.ONSERVER\' | translate}}</th></thead><tbody><tr><td>\n<span>{{latest}}</span></td><td><span class=\"magento-version-number\" ng-class=\"{\'red-fg\': outdated}\">{{current}}</span>\n<md-button class=\"md-icon-button\" aria-label=\"warning\" ng-show=\"outdated\"><md-tooltip md-direction=\"top\" \nclass=\"module-tooltop\">{{\'WIDGETS.MODULES.MAGENTO.EDITION.MSG\' | translate}} Magento {{pack}}</md-tooltip><md-icon \nclass=\"magento-version_version-icon\" md-svg-src=\"assets/angular-material-assets/icons/ic_warning_black_24px.svg\">\n</md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/widgets/modules/magento/magento_versions/magento_versions.html","<ms-widget class=\"widget-builder no-settings\" layout=\"row\" draggable=\"true\" flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" layout-padding=\"16px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" \nlayout=\"row\" layout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\">\nMagento {{\'WIDGETS.MODULES.MAGENTO.EDITION.NAME\' | translate}}</div></div><magento-versions data=\"options\" \nng-show=\"!isLoading\"></magento-versions></ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/module_count/magento_module_count_text.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\" flex=\"100\" class=\"magento-module-count\"><div \nclass=\"magento-module-count-item\"><div class=\"h2\" translate=\"WIDGETS.MODULES.MAGENTO.MODULE_SUMMARY.LABELS.INSTALLED\">\nInstalled</div><md-icon class=\"magento-module-count-icon\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_view_module_black_48px.svg\"></md-icon><span \nclass=\"md-display-2 magento-module-count-counter exblue-fg\">{{lenModule.modules}}</span></div><div \nclass=\"magento-module-count-item\"><div class=\"h2\" translate=\"WIDGETS.MODULES.MAGENTO.MODULE_SUMMARY.LABELS.NEW\">\nNew version available</div><md-icon class=\"magento-module-count-icon\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_lightbulb_outline_black_24px.svg\"></md-icon><span \nng-class=\"{\'orange-fg\': lenModule.modulesOutdated > 0}\" class=\"md-display-2 magento-module-count-counter\">\n{{lenModule.modulesOutdated}}</span></div><div class=\"magento-module-count-item\"><div class=\"h2\" \ntranslate=\"WIDGETS.MODULES.MAGENTO.MODULE_SUMMARY.LABELS.SECURITY\">Security issues</div><md-icon \nclass=\"magento-module-count-icon\" md-svg-src=\"assets/angular-material-assets/icons/ic_security_black_24px.svg\">\n</md-icon><span ng-class=\"{\'red-fg\': lenModule.securityRisk > 0}\" class=\"md-display-2 magento-module-count-counter\">\n{{lenModule.securityRisk}}</span></div></div>");
$templateCache.put("app/main/widgets/modules/magento/module_count/module_count.html","<ms-widget class=\"widget-builder no-settings\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" layout-padding=\"16px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" \nlayout=\"row\" layout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\">\nMagento module {{\'WIDGETS.MODULES.MAGENTO.MODULE_SUMMARY.NAME\' | translate}}</div></div><magento-module-count \ndata=\"options\" ng-show=\"!isLoading\"></magento-module-count></ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/module_manual/magento_module_manual_table.html","<div class=\"magento-edition\"></div><h3>Module</h3><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"dtoptions\"><thead><th>{{\'MAGENTO.MODULE.MANUAL.CATEGORY\' | translate}}</th><th>\n{{\'MAGENTO.MODULE.MANUAL.ACTION\' | translate}}</th></thead><tbody><tr ng-repeat=\"item in list\"><td>{{item.category}}\n</td><td><a href=\"\" ng-click=\"OpenDialog(item.items, item.category)\">Bekijk modules</a></td></tr></tbody></table>");
$templateCache.put("app/main/widgets/modules/magento/module_manual/module_manual.html","");
$templateCache.put("app/main/widgets/modules/magento/module_outdated/magento_module_outdated_table.html","<table class=\"dataTable row-border hover magento-module_outdated\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-instance=\"dtInstanceCallback\"><thead><tr><th translate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.NAME\">\nModule name</th><th translate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.LIVE\">Version on the live server</th><th \ntranslate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.AVAILABLE\">Latest version available</th></tr></thead><tbody>\n<tr ng-repeat=\"item in outDated\"><td>{{item.name}}</td><td><span class=\"module-version-number\" \nng-class=\"{\'red-fg\': item.versionOutdated}\">{{item.installed}}</span><md-button class=\"md-icon-button\" \naria-label=\"warning\" ng-show=\"item.versionOutdated\"><md-tooltip md-direction=\"top\" class=\"module-tooltop\">\n{{\'WIDGETS.MODULES.MAGENTO.MODULE_VERSION.MSG.NEW\' | translate}}</md-tooltip><md-icon \nclass=\"magento-module_outdated-icon\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_lightbulb_outline_black_24px.svg\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"security\" ng-show=\"item.security_risk\"><md-tooltip md-direction=\"top\">\n{{\'WIDGETS.MODULES.MAGENTO.MODULE_VERSION.MSG.WARNING\' | translate}}</md-tooltip><md-icon \nclass=\"magento-module_outdated-icon\" md-svg-src=\"assets/angular-material-assets/icons/ic_security_black_24px.svg\">\n</md-icon></md-button></td><td>{{item.latest}}</td></tr></tbody></table>");
$templateCache.put("app/main/widgets/modules/magento/module_outdated/module_outdated.html","<ms-widget class=\"widget-builder\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"16px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\">\nMagento modules - {{\'WIDGETS.MODULES.MAGENTO.UPDATEAVALIABLE\' | translate}}</div></div><magento-module-outdated \ndata=\"options\" ng-show=\"!isLoading\"></magento-module-outdated></ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/module_versions/magento_module_versions_table.html","<table class=\"dataTable row-border hover magento-module_version\" datatable=\"ng\" dt-options=\"dtoptions\" \ndt-disable-deep-watchers=\"true\" dt-instance=\"dtInstanceCallback\"><thead><tr><th \ntranslate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.NAME\">Module name</th><th \ntranslate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.LIVE\">Version on the live server</th><th \ntranslate=\"WIDGETS.MODULES.MAGENTO.MODULE_VERSION.LABELS.AVAILABLE\">Latest version available</th></tr></thead><tbody>\n<tr ng-repeat=\"item in data\"><td>{{item.name}}</td><td><span class=\"module-version-number\" \nng-class=\"{\'red-fg\': item.versionOutdated}\">{{item.installed}}</span><md-button class=\"md-icon-button\" \naria-label=\"warning\" ng-show=\"item.versionOutdated\"><md-tooltip md-direction=\"top\" class=\"module-tooltop\">\n{{\'WIDGETS.MODULES.MAGENTO.MODULE_VERSION.MSG.NEW\' | translate}}</md-tooltip><md-icon \nclass=\"magento-module_version-icon\" \nmd-svg-src=\"assets/angular-material-assets/icons/ic_lightbulb_outline_black_24px.svg\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"security\" ng-show=\"item.security_risk\"><md-tooltip md-direction=\"top\">\n{{\'WIDGETS.MODULES.MAGENTO.MODULE_VERSION.MSG.WARNING\' | translate}}</md-tooltip><md-icon \nclass=\"magento-module_version-icon\" md-svg-src=\"assets/angular-material-assets/icons/ic_security_black_24px.svg\">\n</md-icon></md-button></td><td>{{item.latest}}</td></tr></tbody></table>");
$templateCache.put("app/main/widgets/modules/magento/module_versions/module_versions.html","<ms-widget class=\"widget-builder\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\">\nMagento {{\'WIDGETS.MODULES.MAGENTO.MODULE_VERSION.NAME\' | translate}}</div></div><magento-module-versions \ndata=\"options\" ng-show=\"!isLoading\"></magento-module-versions></ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/orders/magento_orders_chart.html","<div ng-if=\"noData\"><h3>Sorry!</h3><h4 translate=\"WIDGETS.GENERAL.NODATA\">No data found.</h4></div><div hide-sm \nhide-xs ng-if=\"!noData\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"values\" chart-labels=\"labels\" \nchart-series=\"series\" chart-colors=\"chartColors\" chart-options=\"chartOptions\"></canvas></div>\n<md-virtual-repeat-container class=\"vertical-container\" ng-if=\"!noData\" hide-xl hide-md hide-gt hide-lg><div \nmd-virtual-repeat=\"item in mobileData\" class=\"repeated-item\" layout=\"row\" flex layout-nowrap><div flex=\"100\"><h4>\n<strong>{{\'WIDGETS.GENERAL.DATE\' | translate}}:</strong> {{item.date}}</h4></div><div flex=\"100\" layout=\"row\"><div \nng-repeat=\"serie in item.series\" flex=\"30\">{{serie}}</div></div><div flex=\"100\" layout=\"row\"><div \nng-repeat=\"mvalue in item.values track by $index\" flex=\"30\">{{mvalue}}</div></div></div></md-virtual-repeat-container>");
$templateCache.put("app/main/widgets/modules/magento/orders/orders.html","<ms-widget class=\"widget-builder\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\" translate=\"WIDGETS.MODULES.MAGENTO.ORDERS\">\nBestellingen</div><div class=\"h5\" hide-xs hide-sm>{{\'WIDGETS.SETTINGS.STOREVIEW.NAME\' | translate}}: {{storeView}}\n</div><md-menu class=\"md-menu-container\"><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"flipWidget()\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" class=\"menu-item-options\" aria-label=\"Options for widget\">Options</md-button></md-menu-item>\n</md-menu-content></md-menu></div><magento-orders data=\"options\" ng-show=\"!isLoading\"></magento-orders>\n</ms-widget-front><ms-widget-back class=\"white-bg\" layout-padding=\"8px\"><md-content ng-clock><settings-default-header \nname=\"{{\'WIDGETS.MODULES.MAGENTO.ORDERS\' | translate}}\"><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab\n label=\"{{\'WIDGETS.SETTINGS.DATERANGE.NAME\' | translate}}\"><md-content class=\"md-padding\"><widget-range-settings \nsetup=\"setup\" name=\"{{\'WIDGETS.MODULES.MAGENTO.ORDERS\' | translate}}\"></widget-range-settings></md-content></md-tab>\n<md-tab label=\"{{\'WIDGETS.SETTINGS.STOREVIEW.NAME\' | translate}}\"><md-content class=\"md-padding\"><store-settings-filter\n setup=\"setup\"></store-settings-filter></md-content></md-tab></md-tabs></md-content><save-settings></save-settings>\n</settings-default-header></md-content></ms-widget-back></ms-widget>");
$templateCache.put("app/main/widgets/modules/magento/sales/magento_sales_chart.html","<div ng-if=\"noData\"><h3>Sorry!</h3><h4 translate=\"WIDGETS.GENERAL.NODATA\">No data found.</h4></div><div hide-sm \nhide-xs><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"values\" chart-labels=\"labels\" chart-series=\"series\" \nchart-options=\"chartOptions\" ng-if=\"!noData\" hide-sm hide-xs></canvas></div><md-virtual-repeat-container \nclass=\"vertical-container\" ng-if=\"!noData\" hide-xl hide-md hide-gt hide-lg><div md-virtual-repeat=\"item in mobileData\" \nclass=\"repeated-item\" layout=\"row\" flex layout-nowrap><div flex=\"100\"><h4><strong>\n{{\'WIDGETS.GENERAL.DATE\' | translate}}:</strong> {{item.label}}</h4></div><div flex=\"100\" layout=\"row\"><div flex=\"100\">\n&euro; {{item.value}}</div></div></div></md-virtual-repeat-container>");
$templateCache.put("app/main/widgets/modules/magento/sales/sales.html","<ms-widget class=\"widget-builder\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\" translate=\"WIDGETS.MODULES.MAGENTO.SALES\">\nOmzet</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"flipWidget()\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Options for widget\">Options</md-button></md-menu-item></md-menu-content></md-menu>\n</div><magento-sales data=\"options\" ng-show=\"!isLoading\"></magento-sales><ex-btw></ex-btw></ms-widget-front>\n<ms-widget-back class=\"white-bg\" layout-padding=\"8px\"><md-content ng-clock><settings-default-header \nname=\"{{\'WIDGETS.MODULES.MAGENTO.SALES\' | translate}}\"><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{\'WIDGETS.SETTINGS.DATERANGE.NAME\' | translate}}\"><md-content class=\"md-padding\"><widget-range-settings \nsetup=\"setup\" name=\"{{\'WIDGETS.MODULES.MAGENTO.SALES\' | translate}}\"></widget-range-settings></md-content></md-tab>\n</md-tabs><save-settings></save-settings></settings-default-header></md-content></ms-widget-back></ms-widget><ms-widget\n class=\"widget-builder no-settings\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading ng-show=\"isLoading\"></ex-loading><sales-summary></sales-summary><ex-btw></ex-btw>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/widgets/modules/website/environment_info/environment_info.html","<ms-widget class=\"widget-builder no-settings\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" layout-padding=\"16px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" \nlayout=\"row\" layout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\" \ntranslate=\"WIDGETS.MODULES.WEBSITE.ENVIROMMENT.NAME\">Ontwikkelstraat</div></div><magento-cache-flush>\n</magento-cache-flush><website-env-info data=\"options\" ng-show=\"!isLoading\"></website-env-info></ms-widget-front>\n</ms-widget>");
$templateCache.put("app/main/widgets/modules/website/environment_info/website_environment_info_table.html","<table class=\"dataTable row-border hover magento-module_outdated\" datatable=\"ng\" dt-options=\"dtoptions\"><thead><tr><th \ntranslate=\"WIDGETS.MODULES.WEBSITE.ENVIROMMENT.LABELS.NAME\">Name</th><th>URL</th></tr></thead><tbody><tr \nng-repeat=\"item in data\" ng-if=\"item.is_valid\"><td>{{item.name}}</td><td><a href=\"{{item.url}}\" target=\"_blank\">\n{{item.url}}</a></td></tr></tbody></table>");
$templateCache.put("app/main/widgets/modules/website/responsetime/responsetime.html","<ms-widget class=\"widget-builder\" layout=\"row\" draggable=\"false\" flippable=\"true\"><ms-widget-front class=\"white-bg\" \nlayout-padding=\"8px\"><ex-loading ng-show=\"isLoading\"></ex-loading><div class=\"widget-header\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"!isLoading\"><div class=\"h3\" \ntranslate=\"WIDGETS.MODULES.WEBSITE.RESPONSETIME\">Response tijd</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"flipWidget()\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Options for widget\">Options\n</md-button></md-menu-item></md-menu-content></md-menu></div><website-responsetime data=\"options\" ng-show=\"!isLoading\">\n</website-responsetime></ms-widget-front><ms-widget-back class=\"white-bg\" layout-padding=\"8px\"><md-content ng-clock>\n<settings-default-header name=\"{{\'WIDGETS.MODULES.WEBSITE.RESPONSETIME\' | translate}}\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"{{\'WIDGETS.SETTINGS.DATERANGE.NAME\' | translate}}\"><md-content class=\"md-padding\">\n<widget-range-settings setup=\"setup\"></widget-range-settings></md-content></md-tab></md-tabs><save-settings>\n</save-settings></settings-default-header></md-content></ms-widget-back></ms-widget>");
$templateCache.put("app/main/widgets/modules/website/responsetime/website_responsetime_line_chart.html","<div ng-if=\"noData\"><h3>Sorry!</h3><h4 translate=\"WIDGETS.GENERAL.NODATA\">No data found.</h4></div><div hide-sm \nhide-xs><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"values\" chart-labels=\"labels\" \nchart-dataset-override=\"datasetOverride\" chart-series=\"series\" chart-options=\"chartOptions\" ng-if=\"!noData\"></canvas>\n</div><md-virtual-repeat-container class=\"vertical-container\" ng-if=\"!noData\" hide-xl hide-md hide-gt hide-lg><div \nmd-virtual-repeat=\"item in mobileData\" class=\"repeated-item\" layout=\"row\" flex layout-nowrap><div flex=\"100\"><h4>\n<strong>{{\'WIDGETS.GENERAL.DATE\' | translate}}:</strong> {{item.label}}</h4></div><div flex=\"100\" layout=\"row\"><div \nflex=\"100\">{{item.value}}</div></div></div></md-virtual-repeat-container>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/widgets/modules/magento/module_manual/modal/view_modules.html","<md-dialog layout-padding=\"15px\" class=\"module-manual-dialog md-dialog-fullscreen\"><header><h2>Handleiding per module\n</h2><span class=\"close\" ng-click=\"vm.closeDialoog()\"><i class=\"material-icons\">close</i></span></header><div><md-tabs \nmd-dynamic-height md-border-bottom><md-tab ng-repeat=\"item in vm.data\" label=\"{{item.label}}\"><ex-loading \nng-show=\"vm.loading\"></ex-loading><md-content ng-show=\"!vm.loading\" class=\"md-padding\"><header><div \nng-hide=\"vm.documentationUrlIsset(item.documentation_url)\">Er is helaas geen handleiding beschikbaar.</div><div \nng-show=\"vm.documentationUrlIsset(item.documentation_url)\"><a class=\"show-manual\" \nng-href=\"https://experius.atlassian.net/wiki{{item.link}}\" target=\"_blank\">\n{{\'MAGENTO.MODULE.MANUAL.SHOW\' | translate}} <i class=\"material-icons\">library_books</i></a></div></header><article \nng-show=\"vm.documentationUrlIsset(item.documentation_url)\" ng-bind-html=\"vm.renderHtml(item.html)\"></article>\n</md-content></md-tab></md-tabs></div></md-dialog>");}]);